<app-header [transparent]="transparent" [homePage]="true" />
<!-- <ngx-spinner >
    <img src="../assets/img/loaderrr.gif" alt="" style="width: auto; height: auto;">
</ngx-spinner> -->

<div class="home">
  <!-- Home Slider Section -->
  <div class="home_slider">
    <div
      id="carouselCaptions"
      class="home_slider_carousel carousel slide"
      data-bs-ride="carousel"
    >
      <div class="home_slider_carousel_indicators carousel-indicators">
        <div class="home_slider_carousel_indicators_items">
          <button
            class="home_slider_carousel_indicators_items_btn active"
            type="button"
            data-bs-target="#carouselCaptions"
            data-bs-slide-to="0"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            class="home_slider_carousel_indicators_items_btn"
            type="button"
            data-bs-target="#carouselCaptions"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
          <button
            class="home_slider_carousel_indicators_items_btn"
            type="button"
            data-bs-target="#carouselCaptions"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          ></button>
          <button
            class="home_slider_carousel_indicators_items_btn"
            type="button"
            data-bs-target="#carouselCaptions"
            data-bs-slide-to="3"
            aria-label="Slide 4"
          ></button>
        </div>
      </div>
      <div class="home_slider_carousel_inner carousel-inner">
        <div class="carousel-item active" data-bs-interval="2000">
          <div class="home_slider_carousel_inner_item">
            <img
              src="../../../assets/img/carousel_img/carousel_01.webp"
              class="home_slider_carousel_inner_item_img w-100"
              alt="image"
            />
            <img
              src="../../../assets/img/carousel_img/carousel_mobile_01.webp"
              class="home_slider_carousel_inner_item_phoneimg w-100"
              alt="image"
            />
            <div class="home_slider_carousel_inner_item_top carousel-caption">
              <p class="text_white_3">Agrochemical Discovery Intelligence</p>
              <span class="text_white_4_res"
                >AgroPat Ultimate Discovery Suite Aids in Advancing the
                Development of Discovery Agrochemicals and in Identifying New
                Opportunities Within the Field.</span
              >
              <div class="home_slider_carousel_inner_item_top_button">
                <button
                  type="button"
                  class="rounded-pill text_blue_4 button_white_1"
                >
                  <span>View More</span>
                  <img
                    class="home_slider_carousel_inner_item_top_button_icon button_white_1_text_icon"
                    src="../../../assets/icons/video_icon.png"
                  />
                </button>
              </div>
              <div class="home_slider_carousel_inner_item_top_img">
                <div class="home_slider_carousel_inner_item_top_img_body">
                  <div class="home_slider_carousel_inner_item_top_img_body_box">
                    <img
                      width="30%"
                      src="../../../assets/icons/leaves_icon.png"
                      alt="image"
                    />
                    <div class="text_white_21">AgroPat</div>
                  </div>
                </div>
              </div>
              <div class="home_slider_carousel_inner_item_top_list p-y-11">
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Agrochemical Innovation Intelligence
                </div>
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  New or Existing Chemical Class Development Updates
                </div>
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Early Identification of Advanced Agrochemical Candidates
                </div>
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  New Mode of Action (MoA) Candidates
                </div>
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  New or Existing Chemical Class Development Updates
                </div>
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Patent Watch for Active Ingredient and Processes
                </div>
              </div>
            </div>
            <div
              class="home_slider_carousel_inner_item_button carousel-caption"
            >
              <button
                type="button"
                class="rounded-pill text_blue_4 button_white_1"
                data-bs-toggle="modal"
                data-bs-target="#VideoModel"
                data-bs-dismiss="modal"
                (click)="toggleIntroVideoHome()"
              >
                <span>View More</span>
                <img
                  class="home_slider_carousel_inner_item_button_icon button_white_1_text_icon"
                  src="../../../assets/icons/video_icon.png"
                />
              </button>
            </div>
            <div
              class="home_slider_carousel_inner_item_layout carousel-caption"
            >
              <div class="home_slider_carousel_inner_item_layout_content">
                <div class="home_slider_carousel_inner_item_layout_content_box">
                  <div
                    class="home_slider_carousel_inner_item_layout_content_box_left"
                  >
                    <div
                      class="home_slider_carousel_inner_item_layout_content_box_left_top1"
                    >
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_left_top1_box slider_box transparent_hexagon"
                      >
                        <div class="slider_box_left">
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 50 50"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M45.5704 38.0234C44.1876 37.1797 42.172 37.2813 40.4454 38.2734C38.8595 39.1875 37.8126 40.6797 37.672 42.1719C37.6173 42.2266 37.5548 42.2812 37.5001 42.3359V39.6328C38.6876 38.7578 39.4298 37.125 39.4298 35.3281C39.4298 33.3359 38.5157 31.5391 37.0938 30.7578C36.8595 30.625 36.5782 30.625 36.3438 30.7578C34.922 31.5391 34.0079 33.3359 34.0079 35.3281C34.0079 37.125 34.7579 38.75 35.9376 39.6328V42.3125C35.8751 42.2578 35.8048 42.2031 35.7345 42.1484C35.5391 40.6641 34.4376 39.2031 32.8126 38.3516C31.047 37.4219 29.0313 37.4063 27.6798 38.2969C27.4532 38.4453 27.3204 38.6953 27.3282 38.9609C27.3595 40.5781 28.5235 42.2266 30.297 43.1563C31.1954 43.625 32.1641 43.8672 33.0782 43.8672C33.7423 43.8672 34.3673 43.7422 34.922 43.4922C35.4063 43.8906 35.7579 44.2891 35.9454 44.6641V46.8672C35.9454 47.2969 36.297 47.6484 36.7266 47.6484C37.1563 47.6484 37.5079 47.2969 37.5079 46.8672V44.7031C37.797 44.3203 38.211 43.8281 38.5548 43.4844C39.0626 43.6875 39.6173 43.7891 40.2032 43.7891C41.172 43.7891 42.2032 43.5156 43.1485 42.9688C44.8751 41.9766 45.9766 40.2891 45.9532 38.6641C45.9532 38.3984 45.8048 38.1484 45.5782 38.0078L45.5704 38.0234Z"
                              fill="#FFCD04"
                            />
                            <path
                              d="M20.6563 38.0234C19.2735 37.1797 17.2579 37.2813 15.5313 38.2734C13.9454 39.1875 12.8985 40.6797 12.7579 42.1719C12.7032 42.2266 12.6407 42.2812 12.586 42.3359V39.6328C13.7735 38.7578 14.5157 37.125 14.5157 35.3281C14.5157 33.3359 13.6016 31.5391 12.1798 30.7578C11.9454 30.625 11.6641 30.625 11.4298 30.7578C10.0079 31.5391 9.09383 33.3359 9.09383 35.3281C9.09383 37.125 9.84383 38.75 11.0235 39.6328V42.3125C10.961 42.2578 10.8907 42.2031 10.8204 42.1484C10.6251 40.6641 9.52352 39.2031 7.89852 38.3516C6.13289 37.4219 4.11727 37.4063 2.76571 38.2969C2.53914 38.4453 2.40633 38.6953 2.41414 38.9609C2.44539 40.5781 3.60946 42.2266 5.38289 43.1563C6.28133 43.625 7.25008 43.8672 8.16414 43.8672C8.82821 43.8672 9.45321 43.7422 10.0079 43.4922C10.4923 43.8906 10.8438 44.2891 11.0313 44.6641V46.8672C11.0313 47.2969 11.3829 47.6484 11.8126 47.6484C12.2423 47.6484 12.5938 47.2969 12.5938 46.8672V44.7031C12.8829 44.3203 13.297 43.8281 13.6407 43.4844C14.1485 43.6875 14.7032 43.7891 15.2891 43.7891C16.2579 43.7891 17.2891 43.5156 18.2345 42.9688C19.961 41.9766 21.0626 40.2891 21.0391 38.6641C21.0391 38.3984 20.8907 38.1484 20.6641 38.0078L20.6563 38.0234Z"
                              fill="#FFCD04"
                            />
                            <path
                              d="M32.25 6.77344C32.125 6.02344 31.4688 5.46875 30.7109 5.46875H19.2969C18.5313 5.46875 17.8828 6.02344 17.7578 6.77344L17.4531 8.59375H32.5547L32.25 6.77344Z"
                              fill="white"
                            />
                            <path
                              d="M32.0312 21.5547V19.5312H34.4531C34.8437 19.5312 35.1562 19.2188 35.1562 18.8281V10.8594C35.1562 10.4687 34.8437 10.1562 34.4531 10.1562H15.5469C15.1562 10.1562 14.8438 10.4687 14.8438 10.8594V18.8281C14.8438 19.2188 15.1562 19.5312 15.5469 19.5312H17.9688V21.5547C17.9688 22.1641 18.4609 22.6562 19.0703 22.6562H23.4375V25.0859C23.4375 25.4688 23.75 25.7812 24.1328 25.7812H25.8594C26.2422 25.7812 26.5547 25.4688 26.5547 25.0859V22.6562H30.9219C31.5313 22.6562 32.0234 22.1641 32.0234 21.5547H32.0312ZM17.9688 13.2812H32.0312V16.4062H17.9688V13.2812Z"
                              fill="white"
                            />
                            <path
                              d="M25 28.125C24.5703 28.125 24.2188 28.4766 24.2188 28.9062V30.4688C24.2188 30.8984 24.5703 31.25 25 31.25C25.4297 31.25 25.7812 30.8984 25.7812 30.4688V28.9062C25.7812 28.4766 25.4297 28.125 25 28.125Z"
                              fill="white"
                            />
                            <path
                              d="M25 32.8125C24.5703 32.8125 24.2188 33.1641 24.2188 33.5938V35.1562C24.2188 35.5859 24.5703 35.9375 25 35.9375C25.4297 35.9375 25.7812 35.5859 25.7812 35.1562V33.5938C25.7812 33.1641 25.4297 32.8125 25 32.8125Z"
                              fill="white"
                            />
                            <path
                              d="M28.5624 30.1327C28.7187 30.1327 28.8749 30.0859 29.0078 29.9921C29.3593 29.7499 29.4531 29.2577 29.2031 28.9062L28.3124 27.6249C28.0703 27.2734 27.5781 27.1796 27.2265 27.4296C26.8749 27.6718 26.7812 28.164 27.0312 28.5156L27.9218 29.7968C28.0703 30.0156 28.3203 30.1327 28.5624 30.1327Z"
                              fill="white"
                            />
                            <path
                              d="M29.8984 31.2812C29.5468 31.5312 29.4531 32.0156 29.7031 32.3671L30.5937 33.6484C30.7421 33.8671 30.9921 33.9843 31.2343 33.9843C31.3906 33.9843 31.5468 33.9374 31.6796 33.8437C32.0312 33.5937 32.1249 33.1093 31.8749 32.7577L30.9843 31.4765C30.7343 31.1249 30.2499 31.039 29.8984 31.2812Z"
                              fill="white"
                            />
                            <path
                              d="M21.6874 27.6249L20.7968 28.9062C20.5468 29.2577 20.6406 29.7499 20.9921 29.9921C21.1249 30.0859 21.2812 30.1327 21.4374 30.1327C21.6874 30.1327 21.9296 30.0156 22.0781 29.7968L22.9687 28.5156C23.2187 28.164 23.1249 27.6718 22.7734 27.4296C22.4218 27.1796 21.9296 27.2734 21.6874 27.6249Z"
                              fill="white"
                            />
                            <path
                              d="M18.7577 33.9843C19.0077 33.9843 19.2499 33.8671 19.3984 33.6484L20.289 32.3671C20.539 32.0156 20.4452 31.5234 20.0937 31.2812C19.7421 31.039 19.2499 31.1249 19.0077 31.4765L18.1171 32.7577C17.8671 33.1093 17.9609 33.6015 18.3124 33.8437C18.4452 33.9374 18.6015 33.9843 18.7577 33.9843Z"
                              fill="white"
                            />
                            <path
                              d="M46.1172 12.5H43.75V8.40625C43.75 8.07812 43.4844 7.8125 43.1563 7.8125H42.1875V3.90625H45.3125C45.7422 3.90625 46.0938 3.55469 46.0938 3.125C46.0938 2.69531 45.7422 2.34375 45.3125 2.34375H37.5C37.0703 2.34375 36.7188 2.69531 36.7188 3.125C36.7188 3.55469 37.0703 3.90625 37.5 3.90625H40.625V7.8125H39.6562C39.3281 7.8125 39.0625 8.07812 39.0625 8.40625V12.5H36.7188V17.1875H46.1172C46.5391 17.1875 46.875 16.8516 46.875 16.4297V13.2578C46.875 12.8359 46.5391 12.5 46.1172 12.5Z"
                              fill="white"
                            />
                            <path
                              d="M3.88281 17.1875H13.2812V12.5H10.9375V8.40625C10.9375 8.07812 10.6719 7.8125 10.3438 7.8125H9.375V3.90625H12.5C12.9297 3.90625 13.2812 3.55469 13.2812 3.125C13.2812 2.69531 12.9297 2.34375 12.5 2.34375H4.6875C4.25781 2.34375 3.90625 2.69531 3.90625 3.125C3.90625 3.55469 4.25781 3.90625 4.6875 3.90625H7.8125V7.8125H6.84375C6.51563 7.8125 6.25 8.07812 6.25 8.40625V12.5H3.88281C3.46094 12.5 3.125 12.8359 3.125 13.2578V16.4297C3.125 16.8516 3.46094 17.1875 3.88281 17.1875Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <div class="slider_box_right">
                          <div class="slider_box_right_content">
                            <span class="text_white_7"
                              >Agrochemical Innovation Intelligence</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="home_slider_carousel_inner_item_layout_content_box_left_center1"
                    >
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_left_center1_box slider_box transparent_hexagon"
                      >
                        <div class="slider_box_left">
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 50 50"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_2002_1775)">
                              <path
                                d="M44.0001 23.5771C44.0001 24.2726 43.4401 24.837 42.7482 24.837H41.3444V38.8107C41.3444 43.3261 37.694 46.9999 33.2073 46.9999C29.107 46.9999 25.7045 43.9309 25.1503 39.9555H30.0509C30.7428 39.9555 31.3028 39.3911 31.3028 38.6957C31.3028 37.9994 30.7428 37.4358 30.0509 37.4358H25.0702V34.916H30.0509C30.7428 34.916 31.3028 34.3516 31.3028 33.6562C31.3028 32.9599 30.7428 32.3963 30.0509 32.3963H25.0702V29.8766H30.0509C30.7428 29.8766 31.3028 29.3121 31.3028 28.6167C31.3028 27.9204 30.7428 27.3569 30.0509 27.3569H25.0702V24.8371H23.6664C22.9746 24.8371 22.4146 24.2726 22.4146 23.5772C22.4146 22.8809 22.9746 22.3174 23.6664 22.3174H42.7482C43.4401 22.3174 44.0001 22.8808 44.0001 23.5771Z"
                                fill="white"
                              />
                              <path
                                d="M21.4722 15.6752L19.5953 18.9467C19.3716 19.3364 18.9585 19.5766 18.5112 19.5766H15.4708L14.3324 21.5093L15.4808 23.5116H18.0964C18.7882 23.5116 19.3482 24.0761 19.3482 24.7715C19.3482 25.4678 18.7882 26.0313 18.0964 26.0313H15.4808L14.3274 28.0429L15.7086 30.451C16.0542 31.0541 15.8489 31.8243 15.2505 32.172C14.6546 32.5201 13.8873 32.3161 13.5404 31.7109L12.1592 29.3029H9.128C8.6815 29.3029 8.26755 29.0627 8.04388 28.6729L6.16775 25.4014C5.94408 25.0117 5.94408 24.5312 6.16775 24.1415L8.04388 20.8708C8.26755 20.4812 8.6815 20.2409 9.128 20.2409H12.1684L13.3076 18.3082L11.7978 15.6751C11.5741 15.2853 11.5741 14.8049 11.7978 14.4152L13.3126 11.7745L11.8671 9.2548H8.79917C8.10731 9.2548 7.54731 8.69035 7.54731 7.99496C7.54731 7.29957 8.10731 6.73511 8.79917 6.73511H12.5898C13.0372 6.73511 13.4503 6.9753 13.6739 7.36507L15.4808 10.5147H18.5112C18.9585 10.5147 19.3716 10.7549 19.5953 11.1447L21.4722 14.4154C21.6959 14.805 21.6959 15.2855 21.4722 15.6752Z"
                                fill="white"
                              />
                              <path
                                d="M41.7983 5.15264C41.7098 4.62354 41.2975 4.20857 40.7717 4.11955C40.5865 4.08847 36.2007 3.37713 33.7696 5.82367C33.5652 6.02943 33.3782 6.25367 33.2071 6.49555C33.036 6.25367 32.8491 6.02943 32.6446 5.82367C30.2135 3.37713 25.8278 4.08856 25.6417 4.11963C25.1159 4.20865 24.7044 4.62354 24.616 5.15272C24.5843 5.33917 23.8774 9.75196 26.3093 12.1985C27.7459 13.6442 29.9243 14.0672 31.9552 14.0429V19.7977H34.459V14.0429C36.4897 14.0675 38.6686 13.6439 40.1049 12.1985C42.536 9.75187 41.83 5.33908 41.7983 5.15264Z"
                                fill="#FFCD04"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_2002_1775">
                                <rect
                                  width="38"
                                  height="43"
                                  fill="white"
                                  transform="translate(6 4)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <div class="slider_box_right">
                          <div class="slider_box_right_content">
                            <span class="text_white_7">
                              New or Existing Chemical Class Development
                              Updates</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="home_slider_carousel_inner_item_layout_content_box_left_bottom1"
                    >
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_left_bottom1_box slider_box transparent_hexagon"
                      >
                        <div class="slider_box_left">
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 50 50"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_2002_1744)">
                              <path
                                d="M23.1547 19.7506C23.2053 21.5205 21.7753 22.9771 20.0082 22.9771H16.4107C16.1127 22.9771 15.8711 22.7365 15.8711 22.4396V17.2438C15.8711 16.9469 16.1127 16.7063 16.4107 16.7063H19.9475C21.6608 16.7063 23.106 18.0448 23.1547 19.7506Z"
                                fill="white"
                              />
                              <path
                                d="M26.6888 4.73358C26.4095 3.25653 24.7245 2.53019 23.4619 3.32981C22.2427 4.10273 20.8045 3.32596 19.3626 3.74189C16.3425 4.61318 15.2075 7.07984 15.847 9.39547C14.7273 10.3186 13.8545 11.5708 13.3836 13.0478C13.1158 12.6558 12.7755 12.2705 12.3862 11.9351C12.8106 10.192 11.9124 8.38918 9.67102 7.74894C8.5871 7.44131 7.5594 7.98409 6.75078 7.4766C5.71543 6.82784 4.34255 7.42303 4.11474 8.61699C3.31745 12.7935 6.83586 15.3742 9.69998 14.6544C10.1918 14.5308 10.2536 13.8628 9.79576 13.6455C9.774 13.6352 9.7525 13.6252 9.73128 13.6157C9.38448 13.4589 9.24571 13.0831 9.32117 12.7942C9.43404 12.3623 9.89676 12.1188 10.306 12.2997C12.0709 13.0796 13.046 14.859 12.9933 16.477V16.7063H7.47836C5.76507 16.7063 4.31979 18.0447 4.27033 19.7504C4.22014 21.5212 5.64977 22.9771 7.41721 22.9771H12.2738C12.4725 22.9771 12.6524 23.0578 12.7828 23.1868C13.242 23.6474 12.903 24.4105 12.2462 24.4105H7.23733C6.93928 24.4105 6.69772 24.6511 6.69772 24.948V30.2629C6.69772 30.6741 7.1411 30.9312 7.50175 30.7314C9.64188 29.549 10.1544 28.3011 12.9933 28.061C13.3416 28.0312 13.5989 28.0201 13.879 28.0275C14.1827 28.0356 14.4323 27.7901 14.4323 27.4874C14.4323 25.6651 14.4465 17.0334 14.4323 15.617C14.4056 12.9566 15.9838 10.3841 18.6908 9.39278L18.6944 9.39189C19.0982 9.24766 19.5389 9.48505 19.6369 9.90251C19.7194 10.2605 19.5236 10.6132 19.1899 10.7365C18.7507 10.8989 18.3409 11.1154 17.9675 11.3829C17.6527 11.6083 17.6747 12.0805 18.0061 12.2812C21.7531 14.55 27.8968 11.1396 26.6888 4.73358Z"
                                fill="white"
                              />
                              <path
                                d="M19.2889 32.0196C16.7582 30.6411 16.676 29.4569 13.7128 29.4575C11.73 29.458 11.0543 30.0094 10.0326 30.7699C9.54946 31.1301 7.92926 32.2429 7.0504 32.5637C6.83805 32.6412 6.69775 32.8424 6.69775 33.0676V38.9234C6.69775 42.7703 9.78177 45.9624 13.6437 45.9996C17.5435 46.0372 20.7279 42.8883 20.7279 39.0125V33.0496C20.7279 32.83 20.5944 32.6326 20.3895 32.5512C20.0038 32.3978 19.4611 32.113 19.2889 32.0196ZM14.8226 32.8617L15.0924 32.5929C15.3739 32.3134 15.829 32.3134 16.1105 32.5929C16.3911 32.8733 16.3911 33.3266 16.1105 33.607L15.8407 33.8757C15.5593 34.1542 15.1062 34.1563 14.8226 33.8757C14.542 33.5954 14.542 33.1421 14.8226 32.8617ZM13.2937 36.1762L13.5635 35.9075C13.845 35.628 14.3001 35.628 14.5816 35.9075C14.8622 36.1879 14.8622 36.6412 14.5816 36.9216L14.3118 37.1903C14.0304 37.4687 13.5773 37.4709 13.2937 37.1903C13.0131 36.9099 13.0131 36.4566 13.2937 36.1762ZM11.2252 32.8617L11.495 32.5929C11.7765 32.3134 12.2316 32.3134 12.5131 32.5929C12.7937 32.8733 12.7937 33.3266 12.5131 33.607L12.2432 33.8757C11.9618 34.1542 11.5087 34.1563 11.2252 33.8757C10.9446 33.5954 10.9446 33.1421 11.2252 32.8617Z"
                                fill="white"
                              />
                              <path
                                d="M40.5138 36.9519H29.9912C29.7187 36.9519 29.4696 36.7986 29.3477 36.5558L27.7478 33.3686H23.8755C23.4782 33.3686 23.156 33.0477 23.156 32.652C23.156 32.2562 23.4782 31.9353 23.8755 31.9353H28.1925C28.465 31.9353 28.7141 32.0887 28.836 32.3314L30.4358 35.5186H40.5138C40.9111 35.5186 41.2333 35.8395 41.2333 36.2353C41.2333 36.6311 40.9111 36.9519 40.5138 36.9519Z"
                                fill="white"
                              />
                              <path
                                d="M37.9086 41.4311H37.8215C37.4242 41.4311 37.1021 41.1102 37.1021 40.7145C37.1021 40.3187 37.4242 39.9978 37.8215 39.9978H37.9086C38.3059 39.9978 38.6281 40.3187 38.6281 40.7145C38.6281 41.1102 38.3059 41.4311 37.9086 41.4311Z"
                                fill="white"
                              />
                              <path
                                d="M34.8507 41.4311H29.9912C29.5939 41.4311 29.2717 41.1102 29.2717 40.7145C29.2717 40.3187 29.5939 39.9978 29.9912 39.9978H34.8507C35.248 39.9978 35.5702 40.3187 35.5702 40.7145C35.5702 41.1102 35.248 41.4311 34.8507 41.4311Z"
                                fill="white"
                              />
                              <path
                                d="M40.5138 46H34.0674C33.6701 46 33.3479 45.6791 33.3479 45.2833C33.3479 44.8875 33.6701 44.5667 34.0674 44.5667H40.5138C40.9111 44.5667 41.2333 44.8875 41.2333 45.2833C41.2333 45.6791 40.9111 46 40.5138 46Z"
                                fill="white"
                              />
                              <path
                                d="M30.8123 46H29.9912C29.5939 46 29.2717 45.6791 29.2717 45.2833C29.2717 44.8875 29.5939 44.5667 29.9912 44.5667H30.8123C31.2096 44.5667 31.5317 44.8875 31.5317 45.2833C31.5317 45.6791 31.2096 46 30.8123 46Z"
                                fill="white"
                              />
                              <path
                                d="M43.8416 3.89607H36.3768C35.187 3.89607 34.2184 4.86088 34.2184 6.04606V12.2273H31.7001V5.15023C31.7001 4.04586 30.8451 3.00024 29.4517 3.00024C29.0542 3.00024 28.7322 3.32095 28.7322 3.71691C28.7322 4.11286 29.0542 4.43357 29.4517 4.43357H29.5417C29.9383 4.43357 30.2612 4.75517 30.2612 5.15023V20.8272C30.2612 21.2223 29.9383 21.5439 29.5417 21.5439H25.8543C25.4567 21.5439 25.1348 21.8646 25.1348 22.2606C25.1348 22.6565 25.4567 22.9772 25.8543 22.9772H29.5417C30.7315 22.9772 31.7001 22.0124 31.7001 20.8272V13.6606H34.2184V19.8418C34.2184 21.027 35.187 21.9918 36.3768 21.9918H43.8416C45.0314 21.9918 46.0001 21.027 46.0001 19.8418V6.04606C46.0001 4.86088 45.0314 3.89607 43.8416 3.89607ZM40.424 17.871H38.8051C38.4078 17.871 38.0856 17.5501 38.0856 17.1543C38.0856 16.7586 38.4078 16.4377 38.8051 16.4377H40.424C40.8213 16.4377 41.1435 16.7586 41.1435 17.1543C41.1435 17.5501 40.8213 17.871 40.424 17.871ZM41.5032 13.6606H38.8051C38.4078 13.6606 38.0856 13.3397 38.0856 12.9439C38.0856 12.5482 38.4078 12.2273 38.8051 12.2273H41.5032C41.9006 12.2273 42.2227 12.5482 42.2227 12.9439C42.2227 13.3397 41.9006 13.6606 41.5032 13.6606ZM41.5032 9.45021H38.8051C38.4078 9.45021 38.0856 9.12933 38.0856 8.73355C38.0856 8.33777 38.4078 8.01689 38.8051 8.01689H41.5032C41.9006 8.01689 42.2227 8.33777 42.2227 8.73355C42.2227 9.12933 41.9006 9.45021 41.5032 9.45021Z"
                                fill="#FFCD04"
                              />
                              <path
                                d="M20.7278 24.948V29.9526C20.7278 30.5067 20.1217 30.8538 19.6436 30.5705C18.2277 29.7317 17.5615 28.9082 16.2259 28.4281C16.0129 28.3515 15.8713 28.1492 15.8713 27.9237V24.9481C15.8713 24.6513 16.1129 24.4106 16.411 24.4106H20.1883C20.4863 24.4105 20.7278 24.6511 20.7278 24.948Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_2002_1744">
                                <rect
                                  width="42"
                                  height="43"
                                  fill="white"
                                  transform="translate(4 3)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <div class="slider_box_right">
                          <div class="slider_box_right_content">
                            <span class="text_white_7"
                              >Early Identification of Advanced Agrochemical
                              Candidates</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="home_slider_carousel_inner_item_layout_content_box_center"
                  >
                    <div
                      class="home_slider_carousel_inner_item_layout_content_box_center_body"
                    >
                      <img
                        width="20%"
                        src="../../../assets/icons/leaves_icon.png"
                        alt="image"
                      />
                      <div class="text_white_20">AgroPat</div>
                    </div>
                  </div>
                  <div
                    class="home_slider_carousel_inner_item_layout_content_box_right"
                  >
                    <div
                      class="home_slider_carousel_inner_item_layout_content_box_right"
                    >
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_right_top1"
                      >
                        <div
                          class="home_slider_carousel_inner_item_layout_content_box_right_top1_box slider_box transparent_hexagon"
                        >
                          <div class="slider_box_left">
                            <svg
                              width="50"
                              height="50"
                              viewBox="0 0 50 50"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_2002_1725)">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M8.02879 4H31.7796C34.7427 4 37.153 6.38771 37.153 9.32294V25.2955C36.3966 25.0929 35.554 25.2853 34.9612 25.8726L34.3656 26.4625L33.5517 26.2463C32.3527 25.9279 31.1046 26.6418 30.7831 27.8295L30.5648 28.6361L29.7505 28.8524C28.5419 29.1734 27.8301 30.4045 28.1523 31.595L28.3706 32.4012L27.775 32.9911C26.8934 33.8644 26.8934 35.2845 27.775 36.1579L28.3706 36.7478L28.1523 37.554C27.9998 38.1174 28.0748 38.7141 28.3609 39.2228L27.7651 40.2451H11.465C11.1369 40.2451 10.8715 39.9823 10.8715 39.6572L10.8719 9.04879C10.8722 6.94872 10.417 4.23093 8.02879 4ZM9.71179 13.6103H4.59349C4.26539 13.6103 4 13.3475 4 13.0224V7.99177C4 3.83104 8.98766 2.76784 9.62998 7.67388C9.68954 8.12868 9.7122 8.59022 9.7122 9.04864L9.71179 13.6103ZM28.6427 10.1325H19.382C19.0539 10.1325 18.7885 9.86968 18.7885 9.54463C18.7885 9.21959 19.0538 8.95672 19.382 8.95672L28.6436 8.95675C28.9716 8.95675 29.237 9.21962 29.237 9.54465C29.237 9.8697 28.9708 10.1325 28.6427 10.1325ZM32.7012 15.164H15.3235C14.9954 15.164 14.73 14.9012 14.73 14.5761C14.73 14.2511 14.9953 13.9882 15.3235 13.9882L32.702 13.9883C33.0301 13.9883 33.2955 14.2511 33.2955 14.5762C33.2955 14.9012 33.0293 15.164 32.7012 15.164ZM32.7012 20.1947H15.3235C14.9954 20.1947 14.73 19.9318 14.73 19.6068C14.73 19.2818 14.9953 19.0189 15.3235 19.0189L32.702 19.0189C33.0301 19.0189 33.2955 19.2818 33.2955 19.6068C33.2955 19.9319 33.0293 20.1947 32.7012 20.1947ZM32.7012 25.2262H15.3235C14.9954 25.2262 14.73 24.9633 14.73 24.6383C14.73 24.3132 14.9953 24.0504 15.3235 24.0504L32.702 24.0504C33.0301 24.0504 33.2955 24.3133 33.2955 24.6383C33.2955 24.9634 33.0293 25.2262 32.7012 25.2262ZM27.014 30.2568H15.3226C14.9945 30.2568 14.7291 29.994 14.7291 29.6689C14.7291 29.3439 14.9945 29.081 15.3226 29.081L27.014 29.0811C27.3421 29.0811 27.6075 29.3439 27.6075 29.669C27.6075 29.994 27.3421 30.2568 27.014 30.2568ZM25.4913 35.2875H15.3234C14.9953 35.2875 14.73 35.0247 14.73 34.6996C14.73 34.3746 14.9953 34.1117 15.3234 34.1117H25.4913C25.8194 34.1117 26.0848 34.3746 26.0848 34.6996C26.0848 35.0247 25.8194 35.2875 25.4913 35.2875Z"
                                  fill="white"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M40.8495 47.0001C40.6393 47.0001 40.4425 46.8892 40.3357 46.7061L38.2717 43.1646L38.7535 42.6874L39.5674 42.9036C40.7727 43.2237 42.0129 42.5141 42.336 41.3205L42.5543 40.5138C42.9941 40.397 43.5411 40.2874 43.9153 40.0735L45.9195 43.5122C46.1768 43.954 45.7784 44.4917 45.276 44.3798L42.3188 43.7213L41.4167 46.5869C41.3394 46.8319 41.108 47.0001 40.8495 47.0001Z"
                                  fill="#FFCD04"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M32.2704 46.9999C32.0035 46.9999 31.77 46.8249 31.6981 46.5707L30.863 43.6145L27.8609 44.3762C27.3541 44.5048 26.9389 43.9615 27.1996 43.5129L29.2046 40.0728C29.5786 40.2866 30.1252 40.396 30.5647 40.5128L30.7831 41.3194C31.1069 42.5159 32.3491 43.222 33.5517 42.9025L34.3656 42.6863L34.848 43.1642L32.7834 46.7068C32.6774 46.889 32.4798 46.9999 32.2704 46.9999Z"
                                  fill="#FFCD04"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M37.3379 26.6849L38.407 27.7448L39.8678 27.3568C40.4536 27.2014 41.059 27.5475 41.2158 28.1278L41.6075 29.5748L43.0683 29.9628C43.6546 30.1189 44.0045 30.7155 43.8466 31.2982L43.4549 32.7452L44.524 33.8043C44.953 34.2292 44.953 34.9213 44.524 35.3462L43.4549 36.4053L43.8466 37.8523C44.0038 38.4318 43.6564 39.0322 43.0683 39.1877L41.6075 39.5757L41.2158 41.0227C41.0585 41.6025 40.4566 41.9503 39.8678 41.7937L38.407 41.4057L37.3379 42.4648C37.1234 42.6764 36.8419 42.783 36.5596 42.783C36.2781 42.783 35.9958 42.6764 35.7813 42.4639L34.7122 41.4049L33.2514 41.7929C32.6661 41.9478 32.0604 41.6049 31.9034 41.0219L31.5117 39.5749L30.0509 39.1869C29.4646 39.0308 29.1147 38.4341 29.2726 37.8515L29.6643 36.4044L28.5952 35.3454C28.1662 34.9204 28.1662 34.2284 28.5952 33.8034L29.6643 32.7444L29.2726 31.2974C29.1156 30.7187 29.4616 30.1178 30.0509 29.962L31.5117 29.574L31.9034 28.1269C32.0602 27.5466 32.6656 27.2006 33.2514 27.356L34.7122 27.744L35.7813 26.6849C36.2103 26.26 36.9089 26.26 37.3379 26.6849ZM36.5596 30.3282C34.1959 30.3282 32.273 32.233 32.273 34.5744C32.273 36.9159 34.1959 38.8207 36.5596 38.8207C38.9233 38.8207 40.8461 36.9159 40.8461 34.5744C40.8461 32.233 38.9233 30.3282 36.5596 30.3282Z"
                                  fill="#FFCD04"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M36.5596 31.5042C34.8504 31.5042 33.46 32.8815 33.46 34.5746C33.46 36.2677 34.8504 37.6451 36.5596 37.6451C38.2688 37.6451 39.6592 36.2677 39.6592 34.5746C39.6592 32.8815 38.2688 31.5042 36.5596 31.5042Z"
                                  fill="white"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_2002_1725">
                                  <rect
                                    width="42"
                                    height="43"
                                    fill="white"
                                    transform="translate(4 4)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div class="slider_box_right">
                            <div class="slider_box_right_content">
                              <span class="text_white_7">
                                New Mode of Action (MoA) Candidates</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_right_center1"
                      >
                        <div
                          class="home_slider_carousel_inner_item_layout_content_box_right_center1_box slider_box transparent_hexagon"
                        >
                          <div class="slider_box_left">
                            <svg
                              width="50"
                              height="50"
                              viewBox="0 0 50 50"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_2002_1792)">
                                <path
                                  d="M17.5889 36.1714V33.407C17.5893 32.0853 16.7426 30.9121 15.4881 30.4961L11.8478 29.2828C11.3086 29.1048 10.8192 28.8017 10.4196 28.3983C9.34464 27.3232 7.47495 27.2549 6.78159 28.826L5.27893 32.2107C7.44687 36.3407 10.9848 39.5872 15.2854 41.3928V40.4714C15.2823 39.3483 15.8448 38.2992 16.7819 37.6802C17.2881 37.3455 17.5915 36.7782 17.5889 36.1714Z"
                                  fill="white"
                                />
                                <path
                                  d="M14.5176 6.04802C14.5164 6.30555 14.6463 6.54599 14.8624 6.68612C15.0784 6.83066 15.3529 6.85609 15.5918 6.75369L17.8953 5.76468C18.1751 5.64055 18.3558 5.36358 18.3568 5.05748V3.54248C17.0345 3.85512 15.7479 4.30337 14.5176 4.8801V6.04802Z"
                                  fill="white"
                                />
                                <path
                                  d="M41.6223 17.1675C41.3346 17.8897 40.6336 18.3618 39.8562 18.3569H39.0884C38.8141 18.3633 38.564 18.5157 38.4324 18.7565C38.3009 18.9973 38.3077 19.29 38.4505 19.5243C38.5932 19.7587 38.8502 19.8991 39.1245 19.8926C39.7288 19.8997 40.2931 20.1966 40.6413 20.6906C40.9895 21.1846 41.0793 21.8158 40.8828 22.3874C40.5818 23.2927 40.2279 24.2411 39.8509 25.204C40.6147 25.3611 41.2953 25.7907 41.7658 26.4126C41.959 26.6646 42.2188 26.8575 42.516 26.9693C43.2339 23.5018 43.0096 19.9053 41.8664 16.554L41.6223 17.1675Z"
                                  fill="white"
                                />
                                <path
                                  d="M28.5913 3.81274L25.5038 8.96819C25.2079 9.48935 25.2161 10.1296 25.5251 10.643C25.8341 11.1565 26.3959 11.4635 26.9949 11.4461H32.1779C32.823 11.4533 33.4361 11.7282 33.8707 12.205C34.3053 12.6819 34.5223 13.3178 34.4699 13.9608C34.3331 15.1654 33.3055 16.0701 32.0934 16.0533H27.7935C25.2481 16.0115 23.1203 17.9797 22.9638 20.5207C22.926 21.7667 23.3946 22.9747 24.2627 23.8692C25.1309 24.7637 26.3244 25.2682 27.5708 25.2677C28.5892 25.2681 29.5659 25.6724 30.2867 26.3918C30.9952 25.4733 32.1413 25.0045 33.2905 25.1632C33.6681 25.2155 34.0523 25.1395 34.3816 24.9475C35.3908 24.3577 36.6395 24.3577 37.6487 24.9475C37.8266 25.0503 38.0213 25.1205 38.2238 25.1548C38.6707 24.0398 39.08 22.9464 39.4263 21.9052C39.48 21.7439 39.4109 21.4276 39.1813 21.4329C37.9079 21.4586 36.8547 20.447 36.829 19.1735C36.8034 17.9 37.8149 16.8468 39.0884 16.8211H39.8563C40.004 16.8221 40.1377 16.7339 40.1949 16.5977L41.0395 14.4937C38.6023 9.32168 34.0735 5.43579 28.5913 3.81274Z"
                                  fill="white"
                                />
                                <path
                                  d="M4.59706 19.8926C5.41092 19.8918 6.07047 19.2322 6.07131 18.4183C6.07213 17.7014 6.32736 17.0081 6.79155 16.4618L10.4564 12.1901C10.6839 11.9177 10.7347 11.5389 10.5871 11.2161C10.4394 10.8934 10.1195 10.6842 9.76462 10.6782H7.24534C5.14184 13.3556 3.76142 16.5284 3.23645 19.8926H4.59706Z"
                                  fill="white"
                                />
                                <path
                                  d="M36.0171 29.8748C32.6246 29.8748 29.8744 32.625 29.8744 36.0177C29.8744 39.4103 32.6246 42.1606 36.0171 42.1606C39.4096 42.1606 42.1598 39.4103 42.1598 36.0177C42.156 32.6266 39.4081 29.8786 36.0171 29.8748ZM38.8635 35.0248L35.0243 38.8642C34.7244 39.1639 34.2384 39.1639 33.9386 38.8642L33.1707 38.0963C32.8797 37.795 32.8839 37.3161 33.1801 37.0199C33.4763 36.7237 33.9552 36.7195 34.2564 37.0105L34.4814 37.2355L37.7778 33.9391C38.079 33.6481 38.5579 33.6522 38.8541 33.9484C39.1503 34.2446 39.1545 34.7235 38.8635 35.0248Z"
                                  fill="#FFCD04"
                                />
                                <path
                                  d="M5.38031 28.204C5.96443 26.8856 7.2708 26.0356 8.71273 26.0355C9.68148 26.0382 10.6102 26.4222 11.298 27.1044C12.4306 28.2432 14.4869 28.5434 15.9734 29.0394C17.8556 29.6636 19.1257 31.424 19.1246 33.407V36.1714C19.1277 37.2944 18.5652 38.3436 17.6281 38.9626C17.122 39.2973 16.8186 39.8646 16.8211 40.4714V41.9572C20.0979 43.0225 23.5956 43.2154 26.9696 42.517C26.8583 42.2196 26.6653 41.9596 26.413 41.7668C25.4788 41.0606 24.9997 39.9044 25.1606 38.7445C25.2123 38.3669 25.1363 37.9828 24.9448 37.6533C24.354 36.6444 24.354 35.395 24.9448 34.3861C25.138 34.0563 25.2148 33.6713 25.1629 33.2926C25.0019 32.1323 25.481 30.9755 26.4153 30.2688C26.7187 30.0394 26.9365 29.715 27.0341 29.3473C27.2837 28.3902 27.9588 27.6005 28.8654 27.205C28.4839 26.9443 28.0329 26.8044 27.5709 26.8034C25.9097 26.8041 24.319 26.132 23.1617 24.9403C22.0043 23.7486 21.3789 22.139 21.4281 20.4785C21.6113 17.1075 24.4179 14.4793 27.7935 14.5176H32.0934C32.5095 14.5307 32.8708 14.2334 32.9381 13.8226C32.9557 13.6087 32.884 13.3969 32.74 13.2376C32.596 13.0784 32.3926 12.9858 32.1779 12.9818H26.995C25.8427 12.9925 24.7732 12.3841 24.1937 11.388C23.6142 10.392 23.6137 9.16155 24.1924 8.16502L27.0334 3.41885C24.6832 2.93054 22.2645 2.86863 19.8925 3.23609V5.05747C19.8908 5.97616 19.3456 6.80678 18.5034 7.17371L16.1953 8.16656C15.4828 8.45683 14.673 8.3772 14.0306 7.95371C13.3883 7.53022 12.9959 6.8173 12.9819 6.04802V5.68712C11.36 6.62781 9.8778 7.79089 8.57836 9.14251H9.76467C10.708 9.1709 11.5539 9.73115 11.9482 10.5887C12.3424 11.4462 12.217 12.453 11.6244 13.1876L7.95948 17.4593C7.73226 17.7272 7.60738 18.067 7.60704 18.4183C7.60535 20.08 6.25875 21.4267 4.59711 21.4284H3.06527C3.02611 21.9359 3 22.4465 3 22.9641C2.99892 25.4951 3.48186 28.0029 4.42281 30.3525L5.38031 28.204Z"
                                  fill="white"
                                />
                                <path
                                  d="M44.6936 31.4942C44.1133 31.0549 43.6981 30.4326 43.515 29.7281C43.3596 29.1345 42.8961 28.6707 42.3026 28.5149C41.5984 28.3308 40.9764 27.9154 40.5366 27.3355C40.1645 26.8474 39.5592 26.5964 38.951 26.6782C38.2334 26.7764 37.5036 26.6318 36.8778 26.2674C36.3484 25.9551 35.6911 25.9551 35.1617 26.2674C34.5325 26.6328 33.7996 26.7784 33.0785 26.6812C32.4707 26.6011 31.8663 26.8514 31.4929 27.3378C31.0539 27.9184 30.4316 28.3338 29.7269 28.5164C29.1333 28.6719 28.6695 29.1353 28.5137 29.7289C28.3296 30.4332 27.9143 31.0551 27.3343 31.495C26.8445 31.8657 26.5932 32.4721 26.6771 33.0806C26.775 33.7982 26.6304 34.5279 26.2663 35.1539C25.9541 35.6833 25.9541 36.3406 26.2663 36.87C26.6332 37.4987 26.7789 38.2321 26.6801 38.9533C26.5956 39.5617 26.8467 40.1683 27.3366 40.5389C27.9173 40.978 28.3326 41.6003 28.5153 42.305C28.6707 42.8987 29.1341 43.3624 29.7277 43.5182C30.4319 43.7023 31.0539 44.1177 31.4937 44.6977C31.8657 45.1858 32.4711 45.4367 33.0793 45.355C33.2256 45.3348 33.3731 45.3245 33.5208 45.3242C34.0954 45.324 34.6598 45.4764 35.1563 45.7658C35.6857 46.078 36.343 46.078 36.8724 45.7658C37.5011 45.3991 38.2345 45.2534 38.9556 45.3519C39.5635 45.4327 40.1683 45.1823 40.5412 44.6954C40.9802 44.1147 41.6025 43.6994 42.3072 43.5167C42.9008 43.3613 43.3646 42.8978 43.5204 42.3042C43.7045 41.6 44.1198 40.978 44.6998 40.5381C45.1896 40.1674 45.4409 39.561 45.357 38.9525C45.2591 38.2349 45.4037 37.5053 45.7678 36.8793V36.8723C46.0773 36.3446 46.0773 35.6908 45.7678 35.1631C45.4009 34.5345 45.2552 33.801 45.354 33.0799C45.4377 32.4707 45.185 31.8639 44.6936 31.4942ZM36.0171 43.6964C31.7764 43.6964 28.3387 40.2585 28.3387 36.0177C28.3387 31.7769 31.7764 28.3391 36.0171 28.3391C40.2577 28.3391 43.6954 31.7769 43.6954 36.0177C43.6908 40.2566 40.2558 43.6917 36.0171 43.6964Z"
                                  fill="#FFCD04"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_2002_1792">
                                  <rect
                                    width="43"
                                    height="43"
                                    fill="white"
                                    transform="translate(3 3)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div class="slider_box_right">
                            <div class="slider_box_right_content">
                              <span class="text_white_7">
                                New or Existing Chemical Class Development
                                Updates</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_right_bottom1"
                      >
                        <div
                          class="home_slider_carousel_inner_item_layout_content_box_right_bottom1_box slider_box transparent_hexagon"
                        >
                          <div class="slider_box_left">
                            <svg
                              width="50"
                              height="50"
                              viewBox="0 0 50 50"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_2002_1767)">
                                <path
                                  d="M44.6718 31.7813L37.3047 21.9063C36.7422 21.1484 35.6484 20.9844 34.8828 21.5391L32.8437 23C32.4687 23.2734 32.2187 23.6797 32.1484 24.1406C32.1093 24.4063 32.125 24.6719 32.2031 24.9219C31.4297 25.1484 30.1797 25.4141 28.7343 25.3359C27.4531 25.2578 26.2031 25.3672 25.0156 25.6485C23.8125 25.3672 22.5547 25.2578 21.2656 25.3359C21.0859 25.3438 20.914 25.3516 20.7422 25.3516C19.5312 25.3516 18.4765 25.125 17.7968 24.9219C17.875 24.6719 17.8906 24.4063 17.8515 24.1406C17.7812 23.6797 17.5312 23.2734 17.1562 23L15.1172 21.5391C14.3515 20.9844 13.2578 21.1484 12.6953 21.9063L5.32809 31.7813C5.05465 32.1563 4.93747 32.6094 5.00778 33.0703C5.07809 33.5235 5.32809 33.9297 5.70309 34.2031L7.74215 35.6641C8.04684 35.8906 8.40622 35.9922 8.75778 35.9922C9.29684 35.9922 9.82809 35.75 10.164 35.2969L10.2578 35.1797C10.875 36.3203 11.7187 37.5234 12.7734 38.7891C12.5234 39.1094 12.3828 39.4453 12.3515 39.7969C12.2812 40.7578 12.664 41.7266 13.375 42.3984C13.9375 42.9297 14.664 43.2188 15.4062 43.2188C15.4687 43.2188 15.539 43.2109 15.6015 43.2031C15.7422 43.8516 16.0781 44.4688 16.5781 44.9375C17.1562 45.4844 17.8984 45.7813 18.6718 45.7813H18.6953C18.6953 45.7813 18.6953 45.7813 18.7031 45.7813C18.8593 46.3828 19.1718 46.9375 19.6406 47.3594C20.2031 47.875 20.9062 48.1484 21.6406 48.1484C21.7734 48.1484 21.9062 48.1406 22.0468 48.1172C22.5703 48.0469 23.1328 47.7656 23.7187 47.3125C25.6875 48.0469 27.25 48.4219 28.4687 48.4219C29.1718 48.4219 29.7578 48.3047 30.25 48.0625C31.2422 47.5703 31.6406 46.6953 31.8672 45.9531C32.164 45.9844 32.4531 46.0078 32.7187 46.0078C33.4062 46.0078 33.9843 45.8906 34.4609 45.6641C35.5234 45.1563 35.914 44.2188 36.1406 43.4531C36.2343 43.1484 36.25 42.8281 36.2265 42.5078H36.3672C37.0547 42.5078 37.6328 42.3906 38.1093 42.1641C39.1718 41.6563 39.5625 40.7109 39.789 39.9453C40.2109 38.5078 39.2578 37.2578 38.6875 36.6719C38.8203 36.2578 39.1093 35.5703 39.6328 35.0313L39.8203 35.2734C40.1562 35.7266 40.6875 35.9688 41.2265 35.9688C41.5781 35.9688 41.9375 35.8672 42.2422 35.6406L44.2812 34.1797C44.6562 33.9063 44.9062 33.5 44.9765 33.0469C45.0468 32.5859 44.9297 32.1328 44.6562 31.7578L44.6718 31.7813ZM15.7422 41.5938C15.6953 41.6094 15.6484 41.6328 15.6015 41.6406C15.039 41.7188 14.6406 41.4375 14.4531 41.2578C14.0859 40.9141 13.8828 40.3984 13.9218 39.9219C13.9297 39.7891 14.3047 39.2578 15.8281 38.5859C16.3437 38.3594 16.9531 38.5078 17.3125 38.9375C17.5625 39.2422 17.625 39.6406 17.5312 40.0078C16.625 40.5078 16.039 41.0313 15.75 41.5859L15.7422 41.5938ZM19.125 44.1484C19.125 44.1484 19.1093 44.1484 19.1015 44.1484C19.1015 44.1484 19.1015 44.1484 19.0937 44.1484C19.0937 44.1484 19.0859 44.1484 19.0781 44.1484C19 44.1719 18.9297 44.1875 18.875 44.1953C18.2812 44.2813 17.8515 43.9766 17.6562 43.7891C17.2656 43.4297 17.0547 42.8906 17.0937 42.3828C17.1015 42.25 17.3906 41.8281 18.5 41.2578C18.5234 41.2422 18.5468 41.2344 18.5703 41.2188C18.7265 41.1406 18.8984 41.0625 19.0859 40.9766C19.2578 40.8984 19.4375 40.8594 19.6172 40.8594C20.0156 40.8594 20.3984 41.0313 20.664 41.3594C21.0703 41.8594 21.039 42.5938 20.5781 43.0625C19.8984 43.7422 19.4218 44.0235 19.125 44.1328V44.1484ZM23.4531 45.4922C22.8281 46.1328 22.2422 46.5234 21.8437 46.5781C21.4297 46.6328 21.0234 46.5 20.7031 46.2109C20.4531 45.9844 20.2812 45.6797 20.2031 45.3516C20.6797 45.0859 21.164 44.6875 21.6875 44.1641C21.8906 43.9531 22.0547 43.7344 22.1797 43.4844C22.6562 43.3281 23.2031 43.4766 23.539 43.8828C23.9297 44.3594 23.8906 45.0469 23.4531 45.4844V45.4922ZM38.3125 39.5313C38.1093 40.2344 37.8672 40.5781 37.4609 40.7734C36.7343 41.1172 35.0156 41.1719 30.9453 39.4688C30.5468 39.3047 30.0859 39.4922 29.9218 39.8906C29.7578 40.2891 29.9453 40.75 30.3437 40.9141C32.0156 41.6172 33.4297 42.0781 34.625 42.3281C34.7109 42.5781 34.7265 42.8125 34.664 43.0234C34.4531 43.7266 34.2187 44.0781 33.8047 44.2656C33.0781 44.6094 31.3593 44.6641 27.2812 42.961C26.8828 42.7969 26.4218 42.9844 26.2578 43.3828C26.0937 43.7813 26.2812 44.2344 26.6797 44.4063C28.0703 44.9844 29.2734 45.3984 30.3281 45.6719C30.1406 46.2031 29.9218 46.5 29.5703 46.6719C28.9843 46.961 27.7109 47.0625 24.9453 46.1094C25.5703 45.125 25.5156 43.8359 24.75 42.8984C24.1797 42.2109 23.3437 41.8516 22.5 41.8672C22.5 41.8672 22.5 41.8672 22.5 41.8594C22.4375 41.336 22.2343 40.8203 21.8828 40.3828C21.2031 39.5547 20.1328 39.1719 19.1172 39.3672C19.0547 38.8594 18.8515 38.375 18.5234 37.9609C17.7187 36.9844 16.3437 36.6563 15.2031 37.1641C14.7422 37.3672 14.3359 37.5781 13.9843 37.7891C12.7968 36.3672 11.8906 35.0078 11.3125 33.7891L16.9062 26.2891C17.75 26.5703 19.3984 27.0156 21.375 26.9063C21.5156 26.8984 21.6562 26.8906 21.8047 26.8984C21.7968 26.8984 21.7968 26.9063 21.789 26.9063C20.3515 27.7344 18.8672 28.3047 17.4765 28.8125C17.0234 28.9766 16.6484 29.3281 16.4687 29.7734C16.2812 30.2031 16.289 30.6953 16.4922 31.1172C17.4297 33.1641 19.3047 33.8281 21.5 32.9063C26.2578 30.9063 28.7265 32.8906 31.3437 34.9844C33.0625 36.3594 34.8281 37.7734 37.1875 37.7734H37.5703C37.914 38.125 38.5234 38.8594 38.3203 39.5469L38.3125 39.5313ZM37.2265 36.2031C35.4375 36.2266 33.9531 35.0703 32.3125 33.7578C29.7187 31.6797 26.5 29.1016 20.8828 31.4609C19.4453 32.0625 18.4922 31.7422 17.8984 30.461C17.8984 30.4453 17.8828 30.4141 17.8984 30.3672C17.914 30.3359 17.9375 30.2969 18 30.2734C19.4609 29.75 21.0156 29.1406 22.5625 28.25C24.3281 27.2422 26.4297 26.7734 28.6562 26.8984C30.625 27.0078 32.2734 26.5625 33.1172 26.2813L38.7187 33.7891C37.875 34.5625 37.4375 35.5703 37.2265 36.2031Z"
                                  fill="white"
                                />
                                <path
                                  d="M18.5547 19.625H31.4453C33.1719 19.625 34.5703 18.2188 34.5703 16.5V4.6875C34.5703 2.96094 33.1719 1.5625 31.4453 1.5625H18.5547C16.8281 1.5625 15.4297 2.96094 15.4297 4.6875V16.5C15.4297 18.2188 16.8281 19.625 18.5547 19.625ZM20.5078 3.125H29.4922V8.625C29.4922 8.875 29.3672 9.10938 29.1719 9.25C29.0312 9.35156 28.875 9.40625 28.7109 9.40625C28.625 9.40625 28.5469 9.39062 28.4687 9.36719L25 8.26562L21.5312 9.36719C21.2891 9.44531 21.0312 9.39844 20.8281 9.25C20.6328 9.10938 20.5078 8.875 20.5078 8.625V3.125Z"
                                  fill="#FFCD04"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_2002_1767">
                                  <rect width="50" height="50" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div class="slider_box_right">
                            <div class="slider_box_right_content">
                              <span class="text_white_7">
                                Patent Watch for Active Ingredient and
                                Processes</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="carousel-item" data-bs-interval="2000">
          <div class="home_slider_carousel_inner_item">
            <img
              src="../../../assets/img/carousel_img/carousel_02.webp"
              class="home_slider_carousel_inner_item_img w-100"
              alt="image"
            />
            <img
              src="../../../assets/img/carousel_img/carousel_mobile_02.webp"
              class="home_slider_carousel_inner_item_phoneimg w-100"
              alt="image"
            />
            <div class="home_slider_carousel_inner_item_top carousel-caption">
              <p class="text_white_3">Agrochemical Generic Intelligence</p>
              <span class="text_white_4"
                >AgroPat Ultimate Generic Suite Aids in Advancing the
                Development of Generic Agrochemicals and in Identifying New
                Generic Opportunities Within the Field.</span
              >
              <div class="home_slider_carousel_inner_item_top_button">
                <button
                  type="button"
                  class="rounded-pill text_blue_4 button_white_1"
                >
                  <span>View More</span>
                  <img
                    class="home_slider_carousel_inner_item_top_button_icon button_white_1_text_icon"
                    src="../../../assets/icons/video_icon.png"
                  />
                </button>
              </div>
              <div class="home_slider_carousel_inner_item_top_img">
                <div class="home_slider_carousel_inner_item_top_img_body">
                  <div class="home_slider_carousel_inner_item_top_img_body_box">
                    <img
                      width="30%"
                      src="../../../assets/icons/leaves_icon.png"
                      alt="image"
                    />
                    <div class="text_white_21">AgroPat</div>
                  </div>
                </div>
              </div>
              <div class="home_slider_carousel_inner_item_top_list p-y-11">
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Year Wise Generic or Off Patent Molecules
                </div>
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Formulation & Combination Patents
                </div>
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Synthesis Pathways, e.g. Innovator and Commercial Routes
                </div>
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Patent Watch for Active Ingredient and Processes
                </div>
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Patent Landscape of Innovator & Generic Patents
                </div>
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Global Patent Litigation Update
                </div>
              </div>
            </div>
            <div
              class="home_slider_carousel_inner_item_button carousel-caption"
            >
              <button
                type="button"
                class="rounded-pill text_blue_4 button_white_1"
                data-bs-toggle="modal"
                data-bs-target="#VideoModel"
                data-bs-dismiss="modal"
                (click)="toggleIntroVideoHome()"
              >
                <span>View More</span>
                <img
                  class="home_slider_carousel_inner_item_button_icon button_white_1_text_icon"
                  src="../../../assets/icons/video_icon.png"
                />
              </button>
            </div>
            <div
              class="home_slider_carousel_inner_item_layout carousel-caption"
            >
              <div class="home_slider_carousel_inner_item_layout_content">
                <div class="home_slider_carousel_inner_item_layout_content_box">
                  <div
                    class="home_slider_carousel_inner_item_layout_content_box_left"
                  >
                    <div
                      class="home_slider_carousel_inner_item_layout_content_box_left_top1"
                    >
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_left_top1_box slider_box transparent_hexagon"
                      >
                        <div class="slider_box_left">
                          <svg
                            width="44"
                            height="45"
                            viewBox="0 0 44 45"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21.375 14.3438L14.1875 17.3125L22 20.4375L29.8125 17.3125L22.625 14.3438C22.1562 14.1875 21.8438 14.1875 21.375 14.3438Z"
                              fill="#FFDD3C"
                            />
                            <path
                              d="M14.1875 18.875L21.2188 21.6875V29.8125L15.125 27.1562C14.5 26.8437 14.1875 26.375 14.1875 25.75V18.875Z"
                              fill="#FFDD3C"
                            />
                            <path
                              d="M12.1562 34.0313C11.375 33.4063 10.5938 32.625 9.96875 31.8438L6.84375 34.9688C6.21875 34.6562 5.59375 34.5 4.8125 34.5C2.15625 34.5 0.125 36.5313 0.125 39.1875C0.125 41.8438 2.15625 43.875 4.8125 43.875C7.46875 43.875 9.5 41.8438 9.5 39.1875C9.5 38.4063 9.34375 37.7813 9.03125 37.1563L12.1562 34.0313Z"
                              fill="white"
                            />
                            <path
                              d="M9.96875 12.1562C10.5938 11.375 11.375 10.5938 12.1562 9.96875L9.03125 6.84375C9.34375 6.21875 9.5 5.59375 9.5 4.8125C9.5 2.15625 7.46875 0.125 4.8125 0.125C2.15625 0.125 0.125 2.15625 0.125 4.8125C0.125 7.46875 2.15625 9.5 4.8125 9.5C5.59375 9.5 6.21875 9.34375 6.84375 9.03125L9.96875 12.1562Z"
                              fill="white"
                            />
                            <path
                              d="M31.8438 9.96875C32.625 10.5938 33.4063 11.375 34.0313 12.1562L37.1563 9.03125C37.7813 9.34375 38.4063 9.5 39.1875 9.5C41.8438 9.5 43.875 7.46875 43.875 4.8125C43.875 2.15625 41.8438 0.125 39.1875 0.125C36.5313 0.125 34.5 2.15625 34.5 4.8125C34.5 5.59375 34.6562 6.21875 34.9688 6.84375L31.8438 9.96875Z"
                              fill="white"
                            />
                            <path
                              d="M42.7812 37.4688L37.1562 31.8437C36.6875 31.375 35.9062 31.2188 35.2812 31.5312L33.7187 29.8125C35.2812 27.625 36.0625 24.8125 36.0625 22C36.0625 14.1875 29.8125 7.9375 22 7.9375C14.1875 7.9375 7.9375 14.1875 7.9375 22C7.9375 29.8125 14.1875 36.0625 22 36.0625C24.9687 36.0625 27.625 35.125 29.8125 33.7188L31.5312 35.4375C31.2187 36.0625 31.2187 36.6875 31.8437 37.3125L37.4687 42.9375C38.25 43.7188 39.1875 44.0312 40.125 44.0312C41.0625 44.0312 42.1562 43.5625 42.7812 42.9375C44.1875 41.375 44.1875 38.875 42.7812 37.4688ZM11.0625 22C11.0625 15.9062 15.9062 11.0625 22 11.0625C28.0937 11.0625 32.9375 15.9062 32.9375 22C32.9375 28.0938 28.0937 32.9375 22 32.9375C15.9062 32.9375 11.0625 28.0938 11.0625 22Z"
                              fill="white"
                            />
                            <path
                              d="M29.8125 18.875L22.7812 21.6875V29.8125L28.875 27.1562C29.5 26.8437 29.8125 26.375 29.8125 25.75V18.875Z"
                              fill="#FFDD3C"
                            />
                          </svg>
                        </div>
                        <div class="slider_box_right">
                          <div class="slider_box_right_content">
                            <span class="text_white_7"
                              >Year Wise Generic or Off Patent Molecules</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="home_slider_carousel_inner_item_layout_content_box_left_center1"
                    >
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_left_center1_box slider_box transparent_hexagon"
                      >
                        <div class="slider_box_left">
                          <svg
                            width="38"
                            height="43"
                            viewBox="0 0 38 43"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_1882_30398)">
                              <path
                                d="M37.9996 19.5771C37.9996 20.2726 37.4396 20.837 36.7477 20.837H35.344V34.8107C35.344 39.3261 31.6935 42.9999 27.2068 42.9999C23.1065 42.9999 19.704 39.9309 19.1498 35.9555H24.0504C24.7423 35.9555 25.3023 35.3911 25.3023 34.6957C25.3023 33.9994 24.7423 33.4358 24.0504 33.4358H19.0697V30.916H24.0504C24.7423 30.916 25.3023 30.3516 25.3023 29.6562C25.3023 28.9599 24.7423 28.3963 24.0504 28.3963H19.0697V25.8766H24.0504C24.7423 25.8766 25.3023 25.3121 25.3023 24.6167C25.3023 23.9204 24.7423 23.3569 24.0504 23.3569H19.0697V20.8371H17.6659C16.9741 20.8371 16.4141 20.2726 16.4141 19.5772C16.4141 18.8809 16.9741 18.3174 17.6659 18.3174H36.7477C37.4396 18.3174 37.9996 18.8808 37.9996 19.5771Z"
                                fill="white"
                              />
                              <path
                                d="M15.4722 11.6754L13.5953 14.9469C13.3716 15.3366 12.9585 15.5769 12.5112 15.5769H9.47079L8.33243 17.5095L9.4808 19.5119H12.0964C12.7882 19.5119 13.3482 20.0763 13.3482 20.7717C13.3482 21.4681 12.7882 22.0316 12.0964 22.0316H9.4808L8.32742 24.0432L9.70864 26.4513C10.0542 27.0543 9.84885 27.8246 9.25046 28.1723C8.65457 28.5204 7.88726 28.3164 7.54041 27.7112L6.15918 25.3031H3.128C2.6815 25.3031 2.26755 25.0629 2.04388 24.6731L0.16775 21.4016C-0.0559167 21.0119 -0.0559167 20.5315 0.16775 20.1418L2.04388 16.8711C2.26755 16.4814 2.6815 16.2411 3.128 16.2411H6.16837L7.30756 14.3085L5.79781 11.6753C5.57415 11.2855 5.57415 10.8052 5.79781 10.4155L7.31257 7.77475L5.86708 5.25505H2.79917C2.10731 5.25505 1.54731 4.69059 1.54731 3.9952C1.54731 3.29981 2.10731 2.73535 2.79917 2.73535H6.58983C7.03716 2.73535 7.45028 2.97555 7.67394 3.36532L9.4808 6.51498H12.5112C12.9585 6.51498 13.3716 6.75518 13.5953 7.14495L15.4722 10.4156C15.6959 10.8052 15.6959 11.2857 15.4722 11.6754Z"
                                fill="white"
                              />
                              <path
                                d="M35.7978 1.15264C35.7093 0.623537 35.297 0.208571 34.7712 0.119548C34.586 0.0884734 30.2003 -0.622874 27.7691 1.82367C27.5647 2.02943 27.3777 2.25367 27.2066 2.49555C27.0355 2.25367 26.8486 2.02943 26.6441 1.82367C24.213 -0.622874 19.8273 0.0885573 19.6412 0.119632C19.1154 0.208655 18.7039 0.623537 18.6155 1.15272C18.5838 1.33917 17.8769 5.75196 20.3088 8.1985C21.7454 9.64421 23.9238 10.0672 25.9548 10.0429V15.7977H28.4585V10.0429C30.4892 10.0675 32.6681 9.64387 34.1044 8.1985C36.5355 5.75187 35.8295 1.33908 35.7978 1.15264Z"
                                fill="#FFDD3C"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1882_30398">
                                <rect width="38" height="43" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <div class="slider_box_right">
                          <div class="slider_box_right_content">
                            <span class="text_white_7"
                              >Synthesis Pathways, e.g. Innovator and Commercial
                              Routes</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="home_slider_carousel_inner_item_layout_content_box_left_bottom1"
                    >
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_left_bottom1_box slider_box transparent_hexagon"
                      >
                        <div class="slider_box_left">
                          <svg
                            width="42"
                            height="43"
                            viewBox="0 0 42 43"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_1882_30367)">
                              <path
                                d="M19.1547 16.7508C19.2053 18.5207 17.7753 19.9773 16.0082 19.9773H12.4107C12.1127 19.9773 11.8711 19.7367 11.8711 19.4398V14.244C11.8711 13.9472 12.1127 13.7065 12.4107 13.7065H15.9475C17.6608 13.7065 19.106 15.045 19.1547 16.7508Z"
                                fill="white"
                              />
                              <path
                                d="M22.6888 1.73358C22.4095 0.256533 20.7245 -0.469805 19.4619 0.329812C18.2427 1.10273 16.8045 0.32596 15.3626 0.741893C12.3425 1.61318 11.2075 4.07984 11.847 6.39547C10.7273 7.31862 9.85451 8.57081 9.3836 10.0478C9.11577 9.65584 8.77554 9.27045 8.3862 8.93514C8.81061 7.19195 7.91242 5.38918 5.67102 4.74894C4.5871 4.44131 3.5594 4.98409 2.75078 4.4766C1.71543 3.82784 0.342546 4.42303 0.114737 5.61699C-0.682551 9.79353 2.83586 12.3742 5.69998 11.6544C6.19175 11.5308 6.25363 10.8628 5.79576 10.6455C5.774 10.6352 5.7525 10.6252 5.73128 10.6157C5.38448 10.4589 5.24571 10.0831 5.32117 9.79424C5.43404 9.36228 5.89676 9.11879 6.30597 9.29975C8.07089 10.0796 9.04598 11.859 8.99328 13.477V13.7063H3.47836C1.76507 13.7063 0.319792 15.0447 0.270327 16.7504C0.220142 18.5212 1.64977 19.9771 3.41721 19.9771H8.27378C8.47254 19.9771 8.65242 20.0578 8.78282 20.1868C9.24204 20.6474 8.90298 21.4105 8.24617 21.4105H3.23733C2.93928 21.4105 2.69772 21.6511 2.69772 21.948V27.2629C2.69772 27.6741 3.1411 27.9312 3.50175 27.7314C5.64188 26.549 6.15443 25.3011 8.99328 25.061C9.3416 25.0312 9.59891 25.0201 9.87897 25.0275C10.1827 25.0356 10.4323 24.7901 10.4323 24.4874C10.4323 22.6651 10.4465 14.0334 10.4323 12.617C10.4056 9.95657 11.9838 7.38411 14.6908 6.39278L14.6944 6.39189C15.0982 6.24766 15.5389 6.48505 15.6369 6.90251C15.7194 7.26048 15.5236 7.61317 15.1899 7.73653C14.7507 7.89894 14.3409 8.11537 13.9675 8.38287C13.6527 8.60835 13.6747 9.08054 14.0061 9.2812C17.7531 11.55 23.8968 8.13956 22.6888 1.73358Z"
                                fill="white"
                              />
                              <path
                                d="M15.2884 29.0196C12.7577 27.6411 12.6755 26.4569 9.71232 26.4575C7.72949 26.458 7.05379 27.0094 6.03211 27.7699C5.54897 28.1301 3.92877 29.2429 3.04991 29.5637C2.83757 29.6412 2.69727 29.8424 2.69727 30.0676V35.9234C2.69727 39.7703 5.78128 42.9624 9.64325 42.9996C13.543 43.0372 16.7274 39.8883 16.7274 36.0125V30.0496C16.7274 29.83 16.5939 29.6326 16.389 29.5512C16.0033 29.3978 15.4606 29.113 15.2884 29.0196ZM10.8221 29.8617L11.0919 29.5929C11.3734 29.3134 11.8285 29.3134 12.11 29.5929C12.3906 29.8733 12.3906 30.3266 12.11 30.607L11.8402 30.8757C11.5588 31.1542 11.1057 31.1563 10.8221 30.8757C10.5415 30.5954 10.5415 30.1421 10.8221 29.8617ZM9.29321 33.1762L9.56302 32.9075C9.84453 32.628 10.2996 32.628 10.5811 32.9075C10.8617 33.1879 10.8617 33.6412 10.5811 33.9216L10.3113 34.1903C10.0299 34.4687 9.57678 34.4709 9.29321 34.1903C9.01261 33.9099 9.01261 33.4566 9.29321 33.1762ZM7.22467 29.8617L7.49448 29.5929C7.77598 29.3134 8.23106 29.3134 8.51257 29.5929C8.79317 29.8733 8.79317 30.3266 8.51257 30.607L8.24275 30.8757C7.96134 31.1542 7.50824 31.1563 7.22467 30.8757C6.94407 30.5954 6.94407 30.1421 7.22467 29.8617Z"
                                fill="white"
                              />
                              <path
                                d="M36.514 33.9522H25.9914C25.7189 33.9522 25.4698 33.7988 25.3479 33.5561L23.7481 30.3689H19.8757C19.4784 30.3689 19.1562 30.048 19.1562 29.6522C19.1562 29.2564 19.4784 28.9355 19.8757 28.9355H24.1927C24.4652 28.9355 24.7143 29.0889 24.8362 29.3317L26.4361 32.5189H36.514C36.9114 32.5189 37.2335 32.8397 37.2335 33.2355C37.2335 33.6313 36.9114 33.9522 36.514 33.9522Z"
                                fill="white"
                              />
                              <path
                                d="M33.9081 38.4314H33.8211C33.4237 38.4314 33.1016 38.1105 33.1016 37.7147C33.1016 37.3189 33.4237 36.998 33.8211 36.998H33.9081C34.3055 36.998 34.6276 37.3189 34.6276 37.7147C34.6276 38.1105 34.3055 38.4314 33.9081 38.4314Z"
                                fill="white"
                              />
                              <path
                                d="M30.8504 38.4314H25.991C25.5936 38.4314 25.2715 38.1105 25.2715 37.7147C25.2715 37.3189 25.5936 36.998 25.991 36.998H30.8504C31.2478 36.998 31.5699 37.3189 31.5699 37.7147C31.5699 38.1105 31.2478 38.4314 30.8504 38.4314Z"
                                fill="white"
                              />
                              <path
                                d="M36.5135 42.9997H30.0671C29.6698 42.9997 29.3477 42.6788 29.3477 42.2831C29.3477 41.8873 29.6698 41.5664 30.0671 41.5664H36.5135C36.9109 41.5664 37.233 41.8873 37.233 42.2831C37.233 42.6788 36.9109 42.9997 36.5135 42.9997Z"
                                fill="white"
                              />
                              <path
                                d="M26.812 42.9997H25.991C25.5936 42.9997 25.2715 42.6788 25.2715 42.2831C25.2715 41.8873 25.5936 41.5664 25.991 41.5664H26.812C27.2093 41.5664 27.5315 41.8873 27.5315 42.2831C27.5315 42.6788 27.2093 42.9997 26.812 42.9997Z"
                                fill="white"
                              />
                              <path
                                d="M39.8416 0.895829H32.3768C31.187 0.895829 30.2184 1.86064 30.2184 3.04582V9.22704H27.7001V2.14999C27.7001 1.04561 26.8451 0 25.4517 0C25.0542 0 24.7322 0.320707 24.7322 0.716663C24.7322 1.11262 25.0542 1.43333 25.4517 1.43333H25.5417C25.9383 1.43333 26.2612 1.75493 26.2612 2.14999V17.827C26.2612 18.2221 25.9383 18.5437 25.5417 18.5437H21.8543C21.4567 18.5437 21.1348 18.8644 21.1348 19.2603C21.1348 19.6563 21.4567 19.977 21.8543 19.977H25.5417C26.7315 19.977 27.7001 19.0122 27.7001 17.827V10.6604H30.2184V16.8416C30.2184 18.0268 31.187 18.9916 32.3768 18.9916H39.8416C41.0314 18.9916 42.0001 18.0268 42.0001 16.8416V3.04582C42.0001 1.86064 41.0314 0.895829 39.8416 0.895829ZM36.424 14.8708H34.8051C34.4078 14.8708 34.0856 14.5499 34.0856 14.1541C34.0856 13.7583 34.4078 13.4374 34.8051 13.4374H36.424C36.8213 13.4374 37.1435 13.7583 37.1435 14.1541C37.1435 14.5499 36.8213 14.8708 36.424 14.8708ZM37.5032 10.6604H34.8051C34.4078 10.6604 34.0856 10.3395 34.0856 9.9437C34.0856 9.54792 34.4078 9.22704 34.8051 9.22704H37.5032C37.9006 9.22704 38.2227 9.54792 38.2227 9.9437C38.2227 10.3395 37.9006 10.6604 37.5032 10.6604ZM37.5032 6.44997H34.8051C34.4078 6.44997 34.0856 6.12908 34.0856 5.73331C34.0856 5.33753 34.4078 5.01664 34.8051 5.01664H37.5032C37.9006 5.01664 38.2227 5.33753 38.2227 5.73331C38.2227 6.12908 37.9006 6.44997 37.5032 6.44997Z"
                                fill="#FFDD3C"
                              />
                              <path
                                d="M16.7276 21.948V26.9526C16.7276 27.5067 16.1215 27.8538 15.6434 27.5705C14.2274 26.7317 13.5613 25.9082 12.2256 25.4281C12.0127 25.3515 11.8711 25.1492 11.8711 24.9237V21.9481C11.8711 21.6513 12.1127 21.4106 12.4107 21.4106H16.188C16.486 21.4105 16.7276 21.6511 16.7276 21.948Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1882_30367">
                                <rect width="42" height="43" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <div class="slider_box_right">
                          <div class="slider_box_right_content">
                            <span class="text_white_7"
                              >Patent Landscape of Innovator & Generic
                              Patents</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="home_slider_carousel_inner_item_layout_content_box_center"
                  >
                    <div
                      class="home_slider_carousel_inner_item_layout_content_box_center_body"
                    >
                      <img
                        width="20%"
                        src="../../../assets/icons/leaves_icon.png"
                        alt="image"
                      />
                      <div class="text_white_20">AgroPat</div>
                    </div>
                  </div>
                  <div
                    class="home_slider_carousel_inner_item_layout_content_box_right"
                  >
                    <div
                      class="home_slider_carousel_inner_item_layout_content_box_right"
                    >
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_right_top1"
                      >
                        <div
                          class="home_slider_carousel_inner_item_layout_content_box_right_top1_box slider_box transparent_hexagon"
                        >
                          <div class="slider_box_left">
                            <svg
                              width="42"
                              height="43"
                              viewBox="0 0 42 43"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_1882_30348)">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M4.02879 0H27.7796C30.7427 0 33.153 2.38771 33.153 5.32294V21.2955C32.3966 21.0929 31.554 21.2853 30.9612 21.8726L30.3656 22.4625L29.5517 22.2463C28.3527 21.9279 27.1046 22.6418 26.7831 23.8295L26.5648 24.6361L25.7505 24.8524C24.5419 25.1734 23.8301 26.4045 24.1523 27.595L24.3706 28.4012L23.775 28.9911C22.8934 29.8644 22.8934 31.2845 23.775 32.1579L24.3706 32.7478L24.1523 33.554C23.9998 34.1174 24.0748 34.7141 24.3609 35.2228L23.7651 36.2451H7.46502C7.1369 36.2451 6.87153 35.9823 6.87153 35.6572L6.87194 5.04879C6.87216 2.94872 6.41696 0.230932 4.02879 0ZM5.71179 9.61034H0.593486C0.265392 9.61034 0 9.34747 0 9.02243V3.99177C0 -0.168957 4.98766 -1.23216 5.62998 3.67388C5.68954 4.12868 5.7122 4.59022 5.7122 5.04864L5.71179 9.61034ZM24.6427 6.13253H15.382C15.0539 6.13253 14.7885 5.86968 14.7885 5.54463C14.7885 5.21959 15.0538 4.95672 15.382 4.95672L24.6436 4.95675C24.9716 4.95675 25.237 5.21962 25.237 5.54465C25.237 5.8697 24.9708 6.13253 24.6427 6.13253ZM28.7012 11.164H11.3235C10.9954 11.164 10.73 10.9012 10.73 10.5761C10.73 10.2511 10.9953 9.98824 11.3235 9.98824L28.702 9.98827C29.0301 9.98827 29.2955 10.2511 29.2955 10.5762C29.2955 10.9012 29.0293 11.164 28.7012 11.164ZM28.7012 16.1947H11.3235C10.9954 16.1947 10.73 15.9318 10.73 15.6068C10.73 15.2818 10.9953 15.0189 11.3235 15.0189L28.702 15.0189C29.0301 15.0189 29.2955 15.2818 29.2955 15.6068C29.2955 15.9319 29.0293 16.1947 28.7012 16.1947ZM28.7012 21.2262H11.3235C10.9954 21.2262 10.73 20.9633 10.73 20.6383C10.73 20.3132 10.9953 20.0504 11.3235 20.0504L28.702 20.0504C29.0301 20.0504 29.2955 20.3133 29.2955 20.6383C29.2955 20.9634 29.0293 21.2262 28.7012 21.2262ZM23.014 26.2568H11.3226C10.9945 26.2568 10.7291 25.994 10.7291 25.6689C10.7291 25.3439 10.9945 25.081 11.3226 25.081L23.014 25.0811C23.3421 25.0811 23.6075 25.3439 23.6075 25.669C23.6075 25.994 23.3421 26.2568 23.014 26.2568ZM21.4913 31.2875H11.3234C10.9953 31.2875 10.73 31.0247 10.73 30.6996C10.73 30.3746 10.9953 30.1117 11.3234 30.1117H21.4913C21.8194 30.1117 22.0848 30.3746 22.0848 30.6996C22.0848 31.0247 21.8194 31.2875 21.4913 31.2875Z"
                                  fill="white"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M36.8493 42.9998C36.639 42.9998 36.4423 42.889 36.3355 42.7059L34.2715 39.1644L34.7532 38.6872L35.5671 38.9033C36.7724 39.2235 38.0127 38.5139 38.3358 37.3202L38.5541 36.5136C38.9939 36.3968 39.5408 36.2872 39.915 36.0732L41.9192 39.512C42.1766 39.9538 41.7781 40.4914 41.2758 40.3795L38.3186 39.7211L37.4165 42.5866C37.3392 42.8317 37.1077 42.9998 36.8493 42.9998Z"
                                  fill="#FFDD3C"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M28.2702 42.9999C28.0033 42.9999 27.7698 42.8249 27.6979 42.5707L26.8628 39.6145L23.8607 40.3762C23.3539 40.5048 22.9387 39.9615 23.1994 39.5129L25.2044 36.0728C25.5783 36.2866 26.125 36.396 26.5645 36.5128L26.7828 37.3194C27.1067 38.5159 28.3489 39.222 29.5515 38.9025L30.3654 38.6863L30.8477 39.1642L28.7831 42.7068C28.6771 42.889 28.4796 42.9999 28.2702 42.9999Z"
                                  fill="#FFDD3C"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M33.3379 22.6849L34.407 23.7448L35.8678 23.3568C36.4536 23.2014 37.059 23.5475 37.2158 24.1278L37.6075 25.5748L39.0683 25.9628C39.6546 26.1189 40.0045 26.7155 39.8466 27.2982L39.4549 28.7452L40.524 29.8043C40.953 30.2292 40.953 30.9213 40.524 31.3462L39.4549 32.4053L39.8466 33.8523C40.0038 34.4318 39.6564 35.0322 39.0683 35.1877L37.6075 35.5757L37.2158 37.0227C37.0585 37.6025 36.4566 37.9503 35.8678 37.7937L34.407 37.4057L33.3379 38.4648C33.1234 38.6764 32.8419 38.783 32.5596 38.783C32.2781 38.783 31.9958 38.6764 31.7813 38.4639L30.7122 37.4049L29.2514 37.7929C28.6661 37.9478 28.0604 37.6049 27.9034 37.0219L27.5117 35.5749L26.0509 35.1869C25.4646 35.0308 25.1147 34.4341 25.2726 33.8515L25.6643 32.4044L24.5952 31.3454C24.1662 30.9204 24.1662 30.2284 24.5952 29.8034L25.6643 28.7444L25.2726 27.2974C25.1156 26.7187 25.4616 26.1178 26.0509 25.962L27.5117 25.574L27.9034 24.1269C28.0602 23.5466 28.6656 23.2006 29.2514 23.356L30.7122 23.744L31.7813 22.6849C32.2103 22.26 32.9089 22.26 33.3379 22.6849ZM32.5596 26.3282C30.1959 26.3282 28.273 28.233 28.273 30.5744C28.273 32.9159 30.1959 34.8207 32.5596 34.8207C34.9233 34.8207 36.8461 32.9159 36.8461 30.5744C36.8461 28.233 34.9233 26.3282 32.5596 26.3282Z"
                                  fill="#FFDD3C"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M32.5586 27.5039C30.8494 27.5039 29.459 28.8812 29.459 30.5744C29.459 32.2675 30.8494 33.6448 32.5586 33.6448C34.2678 33.6448 35.6582 32.2675 35.6582 30.5744C35.6582 28.8812 34.2678 27.5039 32.5586 27.5039Z"
                                  fill="white"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_1882_30348">
                                  <rect width="42" height="43" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div class="slider_box_right">
                            <div class="slider_box_right_content">
                              <span class="text_white_7"
                                >Formulation & Combination Patents</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_right_center1"
                      >
                        <div
                          class="home_slider_carousel_inner_item_layout_content_box_right_center1_box slider_box transparent_hexagon"
                        >
                          <div class="slider_box_left">
                            <svg
                              width="43"
                              height="43"
                              viewBox="0 0 43 43"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_1882_30415)">
                                <path
                                  d="M14.5893 33.1714V30.407C14.5896 29.0853 13.743 27.9121 12.4885 27.4961L8.84816 26.2828C8.30896 26.1048 7.81956 25.8017 7.41998 25.3983C6.34501 24.3232 4.47532 24.2549 3.78196 25.826L2.2793 29.2107C4.44724 33.3407 7.98517 36.5872 12.2858 38.3928V37.4714C12.2827 36.3483 12.8452 35.2992 13.7823 34.6802C14.2884 34.3455 14.5918 33.7782 14.5893 33.1714Z"
                                  fill="white"
                                />
                                <path
                                  d="M11.5176 3.04802C11.5164 3.30555 11.6463 3.54599 11.8624 3.68612C12.0784 3.83066 12.3529 3.85609 12.5918 3.75369L14.8953 2.76468C15.1751 2.64055 15.3558 2.36358 15.3568 2.05748V0.54248C14.0345 0.855124 12.7479 1.30337 11.5176 1.8801V3.04802Z"
                                  fill="white"
                                />
                                <path
                                  d="M38.6218 14.1672C38.3341 14.8895 37.6331 15.3616 36.8557 15.3567H36.0879C35.8136 15.3631 35.5635 15.5154 35.432 15.7562C35.3004 15.997 35.3073 16.2897 35.45 16.5241C35.5927 16.7584 35.8497 16.8988 36.124 16.8924C36.7284 16.8995 37.2926 17.1963 37.6408 17.6904C37.989 18.1844 38.0788 18.8156 37.8823 19.3872C37.5813 20.2925 37.2274 21.2408 36.8504 22.2037C37.6142 22.3609 38.2948 22.7904 38.7654 23.4123C38.9585 23.6644 39.2184 23.8572 39.5155 23.969C40.2335 20.5016 40.0092 16.9051 38.8659 13.5537L38.6218 14.1672Z"
                                  fill="white"
                                />
                                <path
                                  d="M25.5906 0.812988L22.5031 5.96843C22.2072 6.4896 22.2153 7.1298 22.5243 7.64329C22.8333 8.15677 23.3952 8.46373 23.9942 8.44633H29.1771C29.8222 8.45357 30.4354 8.72846 30.87 9.20529C31.3046 9.68212 31.5216 10.3181 31.4691 10.9611C31.3323 12.1656 30.3048 13.0703 29.0927 13.0535H24.7928C22.2474 13.0118 20.1196 14.98 19.9631 17.521C19.9253 18.7669 20.3939 19.975 21.262 20.8695C22.1301 21.7639 23.3236 22.2685 24.5701 22.2679C25.5885 22.2684 26.5651 22.6726 27.2859 23.3921C27.9945 22.4736 29.1406 22.0048 30.2897 22.1635C30.6673 22.2158 31.0515 22.1398 31.3808 21.9477C32.3901 21.358 33.6388 21.358 34.648 21.9477C34.8258 22.0505 35.0206 22.1207 35.2231 22.155C35.67 21.0401 36.0792 19.9466 36.4255 18.9054C36.4793 18.7442 36.4102 18.4278 36.1806 18.4332C34.9071 18.4588 33.854 17.4473 33.8283 16.1737C33.8027 14.9002 34.8142 13.847 36.0877 13.8214H36.8555C37.0032 13.8223 37.1369 13.7341 37.1941 13.5979L38.0388 11.494C35.6016 6.32192 31.0727 2.43604 25.5906 0.812988Z"
                                  fill="white"
                                />
                                <path
                                  d="M1.59694 16.8926C2.41079 16.8918 3.07034 16.2322 3.07119 15.4183C3.07201 14.7014 3.32724 14.0081 3.79142 13.4618L7.45632 9.19015C7.68381 8.91773 7.73461 8.53886 7.58694 8.21612C7.43926 7.89339 7.11935 7.68416 6.7645 7.67822H4.24522C2.14172 10.3556 0.761297 13.5284 0.236328 16.8926H1.59694Z"
                                  fill="white"
                                />
                                <path
                                  d="M33.0177 26.875C29.6252 26.875 26.875 29.6253 26.875 33.0179C26.875 36.4106 29.6252 39.1608 33.0177 39.1608C36.4102 39.1608 39.1604 36.4106 39.1604 33.0179C39.1566 29.6269 36.4087 26.8788 33.0177 26.875ZM35.8641 32.0251L32.0249 35.8644C31.7251 36.1642 31.239 36.1642 30.9392 35.8644L30.1713 35.0965C29.8803 34.7952 29.8845 34.3163 30.1807 34.0201C30.4769 33.7239 30.9558 33.7198 31.2571 34.0108L31.482 34.2358L34.7784 30.9393C35.0797 30.6483 35.5586 30.6525 35.8547 30.9487C36.1509 31.2449 36.1551 31.7238 35.8641 32.0251Z"
                                  fill="#FFDD3C"
                                />
                                <path
                                  d="M2.38031 25.204C2.96443 23.8856 4.2708 23.0356 5.71273 23.0355C6.68148 23.0382 7.61023 23.4222 8.29804 24.1044C9.4306 25.2432 11.4869 25.5434 12.9734 26.0394C14.8556 26.6636 16.1257 28.424 16.1246 30.407V33.1714C16.1277 34.2944 15.5652 35.3436 14.6281 35.9626C14.122 36.2973 13.8186 36.8646 13.8211 37.4714V38.9572C17.0979 40.0225 20.5956 40.2154 23.9696 39.517C23.8583 39.2196 23.6653 38.9596 23.413 38.7668C22.4788 38.0606 21.9997 36.9044 22.1606 35.7445C22.2123 35.3669 22.1363 34.9828 21.9448 34.6533C21.354 33.6444 21.354 32.395 21.9448 31.3861C22.138 31.0563 22.2148 30.6713 22.1629 30.2926C22.0019 29.1323 22.481 27.9755 23.4153 27.2688C23.7187 27.0394 23.9365 26.715 24.0341 26.3473C24.2837 25.3902 24.9588 24.6005 25.8654 24.205C25.4839 23.9443 25.0329 23.8044 24.5709 23.8034C22.9097 23.8041 21.319 23.132 20.1617 21.9403C19.0043 20.7486 18.3789 19.139 18.4281 17.4785C18.6113 14.1075 21.4179 11.4793 24.7935 11.5176H29.0934C29.5095 11.5307 29.8708 11.2334 29.9381 10.8226C29.9557 10.6087 29.884 10.3969 29.74 10.2376C29.596 10.0784 29.3926 9.98578 29.1779 9.98184H23.995C22.8427 9.99254 21.7732 9.38408 21.1937 8.38804C20.6142 7.39199 20.6137 6.16155 21.1924 5.16502L24.0334 0.418847C21.6832 -0.0694647 19.2645 -0.131366 16.8925 0.236095V2.05747C16.8908 2.97616 16.3456 3.80678 15.5034 4.17371L13.1953 5.16656C12.4828 5.45683 11.673 5.3772 11.0306 4.95371C10.3883 4.53022 9.99595 3.8173 9.98191 3.04802V2.68712C8.36003 3.62781 6.8778 4.79089 5.57836 6.14251H6.76467C7.70802 6.1709 8.55391 6.73115 8.94815 7.58868C9.3424 8.44621 9.21696 9.45305 8.62437 10.1876L4.95948 14.4593C4.73226 14.7272 4.60738 15.067 4.60704 15.4183C4.60535 17.08 3.25875 18.4267 1.59711 18.4284H0.06527C0.0261102 18.9359 1.80829e-06 19.4465 1.80829e-06 19.9641C-0.00107846 22.4951 0.481864 25.0029 1.42281 27.3525L2.38031 25.204Z"
                                  fill="white"
                                />
                                <path
                                  d="M41.6928 28.4942C41.1124 28.0549 40.6972 27.4326 40.5141 26.7281C40.3587 26.1345 39.8953 25.6707 39.3017 25.5149C38.5975 25.3308 37.9755 24.9154 37.5357 24.3355C37.1637 23.8474 36.5583 23.5964 35.9501 23.6782C35.2326 23.7764 34.5028 23.6318 33.8769 23.2674C33.3475 22.9551 32.6903 22.9551 32.1608 23.2674C31.5316 23.6328 30.7987 23.7784 30.0777 23.6812C29.4698 23.6011 28.8654 23.8514 28.4921 24.3378C28.053 24.9184 27.4307 25.3338 26.7261 25.5164C26.1324 25.6719 25.6687 26.1353 25.5129 26.7289C25.3288 27.4332 24.9134 28.0551 24.3335 28.495C23.8437 28.8657 23.5923 29.4721 23.6762 30.0806C23.7741 30.7982 23.6295 31.5279 23.2654 32.1539C22.9532 32.6833 22.9532 33.3406 23.2654 33.87C23.6323 34.4987 23.7781 35.2321 23.6793 35.9533C23.5947 36.5617 23.8459 37.1683 24.3358 37.5389C24.9164 37.978 25.3317 38.6003 25.5144 39.305C25.6698 39.8987 26.1333 40.3624 26.7268 40.5182C27.431 40.7023 28.053 41.1177 28.4929 41.6977C28.8649 42.1858 29.4702 42.4367 30.0784 42.355C30.2248 42.3348 30.3723 42.3245 30.52 42.3242C31.0946 42.324 31.659 42.4764 32.1554 42.7658C32.6849 43.078 33.3421 43.078 33.8716 42.7658C34.5003 42.3991 35.2336 42.2534 35.9547 42.3519C36.5627 42.4327 37.1674 42.1823 37.5403 41.6954C37.9794 41.1147 38.6017 40.6994 39.3063 40.5167C39.9 40.3613 40.3637 39.8978 40.5195 39.3042C40.7036 38.6 41.119 37.978 41.6989 37.5381C42.1887 37.1674 42.4401 36.561 42.3562 35.9525C42.2583 35.2349 42.4029 34.5053 42.767 33.8793V33.8723C43.0765 33.3446 43.0765 32.6908 42.767 32.1631C42.4 31.5345 42.2543 30.801 42.3531 30.0799C42.4368 29.4707 42.1841 28.8639 41.6928 28.4942ZM33.0162 40.6964C28.7755 40.6964 25.3378 37.2585 25.3378 33.0177C25.3378 28.7769 28.7755 25.3391 33.0162 25.3391C37.2569 25.3391 40.6946 28.7769 40.6946 33.0177C40.6899 37.2566 37.2549 40.6917 33.0162 40.6964Z"
                                  fill="#FFDD3C"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_1882_30415">
                                  <rect width="43" height="43" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div class="slider_box_right">
                            <div class="slider_box_right_content">
                              <span class="text_white_7"
                                >Patent Watch for Active Ingredient and
                                Processes</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_right_bottom1"
                      >
                        <div
                          class="home_slider_carousel_inner_item_layout_content_box_right_bottom1_box slider_box transparent_hexagon"
                        >
                          <div class="slider_box_left">
                            <svg
                              width="50"
                              height="50"
                              viewBox="0 0 50 50"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M44.6723 31.7813L37.3051 21.9063C36.7426 21.1484 35.6489 20.9844 34.8833 21.5391L32.8442 23C32.4692 23.2734 32.2192 23.6797 32.1489 24.1406C32.1098 24.4063 32.1255 24.6719 32.2036 24.9219C31.4301 25.1484 30.1801 25.4141 28.7348 25.3359C27.4536 25.2578 26.2036 25.3672 25.0161 25.6485C23.813 25.3672 22.5551 25.2578 21.2661 25.3359C21.0864 25.3438 20.9145 25.3516 20.7426 25.3516C19.5317 25.3516 18.477 25.125 17.7973 24.9219C17.8755 24.6719 17.8911 24.4063 17.852 24.1406C17.7817 23.6797 17.5317 23.2734 17.1567 23L15.1176 21.5391C14.352 20.9844 13.2583 21.1484 12.6958 21.9063L5.32858 31.7813C5.05514 32.1563 4.93796 32.6094 5.00827 33.0703C5.07858 33.5235 5.32858 33.9297 5.70358 34.2031L7.74264 35.6641C8.04733 35.8906 8.40671 35.9922 8.75827 35.9922C9.29733 35.9922 9.82858 35.75 10.1645 35.2969L10.2583 35.1797C10.8755 36.3203 11.7192 37.5234 12.7739 38.7891C12.5239 39.1094 12.3833 39.4453 12.352 39.7969C12.2817 40.7578 12.6645 41.7266 13.3755 42.3984C13.938 42.9297 14.6645 43.2188 15.4067 43.2188C15.4692 43.2188 15.5395 43.2109 15.602 43.2031C15.7426 43.8516 16.0786 44.4688 16.5786 44.9375C17.1567 45.4844 17.8989 45.7813 18.6723 45.7813H18.6958C18.6958 45.7813 18.6958 45.7813 18.7036 45.7813C18.8598 46.3828 19.1723 46.9375 19.6411 47.3594C20.2036 47.875 20.9067 48.1484 21.6411 48.1484C21.7739 48.1484 21.9067 48.1406 22.0473 48.1172C22.5708 48.0469 23.1333 47.7656 23.7192 47.3125C25.688 48.0469 27.2505 48.4219 28.4692 48.4219C29.1723 48.4219 29.7583 48.3047 30.2505 48.0625C31.2426 47.5703 31.6411 46.6953 31.8676 45.9531C32.1645 45.9844 32.4536 46.0078 32.7192 46.0078C33.4067 46.0078 33.9848 45.8906 34.4614 45.6641C35.5239 45.1563 35.9145 44.2188 36.1411 43.4531C36.2348 43.1484 36.2505 42.8281 36.227 42.5078H36.3676C37.0551 42.5078 37.6333 42.3906 38.1098 42.1641C39.1723 41.6563 39.563 40.7109 39.7895 39.9453C40.2114 38.5078 39.2583 37.2578 38.688 36.6719C38.8208 36.2578 39.1098 35.5703 39.6333 35.0313L39.8208 35.2734C40.1567 35.7266 40.688 35.9688 41.227 35.9688C41.5786 35.9688 41.938 35.8672 42.2426 35.6406L44.2817 34.1797C44.6567 33.9063 44.9067 33.5 44.977 33.0469C45.0473 32.5859 44.9301 32.1328 44.6567 31.7578L44.6723 31.7813ZM15.7426 41.5938C15.6958 41.6094 15.6489 41.6328 15.602 41.6406C15.0395 41.7188 14.6411 41.4375 14.4536 41.2578C14.0864 40.9141 13.8833 40.3984 13.9223 39.9219C13.9301 39.7891 14.3051 39.2578 15.8286 38.5859C16.3442 38.3594 16.9536 38.5078 17.313 38.9375C17.563 39.2422 17.6255 39.6406 17.5317 40.0078C16.6255 40.5078 16.0395 41.0313 15.7505 41.5859L15.7426 41.5938ZM19.1255 44.1484C19.1255 44.1484 19.1098 44.1484 19.102 44.1484C19.102 44.1484 19.102 44.1484 19.0942 44.1484C19.0942 44.1484 19.0864 44.1484 19.0786 44.1484C19.0005 44.1719 18.9301 44.1875 18.8755 44.1953C18.2817 44.2813 17.852 43.9766 17.6567 43.7891C17.2661 43.4297 17.0551 42.8906 17.0942 42.3828C17.102 42.25 17.3911 41.8281 18.5005 41.2578C18.5239 41.2422 18.5473 41.2344 18.5708 41.2188C18.727 41.1406 18.8989 41.0625 19.0864 40.9766C19.2583 40.8984 19.438 40.8594 19.6176 40.8594C20.0161 40.8594 20.3989 41.0313 20.6645 41.3594C21.0708 41.8594 21.0395 42.5938 20.5786 43.0625C19.8989 43.7422 19.4223 44.0235 19.1255 44.1328V44.1484ZM23.4536 45.4922C22.8286 46.1328 22.2426 46.5234 21.8442 46.5781C21.4301 46.6328 21.0239 46.5 20.7036 46.2109C20.4536 45.9844 20.2817 45.6797 20.2036 45.3516C20.6801 45.0859 21.1645 44.6875 21.688 44.1641C21.8911 43.9531 22.0551 43.7344 22.1801 43.4844C22.6567 43.3281 23.2036 43.4766 23.5395 43.8828C23.9301 44.3594 23.8911 45.0469 23.4536 45.4844V45.4922ZM38.313 39.5313C38.1098 40.2344 37.8676 40.5781 37.4614 40.7734C36.7348 41.1172 35.0161 41.1719 30.9458 39.4688C30.5473 39.3047 30.0864 39.4922 29.9223 39.8906C29.7583 40.2891 29.9458 40.75 30.3442 40.9141C32.0161 41.6172 33.4301 42.0781 34.6255 42.3281C34.7114 42.5781 34.727 42.8125 34.6645 43.0234C34.4536 43.7266 34.2192 44.0781 33.8051 44.2656C33.0786 44.6094 31.3598 44.6641 27.2817 42.961C26.8833 42.7969 26.4223 42.9844 26.2583 43.3828C26.0942 43.7813 26.2817 44.2344 26.6801 44.4063C28.0708 44.9844 29.2739 45.3984 30.3286 45.6719C30.1411 46.2031 29.9223 46.5 29.5708 46.6719C28.9848 46.961 27.7114 47.0625 24.9458 46.1094C25.5708 45.125 25.5161 43.8359 24.7505 42.8984C24.1801 42.2109 23.3442 41.8516 22.5005 41.8672C22.5005 41.8672 22.5005 41.8672 22.5005 41.8594C22.438 41.336 22.2348 40.8203 21.8833 40.3828C21.2036 39.5547 20.1333 39.1719 19.1176 39.3672C19.0551 38.8594 18.852 38.375 18.5239 37.9609C17.7192 36.9844 16.3442 36.6563 15.2036 37.1641C14.7426 37.3672 14.3364 37.5781 13.9848 37.7891C12.7973 36.3672 11.8911 35.0078 11.313 33.7891L16.9067 26.2891C17.7505 26.5703 19.3989 27.0156 21.3755 26.9063C21.5161 26.8984 21.6567 26.8906 21.8051 26.8984C21.7973 26.8984 21.7973 26.9063 21.7895 26.9063C20.352 27.7344 18.8676 28.3047 17.477 28.8125C17.0239 28.9766 16.6489 29.3281 16.4692 29.7734C16.2817 30.2031 16.2895 30.6953 16.4926 31.1172C17.4301 33.1641 19.3051 33.8281 21.5005 32.9063C26.2583 30.9063 28.727 32.8906 31.3442 34.9844C33.063 36.3594 34.8286 37.7734 37.188 37.7734H37.5708C37.9145 38.125 38.5239 38.8594 38.3208 39.5469L38.313 39.5313ZM37.227 36.2031C35.438 36.2266 33.9536 35.0703 32.313 33.7578C29.7192 31.6797 26.5005 29.1016 20.8833 31.4609C19.4458 32.0625 18.4926 31.7422 17.8989 30.461C17.8989 30.4453 17.8833 30.4141 17.8989 30.3672C17.9145 30.3359 17.938 30.2969 18.0005 30.2734C19.4614 29.75 21.0161 29.1406 22.563 28.25C24.3286 27.2422 26.4301 26.7734 28.6567 26.8984C30.6255 27.0078 32.2739 26.5625 33.1176 26.2813L38.7192 33.7891C37.8755 34.5625 37.438 35.5703 37.227 36.2031Z"
                                fill="white"
                              />
                              <path
                                d="M18.5547 19.625H31.4453C33.1719 19.625 34.5703 18.2188 34.5703 16.5V4.6875C34.5703 2.96094 33.1719 1.5625 31.4453 1.5625H18.5547C16.8281 1.5625 15.4297 2.96094 15.4297 4.6875V16.5C15.4297 18.2188 16.8281 19.625 18.5547 19.625ZM20.5078 3.125H29.4922V8.625C29.4922 8.875 29.3672 9.10938 29.1719 9.25C29.0312 9.35156 28.875 9.40625 28.7109 9.40625C28.625 9.40625 28.5469 9.39062 28.4687 9.36719L25 8.26562L21.5312 9.36719C21.2891 9.44531 21.0312 9.39844 20.8281 9.25C20.6328 9.10938 20.5078 8.875 20.5078 8.625V3.125Z"
                                fill="#FFDD3C"
                              />
                            </svg>
                          </div>
                          <div class="slider_box_right">
                            <div class="slider_box_right_content">
                              <span class="text_white_7"
                                >Global Patent Litigation Update</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="carousel-item" data-bs-interval="2000">
          <div class="home_slider_carousel_inner_item">
            <img
              src="../../../assets/img/carousel_img/carousel_03.webp"
              class="home_slider_carousel_inner_item_img w-100"
              alt="image"
            />
            <img
              src="../../../assets/img/carousel_img/carousel_mobile_03.webp"
              class="home_slider_carousel_inner_item_phoneimg w-100"
              alt="image"
            />
            <div class="home_slider_carousel_inner_item_top carousel-caption">
              <p class="text_white_3">Pharmaceutical Intelligence</p>
              <span class="text_white_4"
                >PharmvetPat Facilitates Progress in Generic and Discovery
                Development by Uncovering New Opportunities in the Field.</span
              >
              <div class="home_slider_carousel_inner_item_top_button">
                <button
                  type="button"
                  class="rounded-pill text_blue_4 button_white_1"
                >
                  <span>View More</span>
                  <img
                    class="home_slider_carousel_inner_item_top_button_icon button_white_1_text_icon"
                    src="../../../assets/icons/video_icon.png"
                  />
                </button>
              </div>
              <div class="home_slider_carousel_inner_item_top_img">
                <div class="home_slider_carousel_inner_item_top_img_body">
                  <div class="home_slider_carousel_inner_item_top_img_body_box">
                    <img
                      width="20%"
                      src="../../../assets/icons/pills_icon.png"
                      alt="image"
                    />
                    <div class="text_white_21">Pharma</div>
                  </div>
                </div>
              </div>
              <div class="home_slider_carousel_inner_item_top_list p-y-11">
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Innovation Intelligence for Pharmaceutical Generic and
                  Discovery Industry
                </div>
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Synthesis Pathways, e.g. Innovator and Commercial Routes
                </div>
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Early Identification of Advanced Pharmaceutical (API)
                  Candidates
                </div>
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Patent Landscape of Innovator & Generic Patents
                </div>
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Patent Watch for Active Ingredient and Processes
                </div>
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Buyer and Supplier Information
                </div>
              </div>
            </div>
            <div
              class="home_slider_carousel_inner_item_button carousel-caption"
            >
              <button
                type="button"
                class="rounded-pill text_blue_4 button_white_1"
                data-bs-toggle="modal"
                data-bs-target="#VideoModel"
                data-bs-dismiss="modal"
                (click)="toggleIntroVideoHome()"
              >
                <span>View More</span>
                <img
                  class="home_slider_carousel_inner_item_button_icon button_white_1_text_icon"
                  src="../../../assets/icons/video_icon.png"
                />
              </button>
            </div>
            <div
              class="home_slider_carousel_inner_item_layout carousel-caption"
            >
              <div class="home_slider_carousel_inner_item_layout_content">
                <div class="home_slider_carousel_inner_item_layout_content_box">
                  <div
                    class="home_slider_carousel_inner_item_layout_content_box_left"
                  >
                    <div
                      class="home_slider_carousel_inner_item_layout_content_box_left_top1"
                    >
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_left_top1_box slider_box transparent_hexagon"
                      >
                        <div class="slider_box_left">
                          <svg
                            width="44"
                            height="45"
                            viewBox="0 0 44 45"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21.375 14.3438L14.1875 17.3125L22 20.4375L29.8125 17.3125L22.625 14.3438C22.1562 14.1875 21.8438 14.1875 21.375 14.3438Z"
                              fill="#FFCD04"
                            />
                            <path
                              d="M14.1875 18.875L21.2188 21.6875V29.8125L15.125 27.1562C14.5 26.8437 14.1875 26.375 14.1875 25.75V18.875Z"
                              fill="#FFCD04"
                            />
                            <path
                              d="M12.1562 34.0313C11.375 33.4063 10.5938 32.625 9.96875 31.8438L6.84375 34.9688C6.21875 34.6562 5.59375 34.5 4.8125 34.5C2.15625 34.5 0.125 36.5313 0.125 39.1875C0.125 41.8438 2.15625 43.875 4.8125 43.875C7.46875 43.875 9.5 41.8438 9.5 39.1875C9.5 38.4063 9.34375 37.7813 9.03125 37.1563L12.1562 34.0313Z"
                              fill="white"
                            />
                            <path
                              d="M9.96875 12.1562C10.5938 11.375 11.375 10.5938 12.1562 9.96875L9.03125 6.84375C9.34375 6.21875 9.5 5.59375 9.5 4.8125C9.5 2.15625 7.46875 0.125 4.8125 0.125C2.15625 0.125 0.125 2.15625 0.125 4.8125C0.125 7.46875 2.15625 9.5 4.8125 9.5C5.59375 9.5 6.21875 9.34375 6.84375 9.03125L9.96875 12.1562Z"
                              fill="white"
                            />
                            <path
                              d="M31.8438 9.96875C32.625 10.5938 33.4063 11.375 34.0313 12.1562L37.1563 9.03125C37.7813 9.34375 38.4063 9.5 39.1875 9.5C41.8438 9.5 43.875 7.46875 43.875 4.8125C43.875 2.15625 41.8438 0.125 39.1875 0.125C36.5313 0.125 34.5 2.15625 34.5 4.8125C34.5 5.59375 34.6562 6.21875 34.9688 6.84375L31.8438 9.96875Z"
                              fill="white"
                            />
                            <path
                              d="M42.7812 37.4688L37.1562 31.8437C36.6875 31.375 35.9062 31.2188 35.2812 31.5312L33.7187 29.8125C35.2812 27.625 36.0625 24.8125 36.0625 22C36.0625 14.1875 29.8125 7.9375 22 7.9375C14.1875 7.9375 7.9375 14.1875 7.9375 22C7.9375 29.8125 14.1875 36.0625 22 36.0625C24.9687 36.0625 27.625 35.125 29.8125 33.7188L31.5312 35.4375C31.2187 36.0625 31.2187 36.6875 31.8437 37.3125L37.4687 42.9375C38.25 43.7188 39.1875 44.0312 40.125 44.0312C41.0625 44.0312 42.1562 43.5625 42.7812 42.9375C44.1875 41.375 44.1875 38.875 42.7812 37.4688ZM11.0625 22C11.0625 15.9062 15.9062 11.0625 22 11.0625C28.0937 11.0625 32.9375 15.9062 32.9375 22C32.9375 28.0938 28.0937 32.9375 22 32.9375C15.9062 32.9375 11.0625 28.0938 11.0625 22Z"
                              fill="white"
                            />
                            <path
                              d="M29.8125 18.875L22.7812 21.6875V29.8125L28.875 27.1562C29.5 26.8437 29.8125 26.375 29.8125 25.75V18.875Z"
                              fill="#FFCD04"
                            />
                          </svg>
                        </div>
                        <div class="slider_box_right">
                          <div class="slider_box_right_content">
                            <span class="text_white_7"
                              >Innovation Intelligence for Pharmaceutical
                              Generic and Discovery Industry</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="home_slider_carousel_inner_item_layout_content_box_left_center2"
                    >
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_left_center1_box slider_box transparent_hexagon"
                      >
                        <div class="slider_box_left">
                          <svg
                            width="38"
                            height="43"
                            viewBox="0 0 38 43"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_1882_30580)">
                              <path
                                d="M37.9996 19.5771C37.9996 20.2726 37.4396 20.837 36.7477 20.837H35.344V34.8107C35.344 39.3261 31.6935 42.9999 27.2068 42.9999C23.1065 42.9999 19.704 39.9309 19.1498 35.9555H24.0504C24.7423 35.9555 25.3023 35.3911 25.3023 34.6957C25.3023 33.9994 24.7423 33.4358 24.0504 33.4358H19.0697V30.916H24.0504C24.7423 30.916 25.3023 30.3516 25.3023 29.6562C25.3023 28.9599 24.7423 28.3963 24.0504 28.3963H19.0697V25.8766H24.0504C24.7423 25.8766 25.3023 25.3121 25.3023 24.6167C25.3023 23.9204 24.7423 23.3569 24.0504 23.3569H19.0697V20.8371H17.6659C16.9741 20.8371 16.4141 20.2726 16.4141 19.5772C16.4141 18.8809 16.9741 18.3174 17.6659 18.3174H36.7477C37.4396 18.3174 37.9996 18.8808 37.9996 19.5771Z"
                                fill="white"
                              />
                              <path
                                d="M15.4722 11.6754L13.5953 14.9469C13.3716 15.3366 12.9585 15.5769 12.5112 15.5769H9.47079L8.33243 17.5095L9.4808 19.5119H12.0964C12.7882 19.5119 13.3482 20.0763 13.3482 20.7717C13.3482 21.4681 12.7882 22.0316 12.0964 22.0316H9.4808L8.32742 24.0432L9.70864 26.4513C10.0542 27.0543 9.84885 27.8246 9.25046 28.1723C8.65457 28.5204 7.88726 28.3164 7.54041 27.7112L6.15918 25.3031H3.128C2.6815 25.3031 2.26755 25.0629 2.04388 24.6731L0.16775 21.4016C-0.0559167 21.0119 -0.0559167 20.5315 0.16775 20.1418L2.04388 16.8711C2.26755 16.4814 2.6815 16.2411 3.128 16.2411H6.16837L7.30756 14.3085L5.79781 11.6753C5.57415 11.2855 5.57415 10.8052 5.79781 10.4155L7.31257 7.77475L5.86708 5.25505H2.79917C2.10731 5.25505 1.54731 4.69059 1.54731 3.9952C1.54731 3.29981 2.10731 2.73535 2.79917 2.73535H6.58983C7.03716 2.73535 7.45028 2.97555 7.67394 3.36532L9.4808 6.51498H12.5112C12.9585 6.51498 13.3716 6.75518 13.5953 7.14495L15.4722 10.4156C15.6959 10.8052 15.6959 11.2857 15.4722 11.6754Z"
                                fill="white"
                              />
                              <path
                                d="M35.7978 1.15264C35.7093 0.623537 35.297 0.208571 34.7712 0.119548C34.586 0.0884734 30.2003 -0.622874 27.7691 1.82367C27.5647 2.02943 27.3777 2.25367 27.2066 2.49555C27.0355 2.25367 26.8486 2.02943 26.6441 1.82367C24.213 -0.622874 19.8273 0.0885573 19.6412 0.119632C19.1154 0.208655 18.7039 0.623537 18.6155 1.15272C18.5838 1.33917 17.8769 5.75196 20.3088 8.1985C21.7454 9.64421 23.9238 10.0672 25.9548 10.0429V15.7977H28.4585V10.0429C30.4892 10.0675 32.6681 9.64387 34.1044 8.1985C36.5355 5.75187 35.8295 1.33908 35.7978 1.15264Z"
                                fill="#FFCD04"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1882_30580">
                                <rect width="38" height="43" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <div class="slider_box_right">
                          <div class="slider_box_right_content">
                            <span class="text_white_7"
                              >Early Identification of Advanced Pharmaceutical
                              (API) Candidates</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="home_slider_carousel_inner_item_layout_content_box_left_bottom2"
                    >
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_left_bottom1_box slider_box transparent_hexagon"
                      >
                        <div class="slider_box_left">
                          <svg
                            width="42"
                            height="43"
                            viewBox="0 0 42 43"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_1882_30549)">
                              <path
                                d="M19.1547 16.7504C19.2053 18.5202 17.7753 19.9769 16.0082 19.9769H12.4107C12.1127 19.9769 11.8711 19.7362 11.8711 19.4394V14.2436C11.8711 13.9467 12.1127 13.7061 12.4107 13.7061H15.9475C17.6608 13.7061 19.106 15.0445 19.1547 16.7504Z"
                                fill="white"
                              />
                              <path
                                d="M22.6888 1.73358C22.4095 0.256533 20.7245 -0.469805 19.4619 0.329812C18.2427 1.10273 16.8045 0.32596 15.3626 0.741893C12.3425 1.61318 11.2075 4.07984 11.847 6.39547C10.7273 7.31862 9.85451 8.57081 9.3836 10.0478C9.11577 9.65584 8.77554 9.27045 8.3862 8.93514C8.81061 7.19195 7.91242 5.38918 5.67102 4.74894C4.5871 4.44131 3.5594 4.98409 2.75078 4.4766C1.71543 3.82784 0.342546 4.42303 0.114737 5.61699C-0.682551 9.79353 2.83586 12.3742 5.69998 11.6544C6.19175 11.5308 6.25363 10.8628 5.79576 10.6455C5.774 10.6352 5.7525 10.6252 5.73128 10.6157C5.38448 10.4589 5.24571 10.0831 5.32117 9.79424C5.43404 9.36228 5.89676 9.11879 6.30597 9.29975C8.07089 10.0796 9.04598 11.859 8.99328 13.477V13.7063H3.47836C1.76507 13.7063 0.319792 15.0447 0.270327 16.7504C0.220142 18.5212 1.64977 19.9771 3.41721 19.9771H8.27378C8.47254 19.9771 8.65242 20.0578 8.78282 20.1868C9.24204 20.6474 8.90298 21.4105 8.24617 21.4105H3.23733C2.93928 21.4105 2.69772 21.6511 2.69772 21.948V27.2629C2.69772 27.6741 3.1411 27.9312 3.50175 27.7314C5.64188 26.549 6.15443 25.3011 8.99328 25.061C9.3416 25.0312 9.59891 25.0201 9.87897 25.0275C10.1827 25.0356 10.4323 24.7901 10.4323 24.4874C10.4323 22.6651 10.4465 14.0334 10.4323 12.617C10.4056 9.95657 11.9838 7.38411 14.6908 6.39278L14.6944 6.39189C15.0982 6.24766 15.5389 6.48505 15.6369 6.90251C15.7194 7.26048 15.5236 7.61317 15.1899 7.73653C14.7507 7.89894 14.3409 8.11537 13.9675 8.38287C13.6527 8.60835 13.6747 9.08054 14.0061 9.2812C17.7531 11.55 23.8968 8.13956 22.6888 1.73358Z"
                                fill="white"
                              />
                              <path
                                d="M15.2884 29.0201C12.7577 27.6416 12.6755 26.4574 9.71232 26.458C7.72949 26.4585 7.05379 27.0098 6.03211 27.7704C5.54897 28.1306 3.92877 29.2434 3.04991 29.5642C2.83757 29.6417 2.69727 29.8429 2.69727 30.0681V35.9239C2.69727 39.7708 5.78128 42.9629 9.64325 43.0001C13.543 43.0377 16.7274 39.8888 16.7274 36.013V30.0501C16.7274 29.8304 16.5939 29.6331 16.389 29.5517C16.0033 29.3983 15.4606 29.1135 15.2884 29.0201ZM10.8221 29.8622L11.0919 29.5934C11.3734 29.3139 11.8285 29.3139 12.11 29.5934C12.3906 29.8738 12.3906 30.3271 12.11 30.6075L11.8402 30.8762C11.5588 31.1547 11.1057 31.1568 10.8221 30.8762C10.5415 30.5958 10.5415 30.1426 10.8221 29.8622ZM9.29321 33.1767L9.56302 32.908C9.84453 32.6285 10.2996 32.6285 10.5811 32.908C10.8617 33.1884 10.8617 33.6417 10.5811 33.9221L10.3113 34.1908C10.0299 34.4692 9.57678 34.4714 9.29321 34.1908C9.01261 33.9104 9.01261 33.4571 9.29321 33.1767ZM7.22467 29.8622L7.49448 29.5934C7.77598 29.3139 8.23106 29.3139 8.51257 29.5934C8.79317 29.8738 8.79317 30.3271 8.51257 30.6075L8.24275 30.8762C7.96134 31.1547 7.50824 31.1568 7.22467 30.8762C6.94407 30.5958 6.94407 30.1426 7.22467 29.8622Z"
                                fill="white"
                              />
                              <path
                                d="M36.514 33.9522H25.9914C25.7189 33.9522 25.4698 33.7988 25.3479 33.5561L23.7481 30.3689H19.8757C19.4784 30.3689 19.1562 30.048 19.1562 29.6522C19.1562 29.2564 19.4784 28.9355 19.8757 28.9355H24.1927C24.4652 28.9355 24.7143 29.0889 24.8362 29.3317L26.4361 32.5189H36.514C36.9114 32.5189 37.2335 32.8397 37.2335 33.2355C37.2335 33.6313 36.9114 33.9522 36.514 33.9522Z"
                                fill="white"
                              />
                              <path
                                d="M33.9081 38.4314H33.8211C33.4237 38.4314 33.1016 38.1105 33.1016 37.7147C33.1016 37.3189 33.4237 36.998 33.8211 36.998H33.9081C34.3055 36.998 34.6276 37.3189 34.6276 37.7147C34.6276 38.1105 34.3055 38.4314 33.9081 38.4314Z"
                                fill="white"
                              />
                              <path
                                d="M30.8504 38.4314H25.991C25.5936 38.4314 25.2715 38.1105 25.2715 37.7147C25.2715 37.3189 25.5936 36.998 25.991 36.998H30.8504C31.2478 36.998 31.5699 37.3189 31.5699 37.7147C31.5699 38.1105 31.2478 38.4314 30.8504 38.4314Z"
                                fill="white"
                              />
                              <path
                                d="M36.5135 42.9997H30.0671C29.6698 42.9997 29.3477 42.6788 29.3477 42.2831C29.3477 41.8873 29.6698 41.5664 30.0671 41.5664H36.5135C36.9109 41.5664 37.233 41.8873 37.233 42.2831C37.233 42.6788 36.9109 42.9997 36.5135 42.9997Z"
                                fill="white"
                              />
                              <path
                                d="M26.812 42.9997H25.991C25.5936 42.9997 25.2715 42.6788 25.2715 42.2831C25.2715 41.8873 25.5936 41.5664 25.991 41.5664H26.812C27.2093 41.5664 27.5315 41.8873 27.5315 42.2831C27.5315 42.6788 27.2093 42.9997 26.812 42.9997Z"
                                fill="white"
                              />
                              <path
                                d="M39.8416 0.895829H32.3768C31.187 0.895829 30.2184 1.86064 30.2184 3.04582V9.22704H27.7001V2.14999C27.7001 1.04561 26.8451 0 25.4517 0C25.0542 0 24.7322 0.320707 24.7322 0.716663C24.7322 1.11262 25.0542 1.43333 25.4517 1.43333H25.5417C25.9383 1.43333 26.2612 1.75493 26.2612 2.14999V17.827C26.2612 18.2221 25.9383 18.5437 25.5417 18.5437H21.8543C21.4567 18.5437 21.1348 18.8644 21.1348 19.2603C21.1348 19.6563 21.4567 19.977 21.8543 19.977H25.5417C26.7315 19.977 27.7001 19.0122 27.7001 17.827V10.6604H30.2184V16.8416C30.2184 18.0268 31.187 18.9916 32.3768 18.9916H39.8416C41.0314 18.9916 42.0001 18.0268 42.0001 16.8416V3.04582C42.0001 1.86064 41.0314 0.895829 39.8416 0.895829ZM36.424 14.8708H34.8051C34.4078 14.8708 34.0856 14.5499 34.0856 14.1541C34.0856 13.7583 34.4078 13.4374 34.8051 13.4374H36.424C36.8213 13.4374 37.1435 13.7583 37.1435 14.1541C37.1435 14.5499 36.8213 14.8708 36.424 14.8708ZM37.5032 10.6604H34.8051C34.4078 10.6604 34.0856 10.3395 34.0856 9.9437C34.0856 9.54792 34.4078 9.22704 34.8051 9.22704H37.5032C37.9006 9.22704 38.2227 9.54792 38.2227 9.9437C38.2227 10.3395 37.9006 10.6604 37.5032 10.6604ZM37.5032 6.44997H34.8051C34.4078 6.44997 34.0856 6.12908 34.0856 5.73331C34.0856 5.33753 34.4078 5.01664 34.8051 5.01664H37.5032C37.9006 5.01664 38.2227 5.33753 38.2227 5.73331C38.2227 6.12908 37.9006 6.44997 37.5032 6.44997Z"
                                fill="#FFCD04"
                              />
                              <path
                                d="M16.7276 21.9475V26.9521C16.7276 27.5062 16.1215 27.8533 15.6434 27.5701C14.2274 26.7312 13.5613 25.9078 12.2256 25.4276C12.0127 25.351 11.8711 25.1487 11.8711 24.9232V21.9477C11.8711 21.6508 12.1127 21.4102 12.4107 21.4102H16.188C16.486 21.41 16.7276 21.6506 16.7276 21.9475Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1882_30549">
                                <rect width="42" height="43" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <div class="slider_box_right">
                          <div class="slider_box_right_content">
                            <span class="text_white_7"
                              >Patent Watch for Active Ingredient and
                              Processes</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="home_slider_carousel_inner_item_layout_content_box_center"
                  >
                    <div
                      class="home_slider_carousel_inner_item_layout_content_box_center_body"
                    >
                      <img
                        width="20%"
                        src="../../../assets/icons/pills_icon.png"
                        alt="image"
                      />
                      <div class="text_white_20">Pharma</div>
                    </div>
                  </div>
                  <div
                    class="home_slider_carousel_inner_item_layout_content_box_right"
                  >
                    <div
                      class="home_slider_carousel_inner_item_layout_content_box_right"
                    >
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_right_top1"
                      >
                        <div
                          class="home_slider_carousel_inner_item_layout_content_box_right_top1_box slider_box transparent_hexagon"
                        >
                          <div class="slider_box_left">
                            <svg
                              width="42"
                              height="43"
                              viewBox="0 0 42 43"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_1882_30530)">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M4.02879 0H27.7796C30.7427 0 33.153 2.38771 33.153 5.32294V21.2955C32.3966 21.0929 31.554 21.2853 30.9612 21.8726L30.3656 22.4625L29.5517 22.2463C28.3527 21.9279 27.1046 22.6418 26.7831 23.8295L26.5648 24.6361L25.7505 24.8524C24.5419 25.1734 23.8301 26.4045 24.1523 27.595L24.3706 28.4012L23.775 28.9911C22.8934 29.8644 22.8934 31.2845 23.775 32.1579L24.3706 32.7478L24.1523 33.554C23.9998 34.1174 24.0748 34.7141 24.3609 35.2228L23.7651 36.2451H7.46502C7.1369 36.2451 6.87153 35.9823 6.87153 35.6572L6.87194 5.04879C6.87216 2.94872 6.41696 0.230932 4.02879 0ZM5.71179 9.61034H0.593486C0.265392 9.61034 0 9.34747 0 9.02243V3.99177C0 -0.168957 4.98766 -1.23216 5.62998 3.67388C5.68954 4.12868 5.7122 4.59022 5.7122 5.04864L5.71179 9.61034ZM24.6427 6.13253H15.382C15.0539 6.13253 14.7885 5.86968 14.7885 5.54463C14.7885 5.21959 15.0538 4.95672 15.382 4.95672L24.6436 4.95675C24.9716 4.95675 25.237 5.21962 25.237 5.54465C25.237 5.8697 24.9708 6.13253 24.6427 6.13253ZM28.7012 11.164H11.3235C10.9954 11.164 10.73 10.9012 10.73 10.5761C10.73 10.2511 10.9953 9.98824 11.3235 9.98824L28.702 9.98827C29.0301 9.98827 29.2955 10.2511 29.2955 10.5762C29.2955 10.9012 29.0293 11.164 28.7012 11.164ZM28.7012 16.1947H11.3235C10.9954 16.1947 10.73 15.9318 10.73 15.6068C10.73 15.2818 10.9953 15.0189 11.3235 15.0189L28.702 15.0189C29.0301 15.0189 29.2955 15.2818 29.2955 15.6068C29.2955 15.9319 29.0293 16.1947 28.7012 16.1947ZM28.7012 21.2262H11.3235C10.9954 21.2262 10.73 20.9633 10.73 20.6383C10.73 20.3132 10.9953 20.0504 11.3235 20.0504L28.702 20.0504C29.0301 20.0504 29.2955 20.3133 29.2955 20.6383C29.2955 20.9634 29.0293 21.2262 28.7012 21.2262ZM23.014 26.2568H11.3226C10.9945 26.2568 10.7291 25.994 10.7291 25.6689C10.7291 25.3439 10.9945 25.081 11.3226 25.081L23.014 25.0811C23.3421 25.0811 23.6075 25.3439 23.6075 25.669C23.6075 25.994 23.3421 26.2568 23.014 26.2568ZM21.4913 31.2875H11.3234C10.9953 31.2875 10.73 31.0247 10.73 30.6996C10.73 30.3746 10.9953 30.1117 11.3234 30.1117H21.4913C21.8194 30.1117 22.0848 30.3746 22.0848 30.6996C22.0848 31.0247 21.8194 31.2875 21.4913 31.2875Z"
                                  fill="white"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M36.8493 42.9998C36.639 42.9998 36.4423 42.889 36.3355 42.7059L34.2715 39.1644L34.7532 38.6872L35.5671 38.9033C36.7724 39.2235 38.0127 38.5139 38.3358 37.3202L38.5541 36.5136C38.9939 36.3968 39.5408 36.2872 39.915 36.0732L41.9192 39.512C42.1766 39.9538 41.7781 40.4914 41.2758 40.3795L38.3186 39.7211L37.4165 42.5866C37.3392 42.8317 37.1077 42.9998 36.8493 42.9998Z"
                                  fill="#FFCD04"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M28.2702 43.0004C28.0033 43.0004 27.7698 42.8254 27.6979 42.5712L26.8628 39.6149L23.8607 40.3767C23.3539 40.5053 22.9387 39.962 23.1994 39.5133L25.2044 36.0732C25.5783 36.287 26.125 36.3965 26.5645 36.5133L26.7828 37.3199C27.1067 38.5164 28.3489 39.2224 29.5515 38.903L30.3654 38.6868L30.8477 39.1647L28.7831 42.7073C28.6771 42.8895 28.4796 43.0004 28.2702 43.0004Z"
                                  fill="#FFCD04"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M33.3379 22.6849L34.407 23.7448L35.8678 23.3568C36.4536 23.2014 37.059 23.5475 37.2158 24.1278L37.6075 25.5748L39.0683 25.9628C39.6546 26.1189 40.0045 26.7155 39.8466 27.2982L39.4549 28.7452L40.524 29.8043C40.953 30.2292 40.953 30.9213 40.524 31.3462L39.4549 32.4053L39.8466 33.8523C40.0038 34.4318 39.6564 35.0322 39.0683 35.1877L37.6075 35.5757L37.2158 37.0227C37.0585 37.6025 36.4566 37.9503 35.8678 37.7937L34.407 37.4057L33.3379 38.4648C33.1234 38.6764 32.8419 38.783 32.5596 38.783C32.2781 38.783 31.9958 38.6764 31.7813 38.4639L30.7122 37.4049L29.2514 37.7929C28.6661 37.9478 28.0604 37.6049 27.9034 37.0219L27.5117 35.5749L26.0509 35.1869C25.4646 35.0308 25.1147 34.4341 25.2726 33.8515L25.6643 32.4044L24.5952 31.3454C24.1662 30.9204 24.1662 30.2284 24.5952 29.8034L25.6643 28.7444L25.2726 27.2974C25.1156 26.7187 25.4616 26.1178 26.0509 25.962L27.5117 25.574L27.9034 24.1269C28.0602 23.5466 28.6656 23.2006 29.2514 23.356L30.7122 23.744L31.7813 22.6849C32.2103 22.26 32.9089 22.26 33.3379 22.6849ZM32.5596 26.3282C30.1959 26.3282 28.273 28.233 28.273 30.5744C28.273 32.9159 30.1959 34.8207 32.5596 34.8207C34.9233 34.8207 36.8461 32.9159 36.8461 30.5744C36.8461 28.233 34.9233 26.3282 32.5596 26.3282Z"
                                  fill="#FFCD04"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M32.5586 27.5039C30.8494 27.5039 29.459 28.8812 29.459 30.5744C29.459 32.2675 30.8494 33.6448 32.5586 33.6448C34.2678 33.6448 35.6582 32.2675 35.6582 30.5744C35.6582 28.8812 34.2678 27.5039 32.5586 27.5039Z"
                                  fill="white"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_1882_30530">
                                  <rect width="42" height="43" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div class="slider_box_right">
                            <div class="slider_box_right_content">
                              <span class="text_white_7"
                                >Synthesis Pathways, e.g. Innovator and
                                Commercial Routes</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_right_center2"
                      >
                        <div
                          class="home_slider_carousel_inner_item_layout_content_box_right_center1_box slider_box transparent_hexagon"
                        >
                          <div class="slider_box_left">
                            <svg
                              width="43"
                              height="43"
                              viewBox="0 0 43 43"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_1882_30597)">
                                <path
                                  d="M14.5893 33.1714V30.407C14.5896 29.0853 13.743 27.9121 12.4885 27.4961L8.84816 26.2828C8.30896 26.1048 7.81956 25.8017 7.41998 25.3983C6.34501 24.3232 4.47532 24.2549 3.78196 25.826L2.2793 29.2107C4.44724 33.3407 7.98517 36.5872 12.2858 38.3928V37.4714C12.2827 36.3483 12.8452 35.2992 13.7823 34.6802C14.2884 34.3455 14.5918 33.7782 14.5893 33.1714Z"
                                  fill="white"
                                />
                                <path
                                  d="M11.5176 3.04754C11.5164 3.30506 11.6463 3.5455 11.8624 3.68563C12.0784 3.83018 12.3529 3.8556 12.5918 3.7532L14.8953 2.76419C15.1751 2.64006 15.3558 2.36309 15.3568 2.05699V0.541992C14.0345 0.854636 12.7479 1.30288 11.5176 1.87961V3.04754Z"
                                  fill="white"
                                />
                                <path
                                  d="M38.6218 14.1672C38.3341 14.8895 37.6331 15.3616 36.8557 15.3567H36.0879C35.8136 15.3631 35.5635 15.5154 35.432 15.7562C35.3004 15.997 35.3073 16.2897 35.45 16.5241C35.5927 16.7584 35.8497 16.8988 36.124 16.8924C36.7284 16.8995 37.2926 17.1963 37.6408 17.6904C37.989 18.1844 38.0788 18.8156 37.8823 19.3872C37.5813 20.2925 37.2274 21.2408 36.8504 22.2037C37.6142 22.3609 38.2948 22.7904 38.7654 23.4123C38.9585 23.6644 39.2184 23.8572 39.5155 23.969C40.2335 20.5016 40.0092 16.9051 38.8659 13.5537L38.6218 14.1672Z"
                                  fill="white"
                                />
                                <path
                                  d="M25.5906 0.8125L22.5031 5.96795C22.2072 6.48911 22.2153 7.12932 22.5243 7.6428C22.8333 8.15628 23.3952 8.46325 23.9942 8.44585H29.1771C29.8222 8.45308 30.4354 8.72797 30.87 9.2048C31.3046 9.68163 31.5216 10.3176 31.4691 10.9606C31.3323 12.1651 30.3048 13.0699 29.0927 13.053H24.7928C22.2474 13.0113 20.1196 14.9795 19.9631 17.5205C19.9253 18.7664 20.3939 19.9745 21.262 20.869C22.1301 21.7635 23.3236 22.268 24.5701 22.2674C25.5885 22.2679 26.5651 22.6721 27.2859 23.3916C27.9945 22.4731 29.1406 22.0043 30.2897 22.163C30.6673 22.2153 31.0515 22.1393 31.3808 21.9472C32.3901 21.3575 33.6388 21.3575 34.648 21.9472C34.8258 22.05 35.0206 22.1202 35.2231 22.1545C35.67 21.0396 36.0792 19.9462 36.4255 18.9049C36.4793 18.7437 36.4102 18.4273 36.1806 18.4327C34.9071 18.4584 33.854 17.4468 33.8283 16.1733C33.8027 14.8997 34.8142 13.8466 36.0877 13.8209H36.8555C37.0032 13.8219 37.1369 13.7336 37.1941 13.5975L38.0388 11.4935C35.6016 6.32143 31.0727 2.43555 25.5906 0.8125Z"
                                  fill="white"
                                />
                                <path
                                  d="M1.59694 16.8931C2.41079 16.8922 3.07034 16.2327 3.07119 15.4188C3.07201 14.7019 3.32724 14.0086 3.79142 13.4623L7.45632 9.19064C7.68381 8.91821 7.73461 8.53935 7.58694 8.21661C7.43926 7.89388 7.11935 7.68465 6.7645 7.67871H4.24522C2.14172 10.3561 0.761297 13.5289 0.236328 16.8931H1.59694Z"
                                  fill="white"
                                />
                                <path
                                  d="M33.0177 26.875C29.6252 26.875 26.875 29.6253 26.875 33.0179C26.875 36.4106 29.6252 39.1608 33.0177 39.1608C36.4102 39.1608 39.1604 36.4106 39.1604 33.0179C39.1566 29.6269 36.4087 26.8788 33.0177 26.875ZM35.8641 32.0251L32.0249 35.8644C31.7251 36.1642 31.239 36.1642 30.9392 35.8644L30.1713 35.0965C29.8803 34.7952 29.8845 34.3163 30.1807 34.0201C30.4769 33.7239 30.9558 33.7198 31.2571 34.0108L31.482 34.2358L34.7784 30.9393C35.0797 30.6483 35.5586 30.6525 35.8547 30.9487C36.1509 31.2449 36.1551 31.7238 35.8641 32.0251Z"
                                  fill="#FFCD04"
                                />
                                <path
                                  d="M2.38031 25.204C2.96443 23.8856 4.2708 23.0356 5.71273 23.0355C6.68148 23.0382 7.61023 23.4222 8.29804 24.1044C9.4306 25.2432 11.4869 25.5434 12.9734 26.0394C14.8556 26.6636 16.1257 28.424 16.1246 30.407V33.1714C16.1277 34.2944 15.5652 35.3436 14.6281 35.9626C14.122 36.2973 13.8186 36.8646 13.8211 37.4714V38.9572C17.0979 40.0225 20.5956 40.2154 23.9696 39.517C23.8583 39.2196 23.6653 38.9596 23.413 38.7668C22.4788 38.0606 21.9997 36.9044 22.1606 35.7445C22.2123 35.3669 22.1363 34.9828 21.9448 34.6533C21.354 33.6444 21.354 32.395 21.9448 31.3861C22.138 31.0563 22.2148 30.6713 22.1629 30.2926C22.0019 29.1323 22.481 27.9755 23.4153 27.2688C23.7187 27.0394 23.9365 26.715 24.0341 26.3473C24.2837 25.3902 24.9588 24.6005 25.8654 24.205C25.4839 23.9443 25.0329 23.8044 24.5709 23.8034C22.9097 23.8041 21.319 23.132 20.1617 21.9403C19.0043 20.7486 18.3789 19.139 18.4281 17.4785C18.6113 14.1075 21.4179 11.4793 24.7935 11.5176H29.0934C29.5095 11.5307 29.8708 11.2334 29.9381 10.8226C29.9557 10.6087 29.884 10.3969 29.74 10.2376C29.596 10.0784 29.3926 9.98578 29.1779 9.98184H23.995C22.8427 9.99254 21.7732 9.38408 21.1937 8.38804C20.6142 7.39199 20.6137 6.16155 21.1924 5.16502L24.0334 0.418847C21.6832 -0.0694647 19.2645 -0.131366 16.8925 0.236095V2.05747C16.8908 2.97616 16.3456 3.80678 15.5034 4.17371L13.1953 5.16656C12.4828 5.45683 11.673 5.3772 11.0306 4.95371C10.3883 4.53022 9.99595 3.8173 9.98191 3.04802V2.68712C8.36003 3.62781 6.8778 4.79089 5.57836 6.14251H6.76467C7.70802 6.1709 8.55391 6.73115 8.94815 7.58868C9.3424 8.44621 9.21696 9.45305 8.62437 10.1876L4.95948 14.4593C4.73226 14.7272 4.60738 15.067 4.60704 15.4183C4.60535 17.08 3.25875 18.4267 1.59711 18.4284H0.06527C0.0261102 18.9359 1.80829e-06 19.4465 1.80829e-06 19.9641C-0.00107846 22.4951 0.481864 25.0029 1.42281 27.3525L2.38031 25.204Z"
                                  fill="white"
                                />
                                <path
                                  d="M41.6928 28.4942C41.1124 28.0549 40.6972 27.4326 40.5141 26.7281C40.3587 26.1345 39.8953 25.6707 39.3017 25.5149C38.5975 25.3308 37.9755 24.9154 37.5357 24.3355C37.1637 23.8474 36.5583 23.5964 35.9501 23.6782C35.2326 23.7764 34.5028 23.6318 33.8769 23.2674C33.3475 22.9551 32.6903 22.9551 32.1608 23.2674C31.5316 23.6328 30.7987 23.7784 30.0777 23.6812C29.4698 23.6011 28.8654 23.8514 28.4921 24.3378C28.053 24.9184 27.4307 25.3338 26.7261 25.5164C26.1324 25.6719 25.6687 26.1353 25.5129 26.7289C25.3288 27.4332 24.9134 28.0551 24.3335 28.495C23.8437 28.8657 23.5923 29.4721 23.6762 30.0806C23.7741 30.7982 23.6295 31.5279 23.2654 32.1539C22.9532 32.6833 22.9532 33.3406 23.2654 33.87C23.6323 34.4987 23.7781 35.2321 23.6793 35.9533C23.5947 36.5617 23.8459 37.1683 24.3358 37.5389C24.9164 37.978 25.3317 38.6003 25.5144 39.305C25.6698 39.8987 26.1333 40.3624 26.7268 40.5182C27.431 40.7023 28.053 41.1177 28.4929 41.6977C28.8649 42.1858 29.4702 42.4367 30.0784 42.355C30.2248 42.3348 30.3723 42.3245 30.52 42.3242C31.0946 42.324 31.659 42.4764 32.1554 42.7658C32.6849 43.078 33.3421 43.078 33.8716 42.7658C34.5003 42.3991 35.2336 42.2534 35.9547 42.3519C36.5627 42.4327 37.1674 42.1823 37.5403 41.6954C37.9794 41.1147 38.6017 40.6994 39.3063 40.5167C39.9 40.3613 40.3637 39.8978 40.5195 39.3042C40.7036 38.6 41.119 37.978 41.6989 37.5381C42.1887 37.1674 42.4401 36.561 42.3562 35.9525C42.2583 35.2349 42.4029 34.5053 42.767 33.8793V33.8723C43.0765 33.3446 43.0765 32.6908 42.767 32.1631C42.4 31.5345 42.2543 30.801 42.3531 30.0799C42.4368 29.4707 42.1841 28.8639 41.6928 28.4942ZM33.0162 40.6964C28.7755 40.6964 25.3378 37.2585 25.3378 33.0177C25.3378 28.7769 28.7755 25.3391 33.0162 25.3391C37.2569 25.3391 40.6946 28.7769 40.6946 33.0177C40.6899 37.2566 37.2549 40.6917 33.0162 40.6964Z"
                                  fill="#FFCD04"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_1882_30597">
                                  <rect width="43" height="43" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div class="slider_box_right">
                            <div class="slider_box_right_content">
                              <span class="text_white_7"
                                >Patent Landscape of Innovator & Generic
                                Patents</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_right_bottom2"
                      >
                        <div
                          class="home_slider_carousel_inner_item_layout_content_box_right_bottom1_box slider_box transparent_hexagon"
                        >
                          <div class="slider_box_left">
                            <svg
                              width="50"
                              height="50"
                              viewBox="0 0 50 50"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M44.6723 31.7808L37.3051 21.9058C36.7426 21.148 35.6489 20.9839 34.8833 21.5386L32.8442 22.9995C32.4692 23.273 32.2192 23.6792 32.1489 24.1401C32.1098 24.4058 32.1255 24.6714 32.2036 24.9214C31.4301 25.148 30.1801 25.4136 28.7348 25.3355C27.4536 25.2573 26.2036 25.3667 25.0161 25.648C23.813 25.3667 22.5551 25.2573 21.2661 25.3355C21.0864 25.3433 20.9145 25.3511 20.7426 25.3511C19.5317 25.3511 18.477 25.1245 17.7973 24.9214C17.8755 24.6714 17.8911 24.4058 17.852 24.1401C17.7817 23.6792 17.5317 23.273 17.1567 22.9995L15.1176 21.5386C14.352 20.9839 13.2583 21.148 12.6958 21.9058L5.32858 31.7808C5.05514 32.1558 4.93796 32.6089 5.00827 33.0698C5.07858 33.523 5.32858 33.9292 5.70358 34.2026L7.74264 35.6636C8.04733 35.8901 8.40671 35.9917 8.75827 35.9917C9.29733 35.9917 9.82858 35.7495 10.1645 35.2964L10.2583 35.1792C10.8755 36.3198 11.7192 37.523 12.7739 38.7886C12.5239 39.1089 12.3833 39.4448 12.352 39.7964C12.2817 40.7573 12.6645 41.7261 13.3755 42.398C13.938 42.9292 14.6645 43.2183 15.4067 43.2183C15.4692 43.2183 15.5395 43.2105 15.602 43.2026C15.7426 43.8511 16.0786 44.4683 16.5786 44.937C17.1567 45.4839 17.8989 45.7808 18.6723 45.7808H18.6958C18.6958 45.7808 18.6958 45.7808 18.7036 45.7808C18.8598 46.3823 19.1723 46.937 19.6411 47.3589C20.2036 47.8745 20.9067 48.148 21.6411 48.148C21.7739 48.148 21.9067 48.1401 22.0473 48.1167C22.5708 48.0464 23.1333 47.7651 23.7192 47.312C25.688 48.0464 27.2505 48.4214 28.4692 48.4214C29.1723 48.4214 29.7583 48.3042 30.2505 48.062C31.2426 47.5698 31.6411 46.6948 31.8676 45.9526C32.1645 45.9839 32.4536 46.0073 32.7192 46.0073C33.4067 46.0073 33.9848 45.8901 34.4614 45.6636C35.5239 45.1558 35.9145 44.2183 36.1411 43.4526C36.2348 43.148 36.2505 42.8276 36.227 42.5073H36.3676C37.0551 42.5073 37.6333 42.3901 38.1098 42.1636C39.1723 41.6558 39.563 40.7105 39.7895 39.9448C40.2114 38.5073 39.2583 37.2573 38.688 36.6714C38.8208 36.2573 39.1098 35.5698 39.6333 35.0308L39.8208 35.273C40.1567 35.7261 40.688 35.9683 41.227 35.9683C41.5786 35.9683 41.938 35.8667 42.2426 35.6401L44.2817 34.1792C44.6567 33.9058 44.9067 33.4995 44.977 33.0464C45.0473 32.5855 44.9301 32.1323 44.6567 31.7573L44.6723 31.7808ZM15.7426 41.5933C15.6958 41.6089 15.6489 41.6323 15.602 41.6401C15.0395 41.7183 14.6411 41.437 14.4536 41.2573C14.0864 40.9136 13.8833 40.398 13.9223 39.9214C13.9301 39.7886 14.3051 39.2573 15.8286 38.5855C16.3442 38.3589 16.9536 38.5073 17.313 38.937C17.563 39.2417 17.6255 39.6401 17.5317 40.0073C16.6255 40.5073 16.0395 41.0308 15.7505 41.5855L15.7426 41.5933ZM19.1255 44.148C19.1255 44.148 19.1098 44.148 19.102 44.148C19.102 44.148 19.102 44.148 19.0942 44.148C19.0942 44.148 19.0864 44.148 19.0786 44.148C19.0005 44.1714 18.9301 44.187 18.8755 44.1948C18.2817 44.2808 17.852 43.9761 17.6567 43.7886C17.2661 43.4292 17.0551 42.8901 17.0942 42.3823C17.102 42.2495 17.3911 41.8276 18.5005 41.2573C18.5239 41.2417 18.5473 41.2339 18.5708 41.2183C18.727 41.1401 18.8989 41.062 19.0864 40.9761C19.2583 40.898 19.438 40.8589 19.6176 40.8589C20.0161 40.8589 20.3989 41.0308 20.6645 41.3589C21.0708 41.8589 21.0395 42.5933 20.5786 43.062C19.8989 43.7417 19.4223 44.023 19.1255 44.1323V44.148ZM23.4536 45.4917C22.8286 46.1323 22.2426 46.523 21.8442 46.5776C21.4301 46.6323 21.0239 46.4995 20.7036 46.2105C20.4536 45.9839 20.2817 45.6792 20.2036 45.3511C20.6801 45.0855 21.1645 44.687 21.688 44.1636C21.8911 43.9526 22.0551 43.7339 22.1801 43.4839C22.6567 43.3276 23.2036 43.4761 23.5395 43.8823C23.9301 44.3589 23.8911 45.0464 23.4536 45.4839V45.4917ZM38.313 39.5308C38.1098 40.2339 37.8676 40.5776 37.4614 40.773C36.7348 41.1167 35.0161 41.1714 30.9458 39.4683C30.5473 39.3042 30.0864 39.4917 29.9223 39.8901C29.7583 40.2886 29.9458 40.7495 30.3442 40.9136C32.0161 41.6167 33.4301 42.0776 34.6255 42.3276C34.7114 42.5776 34.727 42.812 34.6645 43.023C34.4536 43.7261 34.2192 44.0776 33.8051 44.2651C33.0786 44.6089 31.3598 44.6636 27.2817 42.9605C26.8833 42.7964 26.4223 42.9839 26.2583 43.3823C26.0942 43.7808 26.2817 44.2339 26.6801 44.4058C28.0708 44.9839 29.2739 45.398 30.3286 45.6714C30.1411 46.2026 29.9223 46.4995 29.5708 46.6714C28.9848 46.9605 27.7114 47.062 24.9458 46.1089C25.5708 45.1245 25.5161 43.8355 24.7505 42.898C24.1801 42.2105 23.3442 41.8511 22.5005 41.8667C22.5005 41.8667 22.5005 41.8667 22.5005 41.8589C22.438 41.3355 22.2348 40.8198 21.8833 40.3823C21.2036 39.5542 20.1333 39.1714 19.1176 39.3667C19.0551 38.8589 18.852 38.3745 18.5239 37.9605C17.7192 36.9839 16.3442 36.6558 15.2036 37.1636C14.7426 37.3667 14.3364 37.5776 13.9848 37.7886C12.7973 36.3667 11.8911 35.0073 11.313 33.7886L16.9067 26.2886C17.7505 26.5698 19.3989 27.0151 21.3755 26.9058C21.5161 26.898 21.6567 26.8901 21.8051 26.898C21.7973 26.898 21.7973 26.9058 21.7895 26.9058C20.352 27.7339 18.8676 28.3042 17.477 28.812C17.0239 28.9761 16.6489 29.3276 16.4692 29.773C16.2817 30.2026 16.2895 30.6948 16.4926 31.1167C17.4301 33.1636 19.3051 33.8276 21.5005 32.9058C26.2583 30.9058 28.727 32.8901 31.3442 34.9839C33.063 36.3589 34.8286 37.773 37.188 37.773H37.5708C37.9145 38.1245 38.5239 38.8589 38.3208 39.5464L38.313 39.5308ZM37.227 36.2026C35.438 36.2261 33.9536 35.0698 32.313 33.7573C29.7192 31.6792 26.5005 29.1011 20.8833 31.4605C19.4458 32.062 18.4926 31.7417 17.8989 30.4605C17.8989 30.4448 17.8833 30.4136 17.8989 30.3667C17.9145 30.3355 17.938 30.2964 18.0005 30.273C19.4614 29.7495 21.0161 29.1401 22.563 28.2495C24.3286 27.2417 26.4301 26.773 28.6567 26.898C30.6255 27.0073 32.2739 26.562 33.1176 26.2808L38.7192 33.7886C37.8755 34.562 37.438 35.5698 37.227 36.2026Z"
                                fill="white"
                              />
                              <path
                                d="M18.5547 19.625H31.4453C33.1719 19.625 34.5703 18.2188 34.5703 16.5V4.6875C34.5703 2.96094 33.1719 1.5625 31.4453 1.5625H18.5547C16.8281 1.5625 15.4297 2.96094 15.4297 4.6875V16.5C15.4297 18.2188 16.8281 19.625 18.5547 19.625ZM20.5078 3.125H29.4922V8.625C29.4922 8.875 29.3672 9.10938 29.1719 9.25C29.0312 9.35156 28.875 9.40625 28.7109 9.40625C28.625 9.40625 28.5469 9.39062 28.4687 9.36719L25 8.26562L21.5312 9.36719C21.2891 9.44531 21.0312 9.39844 20.8281 9.25C20.6328 9.10938 20.5078 8.875 20.5078 8.625V3.125Z"
                                fill="#FFCD04"
                              />
                            </svg>
                          </div>
                          <div class="slider_box_right">
                            <div class="slider_box_right_content">
                              <span class="text_white_7"
                                >Buyer and Supplier Information</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="carousel-item" data-bs-interval="2000">
          <div class="home_slider_carousel_inner_item">
            <img
              src="../../../assets/img/carousel_img/carousel_04.webp"
              class="home_slider_carousel_inner_item_img w-100"
              alt="image"
            />
            <img
              src="../../../assets/img/carousel_img/carousel_mobile_04.webp"
              class="home_slider_carousel_inner_item_phoneimg w-100"
              alt="image"
            />
            <div class="home_slider_carousel_inner_item_top carousel-caption">
              <p class="text_white_3">Specialty Chemical</p>
              <span class="text_white_4"
                >Our Coverage Embraces Specialty Chemicals, Elaborating on Their
                Synthesis Pathways and Diverse Applications, Fostering New
                Advancements Within the Field.</span
              >
              <div class="home_slider_carousel_inner_item_top_button">
                <button
                  type="button"
                  class="rounded-pill text_blue_4 button_white_1"
                >
                  <span>View More</span>
                  <img
                    class="home_slider_carousel_inner_item_top_button_icon button_white_1_text_icon"
                    src="../../../assets/icons/video_icon.png"
                  />
                </button>
              </div>
              <div class="home_slider_carousel_inner_item_top_img">
                <div class="home_slider_carousel_inner_item_top_img_body">
                  <div class="home_slider_carousel_inner_item_top_img_body_box">
                    <img
                      width="20%"
                      src="../../../assets/icons/laboratory_icon.png"
                      alt="image"
                    />
                    <div class="text_white_21">Chemical</div>
                  </div>
                </div>
              </div>
              <div class="home_slider_carousel_inner_item_top_list p-y-11">
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Coverage Battery, Dyes, Paint, LED, and Cosmetic Chemicals
                </div>
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Formulation & Combination Patents
                </div>
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Synthesis Pathways, e.g. Innovator and Commercial Routes
                </div>
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Applications of Intermediates in Different Industries
                </div>
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Patent Landscape of Innovator & Generic Patents
                </div>
                <div
                  class="home_slider_carousel_inner_item_top_list_item transparent_hexagon"
                >
                  Buyer and Supplier Information
                </div>
              </div>
            </div>
            <div
              class="home_slider_carousel_inner_item_button carousel-caption"
            >
              <button
                type="button"
                class="rounded-pill text_blue_4 button_white_1"
                data-bs-toggle="modal"
                data-bs-target="#VideoModel"
                data-bs-dismiss="modal"
                (click)="toggleIntroVideoHome()"
              >
                <span>View More</span>
                <img
                  class="home_slider_carousel_inner_item_button_icon button_white_1_text_icon"
                  src="../../../assets/icons/video_icon.png"
                />
              </button>
            </div>
            <div
              class="home_slider_carousel_inner_item_layout carousel-caption"
            >
              <div class="home_slider_carousel_inner_item_layout_content">
                <div class="home_slider_carousel_inner_item_layout_content_box">
                  <div
                    class="home_slider_carousel_inner_item_layout_content_box_left"
                  >
                    <div
                      class="home_slider_carousel_inner_item_layout_content_box_left_top1"
                    >
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_left_top1_box slider_box transparent_hexagon"
                      >
                        <div class="slider_box_left">
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 50 50"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M24.375 17.3438L17.1875 20.3125L25 23.4375L32.8125 20.3125L25.625 17.3438C25.1562 17.1875 24.8438 17.1875 24.375 17.3438Z"
                              fill="#FFDD3C"
                            />
                            <path
                              d="M17.1875 21.875L24.2188 24.6875V32.8125L18.125 30.1562C17.5 29.8437 17.1875 29.375 17.1875 28.75V21.875Z"
                              fill="#FFDD3C"
                            />
                            <path
                              d="M15.1562 37.0313C14.375 36.4063 13.5938 35.625 12.9688 34.8438L9.84375 37.9688C9.21875 37.6562 8.59375 37.5 7.8125 37.5C5.15625 37.5 3.125 39.5313 3.125 42.1875C3.125 44.8438 5.15625 46.875 7.8125 46.875C10.4688 46.875 12.5 44.8438 12.5 42.1875C12.5 41.4063 12.3438 40.7813 12.0312 40.1563L15.1562 37.0313Z"
                              fill="white"
                            />
                            <path
                              d="M12.9688 15.1562C13.5938 14.375 14.375 13.5938 15.1562 12.9688L12.0312 9.84375C12.3438 9.21875 12.5 8.59375 12.5 7.8125C12.5 5.15625 10.4688 3.125 7.8125 3.125C5.15625 3.125 3.125 5.15625 3.125 7.8125C3.125 10.4688 5.15625 12.5 7.8125 12.5C8.59375 12.5 9.21875 12.3438 9.84375 12.0312L12.9688 15.1562Z"
                              fill="white"
                            />
                            <path
                              d="M34.8438 12.9688C35.625 13.5938 36.4063 14.375 37.0313 15.1562L40.1563 12.0312C40.7813 12.3438 41.4063 12.5 42.1875 12.5C44.8438 12.5 46.875 10.4688 46.875 7.8125C46.875 5.15625 44.8438 3.125 42.1875 3.125C39.5313 3.125 37.5 5.15625 37.5 7.8125C37.5 8.59375 37.6562 9.21875 37.9688 9.84375L34.8438 12.9688Z"
                              fill="white"
                            />
                            <path
                              d="M45.7812 40.4688L40.1562 34.8437C39.6875 34.375 38.9062 34.2188 38.2812 34.5312L36.7187 32.8125C38.2812 30.625 39.0625 27.8125 39.0625 25C39.0625 17.1875 32.8125 10.9375 25 10.9375C17.1875 10.9375 10.9375 17.1875 10.9375 25C10.9375 32.8125 17.1875 39.0625 25 39.0625C27.9687 39.0625 30.625 38.125 32.8125 36.7188L34.5312 38.4375C34.2187 39.0625 34.2187 39.6875 34.8437 40.3125L40.4687 45.9375C41.25 46.7188 42.1875 47.0312 43.125 47.0312C44.0625 47.0312 45.1562 46.5625 45.7812 45.9375C47.1875 44.375 47.1875 41.875 45.7812 40.4688ZM14.0625 25C14.0625 18.9062 18.9062 14.0625 25 14.0625C31.0937 14.0625 35.9375 18.9062 35.9375 25C35.9375 31.0938 31.0937 35.9375 25 35.9375C18.9062 35.9375 14.0625 31.0938 14.0625 25Z"
                              fill="white"
                            />
                            <path
                              d="M32.8125 21.875L25.7812 24.6875V32.8125L31.875 30.1562C32.5 29.8437 32.8125 29.375 32.8125 28.75V21.875Z"
                              fill="#FFDD3C"
                            />
                          </svg>
                        </div>
                        <div class="slider_box_right">
                          <div class="slider_box_right_content">
                            <span class="text_white_7"
                              >Coverage Battery, Dyes, Paint, LED, and Cosmetic
                              Chemicals</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="home_slider_carousel_inner_item_layout_content_box_left_center2"
                    >
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_left_center1_box slider_box transparent_hexagon"
                      >
                        <div class="slider_box_left">
                          <svg
                            width="38"
                            height="43"
                            viewBox="0 0 38 43"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_1882_30766)">
                              <path
                                d="M37.9996 19.5771C37.9996 20.2726 37.4396 20.837 36.7477 20.837H35.344V34.8107C35.344 39.3261 31.6935 42.9999 27.2068 42.9999C23.1065 42.9999 19.704 39.9309 19.1498 35.9555H24.0504C24.7423 35.9555 25.3023 35.3911 25.3023 34.6957C25.3023 33.9994 24.7423 33.4358 24.0504 33.4358H19.0697V30.916H24.0504C24.7423 30.916 25.3023 30.3516 25.3023 29.6562C25.3023 28.9599 24.7423 28.3963 24.0504 28.3963H19.0697V25.8766H24.0504C24.7423 25.8766 25.3023 25.3121 25.3023 24.6167C25.3023 23.9204 24.7423 23.3569 24.0504 23.3569H19.0697V20.8371H17.6659C16.9741 20.8371 16.4141 20.2726 16.4141 19.5772C16.4141 18.8809 16.9741 18.3174 17.6659 18.3174H36.7477C37.4396 18.3174 37.9996 18.8808 37.9996 19.5771Z"
                                fill="white"
                              />
                              <path
                                d="M15.4722 11.6754L13.5953 14.9469C13.3716 15.3366 12.9585 15.5769 12.5112 15.5769H9.47079L8.33243 17.5095L9.4808 19.5119H12.0964C12.7882 19.5119 13.3482 20.0763 13.3482 20.7717C13.3482 21.4681 12.7882 22.0316 12.0964 22.0316H9.4808L8.32742 24.0432L9.70864 26.4513C10.0542 27.0543 9.84885 27.8246 9.25046 28.1723C8.65457 28.5204 7.88726 28.3164 7.54041 27.7112L6.15918 25.3031H3.128C2.6815 25.3031 2.26755 25.0629 2.04388 24.6731L0.16775 21.4016C-0.0559167 21.0119 -0.0559167 20.5315 0.16775 20.1418L2.04388 16.8711C2.26755 16.4814 2.6815 16.2411 3.128 16.2411H6.16837L7.30756 14.3085L5.79781 11.6753C5.57415 11.2855 5.57415 10.8052 5.79781 10.4155L7.31257 7.77475L5.86708 5.25505H2.79917C2.10731 5.25505 1.54731 4.69059 1.54731 3.9952C1.54731 3.29981 2.10731 2.73535 2.79917 2.73535H6.58983C7.03716 2.73535 7.45028 2.97555 7.67394 3.36532L9.4808 6.51498H12.5112C12.9585 6.51498 13.3716 6.75518 13.5953 7.14495L15.4722 10.4156C15.6959 10.8052 15.6959 11.2857 15.4722 11.6754Z"
                                fill="white"
                              />
                              <path
                                d="M35.7978 1.15264C35.7093 0.623537 35.297 0.208571 34.7712 0.119548C34.586 0.0884734 30.2003 -0.622874 27.7691 1.82367C27.5647 2.02943 27.3777 2.25367 27.2066 2.49555C27.0355 2.25367 26.8486 2.02943 26.6441 1.82367C24.213 -0.622874 19.8273 0.0885573 19.6412 0.119632C19.1154 0.208655 18.7039 0.623537 18.6155 1.15272C18.5838 1.33917 17.8769 5.75196 20.3088 8.1985C21.7454 9.64421 23.9238 10.0672 25.9548 10.0429V15.7977H28.4585V10.0429C30.4892 10.0675 32.6681 9.64387 34.1044 8.1985C36.5355 5.75187 35.8295 1.33908 35.7978 1.15264Z"
                                fill="#FFDD3C"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1882_30766">
                                <rect width="38" height="43" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <div class="slider_box_right">
                          <div class="slider_box_right_content">
                            <span class="text_white_7"
                              >Synthesis Pathways, e.g. Innovator and Commercial
                              Routes</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="home_slider_carousel_inner_item_layout_content_box_left_bottom2"
                    >
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_left_bottom2_box slider_box transparent_hexagon"
                      >
                        <div class="slider_box_left">
                          <svg
                            width="42"
                            height="43"
                            viewBox="0 0 42 43"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_1882_30735)">
                              <path
                                d="M19.1547 16.7504C19.2053 18.5202 17.7753 19.9769 16.0082 19.9769H12.4107C12.1127 19.9769 11.8711 19.7362 11.8711 19.4394V14.2436C11.8711 13.9467 12.1127 13.7061 12.4107 13.7061H15.9475C17.6608 13.7061 19.106 15.0445 19.1547 16.7504Z"
                                fill="white"
                              />
                              <path
                                d="M22.6888 1.73358C22.4095 0.256533 20.7245 -0.469805 19.4619 0.329812C18.2427 1.10273 16.8045 0.32596 15.3626 0.741893C12.3425 1.61318 11.2075 4.07984 11.847 6.39547C10.7273 7.31862 9.85451 8.57081 9.3836 10.0478C9.11577 9.65584 8.77554 9.27045 8.3862 8.93514C8.81061 7.19195 7.91242 5.38918 5.67102 4.74894C4.5871 4.44131 3.5594 4.98409 2.75078 4.4766C1.71543 3.82784 0.342546 4.42303 0.114737 5.61699C-0.682551 9.79353 2.83586 12.3742 5.69998 11.6544C6.19175 11.5308 6.25363 10.8628 5.79576 10.6455C5.774 10.6352 5.7525 10.6252 5.73128 10.6157C5.38448 10.4589 5.24571 10.0831 5.32117 9.79424C5.43404 9.36228 5.89676 9.11879 6.30597 9.29975C8.07089 10.0796 9.04598 11.859 8.99328 13.477V13.7063H3.47836C1.76507 13.7063 0.319792 15.0447 0.270327 16.7504C0.220142 18.5212 1.64977 19.9771 3.41721 19.9771H8.27378C8.47254 19.9771 8.65242 20.0578 8.78282 20.1868C9.24204 20.6474 8.90298 21.4105 8.24617 21.4105H3.23733C2.93928 21.4105 2.69772 21.6511 2.69772 21.948V27.2629C2.69772 27.6741 3.1411 27.9312 3.50175 27.7314C5.64188 26.549 6.15443 25.3011 8.99328 25.061C9.3416 25.0312 9.59891 25.0201 9.87897 25.0275C10.1827 25.0356 10.4323 24.7901 10.4323 24.4874C10.4323 22.6651 10.4465 14.0334 10.4323 12.617C10.4056 9.95657 11.9838 7.38411 14.6908 6.39278L14.6944 6.39189C15.0982 6.24766 15.5389 6.48505 15.6369 6.90251C15.7194 7.26048 15.5236 7.61317 15.1899 7.73653C14.7507 7.89894 14.3409 8.11537 13.9675 8.38287C13.6527 8.60835 13.6747 9.08054 14.0061 9.2812C17.7531 11.55 23.8968 8.13956 22.6888 1.73358Z"
                                fill="white"
                              />
                              <path
                                d="M15.2884 29.0201C12.7577 27.6416 12.6755 26.4574 9.71232 26.458C7.72949 26.4585 7.05379 27.0098 6.03211 27.7704C5.54897 28.1306 3.92877 29.2434 3.04991 29.5642C2.83757 29.6417 2.69727 29.8429 2.69727 30.0681V35.9239C2.69727 39.7708 5.78128 42.9629 9.64325 43.0001C13.543 43.0377 16.7274 39.8888 16.7274 36.013V30.0501C16.7274 29.8304 16.5939 29.6331 16.389 29.5517C16.0033 29.3983 15.4606 29.1135 15.2884 29.0201ZM10.8221 29.8622L11.0919 29.5934C11.3734 29.3139 11.8285 29.3139 12.11 29.5934C12.3906 29.8738 12.3906 30.3271 12.11 30.6075L11.8402 30.8762C11.5588 31.1547 11.1057 31.1568 10.8221 30.8762C10.5415 30.5958 10.5415 30.1426 10.8221 29.8622ZM9.29321 33.1767L9.56302 32.908C9.84453 32.6285 10.2996 32.6285 10.5811 32.908C10.8617 33.1884 10.8617 33.6417 10.5811 33.9221L10.3113 34.1908C10.0299 34.4692 9.57678 34.4714 9.29321 34.1908C9.01261 33.9104 9.01261 33.4571 9.29321 33.1767ZM7.22467 29.8622L7.49448 29.5934C7.77598 29.3139 8.23106 29.3139 8.51257 29.5934C8.79317 29.8738 8.79317 30.3271 8.51257 30.6075L8.24275 30.8762C7.96134 31.1547 7.50824 31.1568 7.22467 30.8762C6.94407 30.5958 6.94407 30.1426 7.22467 29.8622Z"
                                fill="white"
                              />
                              <path
                                d="M36.514 33.9522H25.9914C25.7189 33.9522 25.4698 33.7988 25.3479 33.5561L23.7481 30.3689H19.8757C19.4784 30.3689 19.1562 30.048 19.1562 29.6522C19.1562 29.2564 19.4784 28.9355 19.8757 28.9355H24.1927C24.4652 28.9355 24.7143 29.0889 24.8362 29.3317L26.4361 32.5189H36.514C36.9114 32.5189 37.2335 32.8397 37.2335 33.2355C37.2335 33.6313 36.9114 33.9522 36.514 33.9522Z"
                                fill="white"
                              />
                              <path
                                d="M33.9081 38.4314H33.8211C33.4237 38.4314 33.1016 38.1105 33.1016 37.7147C33.1016 37.3189 33.4237 36.998 33.8211 36.998H33.9081C34.3055 36.998 34.6276 37.3189 34.6276 37.7147C34.6276 38.1105 34.3055 38.4314 33.9081 38.4314Z"
                                fill="white"
                              />
                              <path
                                d="M30.8504 38.4314H25.991C25.5936 38.4314 25.2715 38.1105 25.2715 37.7147C25.2715 37.3189 25.5936 36.998 25.991 36.998H30.8504C31.2478 36.998 31.5699 37.3189 31.5699 37.7147C31.5699 38.1105 31.2478 38.4314 30.8504 38.4314Z"
                                fill="white"
                              />
                              <path
                                d="M36.5135 42.9997H30.0671C29.6698 42.9997 29.3477 42.6788 29.3477 42.2831C29.3477 41.8873 29.6698 41.5664 30.0671 41.5664H36.5135C36.9109 41.5664 37.233 41.8873 37.233 42.2831C37.233 42.6788 36.9109 42.9997 36.5135 42.9997Z"
                                fill="white"
                              />
                              <path
                                d="M26.812 42.9997H25.991C25.5936 42.9997 25.2715 42.6788 25.2715 42.2831C25.2715 41.8873 25.5936 41.5664 25.991 41.5664H26.812C27.2093 41.5664 27.5315 41.8873 27.5315 42.2831C27.5315 42.6788 27.2093 42.9997 26.812 42.9997Z"
                                fill="white"
                              />
                              <path
                                d="M39.8416 0.895829H32.3768C31.187 0.895829 30.2184 1.86064 30.2184 3.04582V9.22704H27.7001V2.14999C27.7001 1.04561 26.8451 0 25.4517 0C25.0542 0 24.7322 0.320707 24.7322 0.716663C24.7322 1.11262 25.0542 1.43333 25.4517 1.43333H25.5417C25.9383 1.43333 26.2612 1.75493 26.2612 2.14999V17.827C26.2612 18.2221 25.9383 18.5437 25.5417 18.5437H21.8543C21.4567 18.5437 21.1348 18.8644 21.1348 19.2603C21.1348 19.6563 21.4567 19.977 21.8543 19.977H25.5417C26.7315 19.977 27.7001 19.0122 27.7001 17.827V10.6604H30.2184V16.8416C30.2184 18.0268 31.187 18.9916 32.3768 18.9916H39.8416C41.0314 18.9916 42.0001 18.0268 42.0001 16.8416V3.04582C42.0001 1.86064 41.0314 0.895829 39.8416 0.895829ZM36.424 14.8708H34.8051C34.4078 14.8708 34.0856 14.5499 34.0856 14.1541C34.0856 13.7583 34.4078 13.4374 34.8051 13.4374H36.424C36.8213 13.4374 37.1435 13.7583 37.1435 14.1541C37.1435 14.5499 36.8213 14.8708 36.424 14.8708ZM37.5032 10.6604H34.8051C34.4078 10.6604 34.0856 10.3395 34.0856 9.9437C34.0856 9.54792 34.4078 9.22704 34.8051 9.22704H37.5032C37.9006 9.22704 38.2227 9.54792 38.2227 9.9437C38.2227 10.3395 37.9006 10.6604 37.5032 10.6604ZM37.5032 6.44997H34.8051C34.4078 6.44997 34.0856 6.12908 34.0856 5.73331C34.0856 5.33753 34.4078 5.01664 34.8051 5.01664H37.5032C37.9006 5.01664 38.2227 5.33753 38.2227 5.73331C38.2227 6.12908 37.9006 6.44997 37.5032 6.44997Z"
                                fill="#FFDD3C"
                              />
                              <path
                                d="M16.7276 21.9475V26.9521C16.7276 27.5062 16.1215 27.8533 15.6434 27.5701C14.2274 26.7312 13.5613 25.9078 12.2256 25.4276C12.0127 25.351 11.8711 25.1487 11.8711 24.9232V21.9477C11.8711 21.6508 12.1127 21.4102 12.4107 21.4102H16.188C16.486 21.41 16.7276 21.6506 16.7276 21.9475Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1882_30735">
                                <rect width="42" height="43" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <div class="slider_box_right">
                          <div class="slider_box_right_content">
                            <span class="text_white_7"
                              >Patent Landscape of Innovator & Generic
                              Patents</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="home_slider_carousel_inner_item_layout_content_box_center"
                  >
                    <div
                      class="home_slider_carousel_inner_item_layout_content_box_center_body"
                    >
                      <img
                        width="20%"
                        src="../../../assets/icons/laboratory_icon.png"
                        alt="image"
                      />
                      <div class="text_white_20">Chemical</div>
                    </div>
                  </div>
                  <div
                    class="home_slider_carousel_inner_item_layout_content_box_right"
                  >
                    <div
                      class="home_slider_carousel_inner_item_layout_content_box_right"
                    >
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_right_top1"
                      >
                        <div
                          class="home_slider_carousel_inner_item_layout_content_box_right_top1_box slider_box transparent_hexagon"
                        >
                          <div class="slider_box_left">
                            <svg
                              width="42"
                              height="43"
                              viewBox="0 0 42 43"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_1882_30716)">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M4.02879 0H27.7796C30.7427 0 33.153 2.38771 33.153 5.32294V21.2955C32.3966 21.0929 31.554 21.2853 30.9612 21.8726L30.3656 22.4625L29.5517 22.2463C28.3527 21.9279 27.1046 22.6418 26.7831 23.8295L26.5648 24.6361L25.7505 24.8524C24.5419 25.1734 23.8301 26.4045 24.1523 27.595L24.3706 28.4012L23.775 28.9911C22.8934 29.8644 22.8934 31.2845 23.775 32.1579L24.3706 32.7478L24.1523 33.554C23.9998 34.1174 24.0748 34.7141 24.3609 35.2228L23.7651 36.2451H7.46502C7.1369 36.2451 6.87153 35.9823 6.87153 35.6572L6.87194 5.04879C6.87216 2.94872 6.41696 0.230932 4.02879 0ZM5.71179 9.61034H0.593486C0.265392 9.61034 0 9.34747 0 9.02243V3.99177C0 -0.168957 4.98766 -1.23216 5.62998 3.67388C5.68954 4.12868 5.7122 4.59022 5.7122 5.04864L5.71179 9.61034ZM24.6427 6.13253H15.382C15.0539 6.13253 14.7885 5.86968 14.7885 5.54463C14.7885 5.21959 15.0538 4.95672 15.382 4.95672L24.6436 4.95675C24.9716 4.95675 25.237 5.21962 25.237 5.54465C25.237 5.8697 24.9708 6.13253 24.6427 6.13253ZM28.7012 11.164H11.3235C10.9954 11.164 10.73 10.9012 10.73 10.5761C10.73 10.2511 10.9953 9.98824 11.3235 9.98824L28.702 9.98827C29.0301 9.98827 29.2955 10.2511 29.2955 10.5762C29.2955 10.9012 29.0293 11.164 28.7012 11.164ZM28.7012 16.1947H11.3235C10.9954 16.1947 10.73 15.9318 10.73 15.6068C10.73 15.2818 10.9953 15.0189 11.3235 15.0189L28.702 15.0189C29.0301 15.0189 29.2955 15.2818 29.2955 15.6068C29.2955 15.9319 29.0293 16.1947 28.7012 16.1947ZM28.7012 21.2262H11.3235C10.9954 21.2262 10.73 20.9633 10.73 20.6383C10.73 20.3132 10.9953 20.0504 11.3235 20.0504L28.702 20.0504C29.0301 20.0504 29.2955 20.3133 29.2955 20.6383C29.2955 20.9634 29.0293 21.2262 28.7012 21.2262ZM23.014 26.2568H11.3226C10.9945 26.2568 10.7291 25.994 10.7291 25.6689C10.7291 25.3439 10.9945 25.081 11.3226 25.081L23.014 25.0811C23.3421 25.0811 23.6075 25.3439 23.6075 25.669C23.6075 25.994 23.3421 26.2568 23.014 26.2568ZM21.4913 31.2875H11.3234C10.9953 31.2875 10.73 31.0247 10.73 30.6996C10.73 30.3746 10.9953 30.1117 11.3234 30.1117H21.4913C21.8194 30.1117 22.0848 30.3746 22.0848 30.6996C22.0848 31.0247 21.8194 31.2875 21.4913 31.2875Z"
                                  fill="white"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M36.8493 42.9998C36.639 42.9998 36.4423 42.889 36.3355 42.7059L34.2715 39.1644L34.7532 38.6872L35.5671 38.9033C36.7724 39.2235 38.0127 38.5139 38.3358 37.3202L38.5541 36.5136C38.9939 36.3968 39.5408 36.2872 39.915 36.0732L41.9192 39.512C42.1766 39.9538 41.7781 40.4914 41.2758 40.3795L38.3186 39.7211L37.4165 42.5866C37.3392 42.8317 37.1077 42.9998 36.8493 42.9998Z"
                                  fill="#FFDD3C"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M28.2702 43.0004C28.0033 43.0004 27.7698 42.8254 27.6979 42.5712L26.8628 39.6149L23.8607 40.3767C23.3539 40.5053 22.9387 39.962 23.1994 39.5133L25.2044 36.0732C25.5783 36.287 26.125 36.3965 26.5645 36.5133L26.7828 37.3199C27.1067 38.5164 28.3489 39.2224 29.5515 38.903L30.3654 38.6868L30.8477 39.1647L28.7831 42.7073C28.6771 42.8895 28.4796 43.0004 28.2702 43.0004Z"
                                  fill="#FFDD3C"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M33.3379 22.6849L34.407 23.7448L35.8678 23.3568C36.4536 23.2014 37.059 23.5475 37.2158 24.1278L37.6075 25.5748L39.0683 25.9628C39.6546 26.1189 40.0045 26.7155 39.8466 27.2982L39.4549 28.7452L40.524 29.8043C40.953 30.2292 40.953 30.9213 40.524 31.3462L39.4549 32.4053L39.8466 33.8523C40.0038 34.4318 39.6564 35.0322 39.0683 35.1877L37.6075 35.5757L37.2158 37.0227C37.0585 37.6025 36.4566 37.9503 35.8678 37.7937L34.407 37.4057L33.3379 38.4648C33.1234 38.6764 32.8419 38.783 32.5596 38.783C32.2781 38.783 31.9958 38.6764 31.7813 38.4639L30.7122 37.4049L29.2514 37.7929C28.6661 37.9478 28.0604 37.6049 27.9034 37.0219L27.5117 35.5749L26.0509 35.1869C25.4646 35.0308 25.1147 34.4341 25.2726 33.8515L25.6643 32.4044L24.5952 31.3454C24.1662 30.9204 24.1662 30.2284 24.5952 29.8034L25.6643 28.7444L25.2726 27.2974C25.1156 26.7187 25.4616 26.1178 26.0509 25.962L27.5117 25.574L27.9034 24.1269C28.0602 23.5466 28.6656 23.2006 29.2514 23.356L30.7122 23.744L31.7813 22.6849C32.2103 22.26 32.9089 22.26 33.3379 22.6849ZM32.5596 26.3282C30.1959 26.3282 28.273 28.233 28.273 30.5744C28.273 32.9159 30.1959 34.8207 32.5596 34.8207C34.9233 34.8207 36.8461 32.9159 36.8461 30.5744C36.8461 28.233 34.9233 26.3282 32.5596 26.3282Z"
                                  fill="#FFDD3C"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M32.5586 27.5039C30.8494 27.5039 29.459 28.8812 29.459 30.5744C29.459 32.2675 30.8494 33.6448 32.5586 33.6448C34.2678 33.6448 35.6582 32.2675 35.6582 30.5744C35.6582 28.8812 34.2678 27.5039 32.5586 27.5039Z"
                                  fill="white"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_1882_30716">
                                  <rect width="42" height="43" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div class="slider_box_right">
                            <div class="slider_box_right_content">
                              <span class="text_white_7"
                                >Formulation & Combination Patents</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_right_center2"
                      >
                        <div
                          class="home_slider_carousel_inner_item_layout_content_box_right_center1_box slider_box transparent_hexagon"
                        >
                          <div class="slider_box_left">
                            <svg
                              width="43"
                              height="43"
                              viewBox="0 0 43 43"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_1882_30783)">
                                <path
                                  d="M14.5893 33.1714V30.407C14.5896 29.0853 13.743 27.9121 12.4885 27.4961L8.84816 26.2828C8.30896 26.1048 7.81956 25.8017 7.41998 25.3983C6.34501 24.3232 4.47532 24.2549 3.78196 25.826L2.2793 29.2107C4.44724 33.3407 7.98517 36.5872 12.2858 38.3928V37.4714C12.2827 36.3483 12.8452 35.2992 13.7823 34.6802C14.2884 34.3455 14.5918 33.7782 14.5893 33.1714Z"
                                  fill="white"
                                />
                                <path
                                  d="M11.5176 3.04754C11.5164 3.30506 11.6463 3.5455 11.8624 3.68563C12.0784 3.83018 12.3529 3.8556 12.5918 3.7532L14.8953 2.76419C15.1751 2.64006 15.3558 2.36309 15.3568 2.05699V0.541992C14.0345 0.854636 12.7479 1.30288 11.5176 1.87961V3.04754Z"
                                  fill="white"
                                />
                                <path
                                  d="M38.6218 14.1672C38.3341 14.8895 37.6331 15.3616 36.8557 15.3567H36.0879C35.8136 15.3631 35.5635 15.5154 35.432 15.7562C35.3004 15.997 35.3073 16.2897 35.45 16.5241C35.5927 16.7584 35.8497 16.8988 36.124 16.8924C36.7284 16.8995 37.2926 17.1963 37.6408 17.6904C37.989 18.1844 38.0788 18.8156 37.8823 19.3872C37.5813 20.2925 37.2274 21.2408 36.8504 22.2037C37.6142 22.3609 38.2948 22.7904 38.7654 23.4123C38.9585 23.6644 39.2184 23.8572 39.5155 23.969C40.2335 20.5016 40.0092 16.9051 38.8659 13.5537L38.6218 14.1672Z"
                                  fill="white"
                                />
                                <path
                                  d="M25.5906 0.8125L22.5031 5.96795C22.2072 6.48911 22.2153 7.12932 22.5243 7.6428C22.8333 8.15628 23.3952 8.46325 23.9942 8.44585H29.1771C29.8222 8.45308 30.4354 8.72797 30.87 9.2048C31.3046 9.68163 31.5216 10.3176 31.4691 10.9606C31.3323 12.1651 30.3048 13.0699 29.0927 13.053H24.7928C22.2474 13.0113 20.1196 14.9795 19.9631 17.5205C19.9253 18.7664 20.3939 19.9745 21.262 20.869C22.1301 21.7635 23.3236 22.268 24.5701 22.2674C25.5885 22.2679 26.5651 22.6721 27.2859 23.3916C27.9945 22.4731 29.1406 22.0043 30.2897 22.163C30.6673 22.2153 31.0515 22.1393 31.3808 21.9472C32.3901 21.3575 33.6388 21.3575 34.648 21.9472C34.8258 22.05 35.0206 22.1202 35.2231 22.1545C35.67 21.0396 36.0792 19.9462 36.4255 18.9049C36.4793 18.7437 36.4102 18.4273 36.1806 18.4327C34.9071 18.4584 33.854 17.4468 33.8283 16.1733C33.8027 14.8997 34.8142 13.8466 36.0877 13.8209H36.8555C37.0032 13.8219 37.1369 13.7336 37.1941 13.5975L38.0388 11.4935C35.6016 6.32143 31.0727 2.43555 25.5906 0.8125Z"
                                  fill="white"
                                />
                                <path
                                  d="M1.59694 16.8931C2.41079 16.8922 3.07034 16.2327 3.07119 15.4188C3.07201 14.7019 3.32724 14.0086 3.79142 13.4623L7.45632 9.19064C7.68381 8.91821 7.73461 8.53935 7.58694 8.21661C7.43926 7.89388 7.11935 7.68465 6.7645 7.67871H4.24522C2.14172 10.3561 0.761297 13.5289 0.236328 16.8931H1.59694Z"
                                  fill="white"
                                />
                                <path
                                  d="M33.0177 26.875C29.6252 26.875 26.875 29.6253 26.875 33.0179C26.875 36.4106 29.6252 39.1608 33.0177 39.1608C36.4102 39.1608 39.1604 36.4106 39.1604 33.0179C39.1566 29.6269 36.4087 26.8788 33.0177 26.875ZM35.8641 32.0251L32.0249 35.8644C31.7251 36.1642 31.239 36.1642 30.9392 35.8644L30.1713 35.0965C29.8803 34.7952 29.8845 34.3163 30.1807 34.0201C30.4769 33.7239 30.9558 33.7198 31.2571 34.0108L31.482 34.2358L34.7784 30.9393C35.0797 30.6483 35.5586 30.6525 35.8547 30.9487C36.1509 31.2449 36.1551 31.7238 35.8641 32.0251Z"
                                  fill="#FFDD3C"
                                />
                                <path
                                  d="M2.38031 25.204C2.96443 23.8856 4.2708 23.0356 5.71273 23.0355C6.68148 23.0382 7.61023 23.4222 8.29804 24.1044C9.4306 25.2432 11.4869 25.5434 12.9734 26.0394C14.8556 26.6636 16.1257 28.424 16.1246 30.407V33.1714C16.1277 34.2944 15.5652 35.3436 14.6281 35.9626C14.122 36.2973 13.8186 36.8646 13.8211 37.4714V38.9572C17.0979 40.0225 20.5956 40.2154 23.9696 39.517C23.8583 39.2196 23.6653 38.9596 23.413 38.7668C22.4788 38.0606 21.9997 36.9044 22.1606 35.7445C22.2123 35.3669 22.1363 34.9828 21.9448 34.6533C21.354 33.6444 21.354 32.395 21.9448 31.3861C22.138 31.0563 22.2148 30.6713 22.1629 30.2926C22.0019 29.1323 22.481 27.9755 23.4153 27.2688C23.7187 27.0394 23.9365 26.715 24.0341 26.3473C24.2837 25.3902 24.9588 24.6005 25.8654 24.205C25.4839 23.9443 25.0329 23.8044 24.5709 23.8034C22.9097 23.8041 21.319 23.132 20.1617 21.9403C19.0043 20.7486 18.3789 19.139 18.4281 17.4785C18.6113 14.1075 21.4179 11.4793 24.7935 11.5176H29.0934C29.5095 11.5307 29.8708 11.2334 29.9381 10.8226C29.9557 10.6087 29.884 10.3969 29.74 10.2376C29.596 10.0784 29.3926 9.98578 29.1779 9.98184H23.995C22.8427 9.99254 21.7732 9.38408 21.1937 8.38804C20.6142 7.39199 20.6137 6.16155 21.1924 5.16502L24.0334 0.418847C21.6832 -0.0694647 19.2645 -0.131366 16.8925 0.236095V2.05747C16.8908 2.97616 16.3456 3.80678 15.5034 4.17371L13.1953 5.16656C12.4828 5.45683 11.673 5.3772 11.0306 4.95371C10.3883 4.53022 9.99595 3.8173 9.98191 3.04802V2.68712C8.36003 3.62781 6.8778 4.79089 5.57836 6.14251H6.76467C7.70802 6.1709 8.55391 6.73115 8.94815 7.58868C9.3424 8.44621 9.21696 9.45305 8.62437 10.1876L4.95948 14.4593C4.73226 14.7272 4.60738 15.067 4.60704 15.4183C4.60535 17.08 3.25875 18.4267 1.59711 18.4284H0.06527C0.0261102 18.9359 1.80829e-06 19.4465 1.80829e-06 19.9641C-0.00107846 22.4951 0.481864 25.0029 1.42281 27.3525L2.38031 25.204Z"
                                  fill="white"
                                />
                                <path
                                  d="M41.6928 28.4942C41.1124 28.0549 40.6972 27.4326 40.5141 26.7281C40.3587 26.1345 39.8953 25.6707 39.3017 25.5149C38.5975 25.3308 37.9755 24.9154 37.5357 24.3355C37.1637 23.8474 36.5583 23.5964 35.9501 23.6782C35.2326 23.7764 34.5028 23.6318 33.8769 23.2674C33.3475 22.9551 32.6903 22.9551 32.1608 23.2674C31.5316 23.6328 30.7987 23.7784 30.0777 23.6812C29.4698 23.6011 28.8654 23.8514 28.4921 24.3378C28.053 24.9184 27.4307 25.3338 26.7261 25.5164C26.1324 25.6719 25.6687 26.1353 25.5129 26.7289C25.3288 27.4332 24.9134 28.0551 24.3335 28.495C23.8437 28.8657 23.5923 29.4721 23.6762 30.0806C23.7741 30.7982 23.6295 31.5279 23.2654 32.1539C22.9532 32.6833 22.9532 33.3406 23.2654 33.87C23.6323 34.4987 23.7781 35.2321 23.6793 35.9533C23.5947 36.5617 23.8459 37.1683 24.3358 37.5389C24.9164 37.978 25.3317 38.6003 25.5144 39.305C25.6698 39.8987 26.1333 40.3624 26.7268 40.5182C27.431 40.7023 28.053 41.1177 28.4929 41.6977C28.8649 42.1858 29.4702 42.4367 30.0784 42.355C30.2248 42.3348 30.3723 42.3245 30.52 42.3242C31.0946 42.324 31.659 42.4764 32.1554 42.7658C32.6849 43.078 33.3421 43.078 33.8716 42.7658C34.5003 42.3991 35.2336 42.2534 35.9547 42.3519C36.5627 42.4327 37.1674 42.1823 37.5403 41.6954C37.9794 41.1147 38.6017 40.6994 39.3063 40.5167C39.9 40.3613 40.3637 39.8978 40.5195 39.3042C40.7036 38.6 41.119 37.978 41.6989 37.5381C42.1887 37.1674 42.4401 36.561 42.3562 35.9525C42.2583 35.2349 42.4029 34.5053 42.767 33.8793V33.8723C43.0765 33.3446 43.0765 32.6908 42.767 32.1631C42.4 31.5345 42.2543 30.801 42.3531 30.0799C42.4368 29.4707 42.1841 28.8639 41.6928 28.4942ZM33.0162 40.6964C28.7755 40.6964 25.3378 37.2585 25.3378 33.0177C25.3378 28.7769 28.7755 25.3391 33.0162 25.3391C37.2569 25.3391 40.6946 28.7769 40.6946 33.0177C40.6899 37.2566 37.2549 40.6917 33.0162 40.6964Z"
                                  fill="#FFDD3C"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_1882_30783">
                                  <rect width="43" height="43" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div class="slider_box_right">
                            <div class="slider_box_right_content">
                              <span class="text_white_7"
                                >Applications of Intermediate in Across the
                                Industries</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="home_slider_carousel_inner_item_layout_content_box_right_bottom2"
                      >
                        <div
                          class="home_slider_carousel_inner_item_layout_content_box_right_bottom1_box slider_box transparent_hexagon"
                        >
                          <div class="slider_box_left">
                            <svg
                              width="50"
                              height="50"
                              viewBox="0 0 50 50"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M44.6723 31.7808L37.3051 21.9058C36.7426 21.148 35.6489 20.9839 34.8833 21.5386L32.8442 22.9995C32.4692 23.273 32.2192 23.6792 32.1489 24.1401C32.1098 24.4058 32.1255 24.6714 32.2036 24.9214C31.4301 25.148 30.1801 25.4136 28.7348 25.3355C27.4536 25.2573 26.2036 25.3667 25.0161 25.648C23.813 25.3667 22.5551 25.2573 21.2661 25.3355C21.0864 25.3433 20.9145 25.3511 20.7426 25.3511C19.5317 25.3511 18.477 25.1245 17.7973 24.9214C17.8755 24.6714 17.8911 24.4058 17.852 24.1401C17.7817 23.6792 17.5317 23.273 17.1567 22.9995L15.1176 21.5386C14.352 20.9839 13.2583 21.148 12.6958 21.9058L5.32858 31.7808C5.05514 32.1558 4.93796 32.6089 5.00827 33.0698C5.07858 33.523 5.32858 33.9292 5.70358 34.2026L7.74264 35.6636C8.04733 35.8901 8.40671 35.9917 8.75827 35.9917C9.29733 35.9917 9.82858 35.7495 10.1645 35.2964L10.2583 35.1792C10.8755 36.3198 11.7192 37.523 12.7739 38.7886C12.5239 39.1089 12.3833 39.4448 12.352 39.7964C12.2817 40.7573 12.6645 41.7261 13.3755 42.398C13.938 42.9292 14.6645 43.2183 15.4067 43.2183C15.4692 43.2183 15.5395 43.2105 15.602 43.2026C15.7426 43.8511 16.0786 44.4683 16.5786 44.937C17.1567 45.4839 17.8989 45.7808 18.6723 45.7808H18.6958C18.6958 45.7808 18.6958 45.7808 18.7036 45.7808C18.8598 46.3823 19.1723 46.937 19.6411 47.3589C20.2036 47.8745 20.9067 48.148 21.6411 48.148C21.7739 48.148 21.9067 48.1401 22.0473 48.1167C22.5708 48.0464 23.1333 47.7651 23.7192 47.312C25.688 48.0464 27.2505 48.4214 28.4692 48.4214C29.1723 48.4214 29.7583 48.3042 30.2505 48.062C31.2426 47.5698 31.6411 46.6948 31.8676 45.9526C32.1645 45.9839 32.4536 46.0073 32.7192 46.0073C33.4067 46.0073 33.9848 45.8901 34.4614 45.6636C35.5239 45.1558 35.9145 44.2183 36.1411 43.4526C36.2348 43.148 36.2505 42.8276 36.227 42.5073H36.3676C37.0551 42.5073 37.6333 42.3901 38.1098 42.1636C39.1723 41.6558 39.563 40.7105 39.7895 39.9448C40.2114 38.5073 39.2583 37.2573 38.688 36.6714C38.8208 36.2573 39.1098 35.5698 39.6333 35.0308L39.8208 35.273C40.1567 35.7261 40.688 35.9683 41.227 35.9683C41.5786 35.9683 41.938 35.8667 42.2426 35.6401L44.2817 34.1792C44.6567 33.9058 44.9067 33.4995 44.977 33.0464C45.0473 32.5855 44.9301 32.1323 44.6567 31.7573L44.6723 31.7808ZM15.7426 41.5933C15.6958 41.6089 15.6489 41.6323 15.602 41.6401C15.0395 41.7183 14.6411 41.437 14.4536 41.2573C14.0864 40.9136 13.8833 40.398 13.9223 39.9214C13.9301 39.7886 14.3051 39.2573 15.8286 38.5855C16.3442 38.3589 16.9536 38.5073 17.313 38.937C17.563 39.2417 17.6255 39.6401 17.5317 40.0073C16.6255 40.5073 16.0395 41.0308 15.7505 41.5855L15.7426 41.5933ZM19.1255 44.148C19.1255 44.148 19.1098 44.148 19.102 44.148C19.102 44.148 19.102 44.148 19.0942 44.148C19.0942 44.148 19.0864 44.148 19.0786 44.148C19.0005 44.1714 18.9301 44.187 18.8755 44.1948C18.2817 44.2808 17.852 43.9761 17.6567 43.7886C17.2661 43.4292 17.0551 42.8901 17.0942 42.3823C17.102 42.2495 17.3911 41.8276 18.5005 41.2573C18.5239 41.2417 18.5473 41.2339 18.5708 41.2183C18.727 41.1401 18.8989 41.062 19.0864 40.9761C19.2583 40.898 19.438 40.8589 19.6176 40.8589C20.0161 40.8589 20.3989 41.0308 20.6645 41.3589C21.0708 41.8589 21.0395 42.5933 20.5786 43.062C19.8989 43.7417 19.4223 44.023 19.1255 44.1323V44.148ZM23.4536 45.4917C22.8286 46.1323 22.2426 46.523 21.8442 46.5776C21.4301 46.6323 21.0239 46.4995 20.7036 46.2105C20.4536 45.9839 20.2817 45.6792 20.2036 45.3511C20.6801 45.0855 21.1645 44.687 21.688 44.1636C21.8911 43.9526 22.0551 43.7339 22.1801 43.4839C22.6567 43.3276 23.2036 43.4761 23.5395 43.8823C23.9301 44.3589 23.8911 45.0464 23.4536 45.4839V45.4917ZM38.313 39.5308C38.1098 40.2339 37.8676 40.5776 37.4614 40.773C36.7348 41.1167 35.0161 41.1714 30.9458 39.4683C30.5473 39.3042 30.0864 39.4917 29.9223 39.8901C29.7583 40.2886 29.9458 40.7495 30.3442 40.9136C32.0161 41.6167 33.4301 42.0776 34.6255 42.3276C34.7114 42.5776 34.727 42.812 34.6645 43.023C34.4536 43.7261 34.2192 44.0776 33.8051 44.2651C33.0786 44.6089 31.3598 44.6636 27.2817 42.9605C26.8833 42.7964 26.4223 42.9839 26.2583 43.3823C26.0942 43.7808 26.2817 44.2339 26.6801 44.4058C28.0708 44.9839 29.2739 45.398 30.3286 45.6714C30.1411 46.2026 29.9223 46.4995 29.5708 46.6714C28.9848 46.9605 27.7114 47.062 24.9458 46.1089C25.5708 45.1245 25.5161 43.8355 24.7505 42.898C24.1801 42.2105 23.3442 41.8511 22.5005 41.8667C22.5005 41.8667 22.5005 41.8667 22.5005 41.8589C22.438 41.3355 22.2348 40.8198 21.8833 40.3823C21.2036 39.5542 20.1333 39.1714 19.1176 39.3667C19.0551 38.8589 18.852 38.3745 18.5239 37.9605C17.7192 36.9839 16.3442 36.6558 15.2036 37.1636C14.7426 37.3667 14.3364 37.5776 13.9848 37.7886C12.7973 36.3667 11.8911 35.0073 11.313 33.7886L16.9067 26.2886C17.7505 26.5698 19.3989 27.0151 21.3755 26.9058C21.5161 26.898 21.6567 26.8901 21.8051 26.898C21.7973 26.898 21.7973 26.9058 21.7895 26.9058C20.352 27.7339 18.8676 28.3042 17.477 28.812C17.0239 28.9761 16.6489 29.3276 16.4692 29.773C16.2817 30.2026 16.2895 30.6948 16.4926 31.1167C17.4301 33.1636 19.3051 33.8276 21.5005 32.9058C26.2583 30.9058 28.727 32.8901 31.3442 34.9839C33.063 36.3589 34.8286 37.773 37.188 37.773H37.5708C37.9145 38.1245 38.5239 38.8589 38.3208 39.5464L38.313 39.5308ZM37.227 36.2026C35.438 36.2261 33.9536 35.0698 32.313 33.7573C29.7192 31.6792 26.5005 29.1011 20.8833 31.4605C19.4458 32.062 18.4926 31.7417 17.8989 30.4605C17.8989 30.4448 17.8833 30.4136 17.8989 30.3667C17.9145 30.3355 17.938 30.2964 18.0005 30.273C19.4614 29.7495 21.0161 29.1401 22.563 28.2495C24.3286 27.2417 26.4301 26.773 28.6567 26.898C30.6255 27.0073 32.2739 26.562 33.1176 26.2808L38.7192 33.7886C37.8755 34.562 37.438 35.5698 37.227 36.2026Z"
                                fill="white"
                              />
                              <path
                                d="M18.5547 19.625H31.4453C33.1719 19.625 34.5703 18.2188 34.5703 16.5V4.6875C34.5703 2.96094 33.1719 1.5625 31.4453 1.5625H18.5547C16.8281 1.5625 15.4297 2.96094 15.4297 4.6875V16.5C15.4297 18.2188 16.8281 19.625 18.5547 19.625ZM20.5078 3.125H29.4922V8.625C29.4922 8.875 29.3672 9.10938 29.1719 9.25C29.0312 9.35156 28.875 9.40625 28.7109 9.40625C28.625 9.40625 28.5469 9.39062 28.4687 9.36719L25 8.26562L21.5312 9.36719C21.2891 9.44531 21.0312 9.39844 20.8281 9.25C20.6328 9.10938 20.5078 8.875 20.5078 8.625V3.125Z"
                                fill="#FFDD3C"
                              />
                            </svg>
                          </div>
                          <div class="slider_box_right">
                            <div class="slider_box_right_content">
                              <span class="text_white_7"
                                >Buyer and Supplier Information</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Clients Section -->
  <div class="home_clients">
    <div class="home_clients_grid">
      <div></div>
      <div
        class="home_clients_grid_body"
        [ngClass]="{ scrollable: clients.length > 5 }"
      >
        <ng-container *ngFor="let client of clients">
          <div class="home_clients_grid_body_box">
            <img
              [src]="clientLogoUrl + client.logo"
              alt="client-logo"
              width="60%"
              *ngIf="client.logo"
            />
          </div>
        </ng-container>
      </div>
      <div></div>
    </div>
    <div class="p-y-16 dis-flex-1 p-40">
      <button
        type="button"
        class="rounded-pill text_white_1 button_blue_1 cursor-pointer"
        routerLink="/clients"
        (click)="scrollToTop()"
      >
        <span class="button_blue_1_text">View More</span>
        <img
          class="button_blue_1_text_icon"
          src="../../../assets/icons/arrow-right.png"
        />
      </button>
    </div>
  </div>

  <!-- Platforms Section -->
  <div class="home_platforms">
    <div class="home_platforms_heading">
      <p class="text_style_5">
        Discover Innovations Together in AgroSciences, Pharmaceuticals,
        Specialty & Fine Chemicals !!
      </p>
    </div>
    <div class="home_platforms_list">
      <ng-container *ngFor="let platform of platforms; let i = index">
        <div class="home_platforms_list_box">
          <div class="home_platforms_list_box_card">
            <div class="home_platforms_list_box_card_top">
              <span class="text_style_6">{{ platform.shortName }}</span>
              <img
                [src]="platformLogoUrl + platform.logo"
                alt="platform-logo"
                width="30%"
                *ngIf="platform.logo"
                class="home_platforms_list_box_card_top_logo"
              />
            </div>
            <div class="home_platforms_list_box_card_bottom">
              <div class="home_platforms_list_box_card_bottom_text">
                <a
                  class="home_platforms_list_box_card_bottom_text_link"
                  [href]="platform.link"
                  target="_blank"
                  ><span class="text_style_7_res">{{
                    platform.platform
                  }}</span></a
                >
              </div>
            </div>
            <div class="home_platforms_list_box_card_link">
              <div class="home_platforms_list_box_card_link_button">
                <div class="home_platforms_list_box_card_link_button_box">
                  <a
                    class="home_platforms_list_box_card_bottom_text_link"
                    [href]="platform.link"
                    target="_blank"
                  >
                    <svg
                      class="home_platforms_list_box_card_bottom_text_link_arrow"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1480_10760)">
                        <path
                          d="M18.7109 0H3.59766C2.88672 0 2.30859 0.578125 2.30859 1.28906C2.30859 2 2.88672 2.57813 3.59766 2.57813H15.5938L0.378906 17.7969C-0.125 18.3008 -0.125 19.1172 0.378906 19.6211C0.882812 20.125 1.69922 20.125 2.20312 19.6211L17.418 4.40234V16.3984C17.418 17.1094 17.9961 17.6875 18.707 17.6875C19.418 17.6875 19.9961 17.1094 19.9961 16.3984V1.28906C20 0.578125 19.4219 0 18.7109 0Z"
                          fill="#303030"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1480_10760">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                </div>
              </div>
            </div>

            <!-- <div class="home_platforms_list_box_card_left">
                            <div class="home_platforms_list_box_card_left_inner">
                            </div>
                        </div>
                        <div class="home_platforms_list_box_card_end">
                            <div class="home_platforms_list_box_card_end_inner">
                            </div>
                        </div> -->
          </div>
          <div class="home_platforms_list_box_smallcard">
            <div class="home_platforms_list_box_smallcard_box">
              <div class="home_platforms_list_box_smallcard_box_top">
                <img
                  [src]="platformLogoUrl + platform.logo"
                  alt="platform-logo"
                  width="30%"
                  *ngIf="platform.logo"
                />
              </div>
              <div class="home_platforms_list_box_smallcard_box_center">
                <span class="text_style_7">{{ platform.platform }}</span>
              </div>
            </div>
            <div class="home_platforms_list_box_smallcard_bottom">
              <div class="home_platforms_list_box_smallcard_bottom_button">
                <a [href]="platform.link" target="_blank">
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 13 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1809_21712)">
                      <path
                        d="M11.4494 0H2.20095C1.7659 0 1.41212 0.353778 1.41212 0.788829C1.41212 1.22388 1.7659 1.57766 2.20095 1.57766H9.54185L0.23127 10.8906C-0.0770901 11.199 -0.0770901 11.6986 0.23127 12.0069C0.539631 12.3153 1.03922 12.3153 1.34758 12.0069L10.6582 2.69397V10.0349C10.6582 10.4699 11.0119 10.8237 11.447 10.8237C11.882 10.8237 12.2358 10.4699 12.2358 10.0349V0.788829C12.2382 0.353778 11.8844 0 11.4494 0Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1809_21712">
                        <rect width="12.2388" height="12.2388" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </div>
            </div>
            <!-- <div class="home_platforms_list_box_smallcard_bottom">
                            <div class="home_platforms_list_box_smallcard_bottom_text">
                                <a class="home_platforms_list_box_smallcard_bottom_text_link" [href]="platform.link" target="_blank"><span class="text_style_7">{{platform.platform}}</span></a>
                            </div>                                                     
                        </div> -->
            <!-- <div class="home_platforms_list_box_smallcard_link">
                            <div class="home_platforms_list_box_smallcard_link_button">
                                <div class="home_platforms_list_box_smallcard_link_button_box">
                                    <a class="home_platforms_list_box_smallcard_bottom_text_link" [href]="platform.link" target="_blank">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_1480_10760)">
                                            <path d="M18.7109 0H3.59766C2.88672 0 2.30859 0.578125 2.30859 1.28906C2.30859 2 2.88672 2.57813 3.59766 2.57813H15.5938L0.378906 17.7969C-0.125 18.3008 -0.125 19.1172 0.378906 19.6211C0.882812 20.125 1.69922 20.125 2.20312 19.6211L17.418 4.40234V16.3984C17.418 17.1094 17.9961 17.6875 18.707 17.6875C19.418 17.6875 19.9961 17.1094 19.9961 16.3984V1.28906C20 0.578125 19.4219 0 18.7109 0Z" fill="#303030"/>
                                            </g>
                                            <defs>
                                            <clipPath id="clip0_1480_10760">
                                            <rect width="20" height="20" fill="white"/>
                                            </clipPath>
                                            </defs>
                                        </svg> 
                                    </a>                                    
                                </div>                                
                            </div>                            
                        </div> -->
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="home_about">
    <div class="home_about_inner">
      <div class="home_about_inner_box">
        <div class="home_about_inner_box_left">
          <div class="home_about_inner_box_left_top">
            <span class="text_style_8">About Us</span>
          </div>
          <div class="home_about_inner_box_left_content">
            <p class="text_style_1">About Us</p>
            <p class="text_style_5" [innerHtml]="aboutusdata[0]?.section_1_title"></p>
            <p class="text_style_9" [innerHtml]="aboutusdata[0]?.section_1_description"></p>
          </div>
        </div>
        <div class="home_about_inner_box_right">
          <div class="home_about_inner_box_right_sec">
            <div class="home_about_inner_box_right_sec_btn" (click)="toggleVideo()">
              <svg
                class="home_about_inner_box_right_sec_btn_play"
                width="64"
                height="64"
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="play-button"
                  d="M32 0C14.3271 0 0 14.3269 0 32C0 49.6731 14.3271 64 32 64C49.6729 64 64 49.6731 64 32C64 14.3269 49.6729 0 32 0ZM40.9232 32.7877L29.4032 39.7874C29.1701 39.9289 28.9051 40 28.64 40C28.3999 40 28.1594 39.9419 27.9418 39.8243C27.484 39.5776 27.2 39.1093 27.2 38.6001V24.6006C27.2 24.0914 27.484 23.6231 27.9418 23.3763C28.3995 23.1282 28.9592 23.1432 29.4032 23.4133L40.9232 30.413C41.344 30.6694 41.6 31.1178 41.6 31.6003C41.6 32.0829 41.344 32.5314 40.9232 32.7877Z"
                  fill="#0032A0"
                />
              </svg>
            </div>
            <div class="home_about_inner_box_right_sec_video">
              <video
                class="home_about_inner_box_right_sec_video_link"
                width="100%"
                height="100%"
                #aboutVideo
                [poster]="aboutusdata[0]?.section_1_thumbnail ? aboutbaseurl + aboutusdata[0]?.section_1_thumbnail : aboutThumbnail"
                [src]="aboutusdata[0]?.section_1_video ? aboutbaseurl + aboutusdata[0]?.section_1_video : ''"
              >
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="home_services">
    <div class="row m-0">
      <div class="home_services_heading">
        <span class="text_style_5">Services</span>
      </div>
    </div>
    <div class="row justify-content-center mx-0">
      <div class="home_services_description">
        <p class="text_style_10">
          We provide tailored support to clients for specific needs in business
          and product development, including regulatory aspects and
          patent-related services.
        </p>
      </div>
    </div>
    <div class="row justify-content-center mx-0">
      <div class="home_services_box">
        <div class="home_services_box_container">
          <ng-container *ngFor="let service of services">
            <div class="home_services_box_container_item">
              <div class="home_services_box_container_item_card">
                <div class="home_services_box_container_item_card_row">
                  <div class="home_services_box_container_item_card_row_icon">
                    <img
                      [src]="serviceLogoUrl + service.logo"
                      alt="logo"
                      *ngIf="service.logo"
                      class="home_services_box_container_item_card_row_icon_logo"
                    />
                  </div>
                </div>
                <div class="home_services_box_container_item_card_row">
                  <p class="text_blue_1">{{ service.name }}</p>
                </div>
                <div class="home_services_box_container_item_card_row">
                  <div
                    class="home_services_box_container_item_card_row_description"
                  >
                    <p class="text_style_9">{{ service.description }}</p>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="home_agropat">
    <div class="home_agropat_heading">
      <span class="text_style_5">AgroPat</span>
    </div>
    <div class="home_agropat_desc">
      <span class="text_black_1"
        >A Crop Protection Active Ingredient (AI) Database</span
      >
    </div>
    <div class="home_agropat_content">
      <div class="home_agropat_content_box">
        <div class="home_agropat_content_box_col">
          <div class="home_agropat_content_box_col_topl">
            <div class="home_agropat_content_box_col_topl_bg1">
              <img
                class="home_agropat_content_box_col_topl_bg1_img"
                src="../../../assets/img/flex1.png"
              />
            </div>
            <div class="home_agropat_content_box_col_topl_desc1">
              <img
                class="home_agropat_content_box_col_topl_desc1_icon"
                src="../../../assets/icons/tick.png"
              />
              <span class="text_style_9"
                >Computed And Experimental Physiochem
              </span>
            </div>
          </div>
          <div class="home_agropat_content_box_col_centerl">
            <div class="home_agropat_content_box_col_centerl_bg1">
              <img
                class="home_agropat_content_box_col_centerl_bg1_img"
                src="../../../assets/img/flex3.png"
              />
            </div>
            <div class="home_agropat_content_box_col_centerl_desc1">
              <div class="home_agropat_content_box_col_centerl_desc1_left">
                <img
                  class="home_agropat_content_box_col_centerl_desc1_left_icon"
                  src="../../../assets/icons/tick.png"
                />
              </div>
              <div class="home_agropat_content_box_col_centerl_desc1_right">
                <span class="text_style_9"
                  >Constraining Patents, e.g. Compound Patent
                </span>
              </div>
            </div>
          </div>
          <div class="home_agropat_content_box_col_bottoml">
            <div class="home_agropat_content_box_col_bottoml_bg1">
              <img
                class="home_agropat_content_box_col_bottoml_bg1_img"
                src="../../../assets/img/flex4.png"
              />
            </div>
            <div class="home_agropat_content_box_col_bottoml_desc1">
              <div class="home_agropat_content_box_col_bottoml_desc1_left">
                <img
                  class="home_agropat_content_box_col_bottoml_desc1_left_icon"
                  src="../../../assets/icons/tick.png"
                />
              </div>
              <div class="home_agropat_content_box_col_bottoml_desc1_right">
                <span class="text_style_9">Synthetic Commercial Routes </span>
              </div>
            </div>
          </div>
        </div>
        <div class="home_agropat_content_box_col">
          <div class="home_agropat_content_box_col_topr">
            <div class="home_agropat_content_box_col_topr">
              <div class="home_agropat_content_box_col_topr_bg1">
                <img
                  class="home_agropat_content_box_col_topr_bg1_img"
                  src="../../../assets/img/flex2.png"
                />
              </div>
              <div class="home_agropat_content_box_col_topr_desc1">
                <img
                  class="home_agropat_content_box_col_topr_desc1_icon"
                  src="../../../assets/icons/tick.png"
                />
                <span class="text_style_9"
                  >New & Existing Active Agrochemical Ingredient
                </span>
              </div>
            </div>
          </div>
          <div class="home_agropat_content_box_col_centerr">
            <div class="home_agropat_content_box_col_centerr_bg1">
              <img
                class="home_agropat_content_box_col_centerr_bg1_img"
                src="../../../assets/img/flex3.png"
              />
            </div>
            <div class="home_agropat_content_box_col_centerr_desc1">
              <div class="home_agropat_content_box_col_centerr_desc1_left">
                <img
                  class="home_agropat_content_box_col_centerr_desc1_left_icon"
                  src="../../../assets/icons/tick.png"
                />
              </div>
              <div class="home_agropat_content_box_col_centerr_desc1_right">
                <span class="text_style_9"
                  >Key Starting Material / Intermediate Information with CAS
                  Number</span
                >
              </div>
            </div>
          </div>
          <div class="home_agropat_content_box_col_bottomr">
            <div class="home_agropat_content_box_col_bottomr_bg1">
              <img
                class="home_agropat_content_box_col_bottomr_bg1_img"
                src="../../../assets/img/flex5.png"
              />
            </div>
            <div class="home_agropat_content_box_col_bottomr_desc1">
              <div class="home_agropat_content_box_col_bottomr_desc1_left">
                <img
                  class="home_agropat_content_box_col_bottomr_desc1_left_icon"
                  src="../../../assets/icons/tick.png"
                />
              </div>
              <div class="home_agropat_content_box_col_bottomr_desc1_right">
                <span class="text_style_9"
                  >Innovator / Developer / Registration Information</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home_agropat_bottom">
      <button class="header_background_transparent border-none">
        <a
          href="https://www.chemrobotics.com/agropat-ultimate/ "
          class="rounded-pill text_white_1 button_blue_1 dis-flex-2 text_decoration_none home_agropat_bottom_btn"
        >
          <span class="button_blue_1_text">View More</span>
          <img
            class="button_blue_1_text_icon"
            src="../../../assets/icons/arrow-right.png"
          />
        </a>
      </button>
    </div>
  </div>
  <div class="home_layout2">
    <div class="home_layout2_heading">
      <span class="text_style_5">AgroPat</span>
    </div>
    <div class="home_layout2_desc">
      <span class="text_style_9"
        >A Crop Protection Active Ingredient (AI) Database</span
      >
    </div>
    <div class="home_layout2_img">
      <img class="image_width3" src="../../../assets/img/agropat_bg.webp" />
    </div>
    <div class="home_layout2_content">
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"
            >Computed And Experimental Physiochem
          </span>
        </div>
      </div>
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"
            >New & Existing Active Agrochemical Ingredient
          </span>
        </div>
      </div>
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"
            >Constraining Patents, e.g. Compound Patent</span
          >
        </div>
      </div>
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"
            >Key Starting Material / Intermediate Information with CAS
            Number</span
          >
        </div>
      </div>
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9">Synthetic Commercial Routes </span>
        </div>
      </div>
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"
            >Innovator / Developer / Registration Information</span
          >
        </div>
      </div>
    </div>
    <div class="home_layout2_button">
      <button type="button" class="header_background_transparent border-none">
        <a
          class="button_blue_1 rounded-pill text_blue_4 text_white_1 text_decoration_none dis-flex-2"
          href="https://www.chemrobotics.com/agropat-ultimate/ "
          ><span>View More </span>
          <img
            class="button_blue_1_text_icon"
            src="../../../assets/icons/arrow-right.png"
        /></a>
      </button>
    </div>
  </div>
  <div class="home_mrl">
    <div class="home_mrl_img">
      <img class="image_width1" src="../../../assets/img/mrl_img.webp" />
    </div>
    <div class="home_mrl_content">
      <div class="home_mrl_content_box">
        <P class="text_style_5">Maximum Residue Levels (or Limits)</P>
        <P class="text_black_1_res"
          >Access MRL Data for most pesticides used on major fruit and vegetable
          export crops and commodities in more than 85 countries</P
        >
        <div class="home_mrl_content_box_list">
          <div class="home_mrl_content_box_list_row text_style_9">
            <div class="home_mrl_content_box_list_row_item">
              <div><img src="../../../assets/icons/tick_icon.png" /></div>
              <div class="p-l-10">
                MRL standard as per authorized agency (USEPA, EU Pesticide &
                FSSI)
              </div>
            </div>
            <div class="home_mrl_content_box_list_row_item">
              <div><img src="../../../assets/icons/tick_icon.png" /></div>
              <div class="p-l-10">
                Covered prescribed crop in different countries
              </div>
            </div>
            <div class="home_mrl_content_box_list_row_item">
              <div><img src="../../../assets/icons/tick_icon.png" /></div>
              <div class="p-l-10">Validity of MRL’s (Expiry)</div>
            </div>
            <div class="home_mrl_content_box_list_row_item">
              <div><img src="../../../assets/icons/tick_icon.png" /></div>
              <div class="p-l-10">
                MRL data displayed with reference citation
              </div>
            </div>
            <div class="home_mrl_content_box_list_row_item">
              <div><img src="../../../assets/icons/tick_icon.png" /></div>
              <div class="p-l-10">Codex Alimentarius MRLs can be accessed</div>
            </div>
          </div>
        </div>
        <div class="home_mrl_content_box_button">
          <a
            type="button"
            class="rounded-pill text_white_1 button_blue_1 dis-flex-2 text_decoration_none home_mrl_content_box_button_view"
            href="https://www.chemrobotics.com/agrochem/mrl-database  "
            ><span> View More </span>
            <img src="../../../assets/icons/arrow-right.png"
          /></a>
        </div>
      </div>
    </div>
  </div>
  <div class="home_layout1">
    <div class="home_layout1_heading">
      <span class="text_style_5">Maximum Residue Levels (or Limits)</span>
    </div>
    <div class="home_layout1_desc">
      <span class="text_style_9"
        >Access MRL Data for most pesticides used on major fruit and vegetable
        export crops and commodities in more than 85 countries</span
      >
    </div>
    <div class="home_layout1_img">
      <img class="image_width2" src="../../../assets/img/mrl_img_small.webp" />
    </div>
    <div class="home_layout1_content bg_yellow">
      <div class="home_layout1_content_list">
        <div class="home_layout1_content_list_row text_black_3_res">
          <div class="home_layout1_content_list_row_item">
            <div><img src="../../../assets/icons/tick_icon.png" /></div>
            <div>
              MRL standard as per authorized agency (USEPA, EU Pesticide & FSSI)
            </div>
          </div>
          <div class="home_layout1_content_list_row_item">
            <div><img src="../../../assets/icons/tick_icon.png" /></div>
            <div>Covered prescribed crop in different countries</div>
          </div>
          <div class="home_layout1_content_list_row_item">
            <div><img src="../../../assets/icons/tick_icon.png" /></div>
            <div>Validity of MRL’s (Expiry)</div>
          </div>
          <div class="home_layout1_content_list_row_item">
            <div><img src="../../../assets/icons/tick_icon.png" /></div>
            <div>MRL data displayed with reference citation</div>
          </div>
          <div class="home_layout1_content_list_row_item">
            <div><img src="../../../assets/icons/tick_icon.png" /></div>
            <div>Codex Alimentarius MRLs can be accessed</div>
          </div>
        </div>
      </div>
      <div class="home_layout1_content_button">
        <button type="button" class="rounded-pill text_white_1 button_blue_1">
          <span>View More </span>
          <img
            class="home_ipd_content_box_button_icon"
            src="../../../assets/icons/arrow-right.png"
          />
        </button>
      </div>
    </div>
  </div>
  <div class="home_techroutes">
    <div class="home_techroutes_heading">
      <p class="text_style_5">Technical Routes</p>
    </div>
    <div class="home_techroutes_desc">
      <p class="text_black_1">
        A Platform Dedicated to Agrochemical, Pharmaceutical, Specialty
        Chemical, Battery Chemicals, Dyes, and LED Chemical etc.
      </p>
    </div>
    <div class="home_techroutes_content">
      <div class="home_techroutes_content_box">
        <div class="home_techroutes_content_box_col">
          <div class="home_techroutes_content_box_col_topl">
            <div class="home_techroutes_content_box_col_topl_bg1">
              <img
                class="home_techroutes_content_box_col_topl_bg1_img"
                src="../../../assets/img/flex1.png"
              />
            </div>
            <div class="home_techroutes_content_box_col_topl_desc1">
              <img
                class="home_techroutes_content_box_col_topl_desc1_icon"
                src="../../../assets/icons/tick.png"
              />
              <span class="text_style_9"
                >Innovator and commercial Synthetic Routes</span
              >
            </div>
          </div>
          <div class="home_techroutes_content_box_col_centerl">
            <div class="home_techroutes_content_box_col_centerl_bg1">
              <img
                class="home_techroutes_content_box_col_centerr_bg1_img"
                src="../../../assets/img/flex3.png"
              />
            </div>
            <div class="home_techroutes_content_box_col_centerl_desc1">
              <div class="home_techroutes_content_box_col_centerl_desc1_left">
                <img
                  class="home_techroutes_content_box_col_centerl_desc1_left_icon"
                  src="../../../assets/icons/tick.png"
                />
              </div>
              <div class="home_techroutes_content_box_col_centerl_desc1_right">
                <span class="text_style_9"
                  >Agrochemical, Pharmaceutical, Specialty Chemical, Battery
                  Chemicals, Dyes, and LED Chemicals Synthetic Routes</span
                >
              </div>
            </div>
          </div>
          <div class="home_techroutes_content_box_col_bottoml">
            <div class="home_techroutes_content_box_col_bottoml_bg1">
              <img
                class="home_techroutes_content_box_col_bottoml_bg1_img"
                src="../../../assets/img/flex4.png"
              />
            </div>
            <div class="home_techroutes_content_box_col_bottoml_desc1">
              <div class="home_techroutes_content_box_col_bottoml_desc1_left">
                <img
                  class="home_techroutes_content_box_col_bottoml_desc1_left_icon"
                  src="../../../assets/icons/tick.png"
                />
              </div>
              <div class="home_techroutes_content_box_col_bottoml_desc1_right">
                <span class="text_style_9">
                  Patent and Non-Patent References
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="home_techroutes_content_box_col">
          <div class="home_techroutes_content_box_col_topr">
            <div class="home_techroutes_content_box_col_topr">
              <div class="home_techroutes_content_box_col_topr_bg1">
                <img
                  class="home_techroutes_content_box_col_topr_bg1_img"
                  src="../../../assets/img/flex2.png"
                />
              </div>
              <div class="home_techroutes_content_box_col_topr_desc1">
                <img
                  class="home_techroutes_content_box_col_topr_desc1_icon"
                  src="../../../assets/icons/tick.png"
                />
                <span class="text_style_9">
                  Intermediate can be searched by their CAS RN., Inchi, Inchikey
                  and IUPAC name etc.</span
                >
              </div>
            </div>
          </div>
          <div class="home_techroutes_content_box_col_centerr">
            <div class="home_techroutes_content_box_col_centerr_bg1">
              <img
                class="home_techroutes_content_box_col_centerr_bg1_img"
                src="../../../assets/img/flex3.png"
              />
            </div>
            <div class="home_techroutes_content_box_col_centerr_desc1">
              <div class="home_techroutes_content_box_col_centerr_desc1_left">
                <img
                  class="home_techroutes_content_box_col_centerr_desc1_left_icon"
                  src="../../../assets/icons/tick.png"
                />
              </div>
              <div class="home_techroutes_content_box_col_centerr_desc1_right">
                <span class="text_style_9">
                  Intermediate Synthetic Routes with Their Application
                  Report</span
                >
              </div>
            </div>
          </div>
          <div class="home_techroutes_content_box_col_bottomr"></div>
        </div>
      </div>
    </div>
    <div class="home_techroutes_bottom">
      <a
        type="button"
        class="rounded-pill text_white_1 button_blue_1 text_decoration_none dis-flex-2"
        href="https://www.chemrobotics.com/agrochem/technical-routes"
        ><span class="button_blue_1_text">View More </span>
        <img
          class="button_blue_1_text_icon"
          src="../../../assets/icons/arrow-right.png"
      /></a>
    </div>
  </div>
  <div class="home_layout2">
    <div class="home_layout2_heading">
      <span class="text_style_5">Technical Routes</span>
    </div>
    <div class="home_layout2_desc">
      <span class="text_style_9"
        >A Platform Dedicated to Agrochemical, Pharmaceutical, Specialty
        Chemical, Battery Chemicals, Dyes, and LED Chemical etc.</span
      >
    </div>
    <div class="home_layout2_img">
      <img
        class="image_width3"
        src="../../../assets/img/technical_routes.webp"
      />
    </div>
    <div class="home_layout2_content">
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"
            >Innovator and commercial Synthetic Routes</span
          >
        </div>
      </div>
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"
            >Agrochemical, Pharmaceutical, Specialty Chemical, Battery
            Chemicals, Dyes, and LED Chemicals Synthetic Routes</span
          >
        </div>
      </div>
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"
            >Intermediate Synthetic Routes with Their Application Report</span
          >
        </div>
      </div>
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9">
            Intermediate can be searched by their CAS RN., Inchi, Inchikey and
            IUPAC name etc.</span
          >
        </div>
      </div>
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"> Patent and Non-Patent References </span>
        </div>
      </div>
    </div>
    <div class="home_layout2_button">
      <button
        type="button"
        class="button_blue_1 rounded-pill text_blue_4 text_white_1"
      >
        <span>View More </span>
        <img
          class="button_blue_1_text_icon"
          src="../../../assets/icons/arrow-right.png"
        />
      </button>
    </div>
  </div>
  <div class="home_techsupp">
    <div class="home_techsupp_content">
      <div class="home_techsupp_content_box">
        <p class="text_white_6_res">ChemiTracker - A Supplier Guide</p>
        <span class="text_white_5_res"
          >A Platform Dedicated To Agrochemical, Pharmaceutical And Fine
          Chemical Industry</span
        >
        <div class="home_techsupp_content_box_list">
          <div class="home_techsupp_content_box_list_row text_white_4_res">
            <div class="home_techsupp_content_box_list_row_item">
              <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
              <div>
                More than 15000 active ingredients with their intermediates
                supplier information
              </div>
            </div>
            <div class="home_techsupp_content_box_list_row_item">
              <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
              <div>
                Information is fully searchable by means of the name of the
                active ingredient, CAS RN. And IUPAC name etc
              </div>
            </div>
            <div class="home_techsupp_content_box_list_row_item">
              <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
              <div>
                Provides continuously updates Supplier with all relevant
                information
              </div>
            </div>
            <div class="home_techsupp_content_box_list_row_item">
              <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
              <div>
                It coverage includes Indian, Chinese, and other countries
                Supplier information
              </div>
            </div>
            <div class="home_techsupp_content_box_list_row_item">
              <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
              <div>
                The platform also discloses the literature reference, e.g.
                patent or non-patent reference
              </div>
            </div>
          </div>
        </div>
        <div class="home_techsupp_content_box_button">
          <a
            type="button"
            class="rounded-pill text_blue_4 button_white_1 dis-flex-2 text_decoration_none"
            href="https://chemitracker.chemrobotics.com/ 
                    "
            ><span>View More </span>
            <img
              class="home_techsupp_content_box_button_icon"
              src="../../../assets/icons/arrow_right_blue.png"
          /></a>
        </div>
      </div>
    </div>
    <div class="home_techsupp_img">
      <img class="image_width1" src="../../../assets/img/tech_suppliers.webp" />
    </div>
  </div>
  <div class="home_layout1">
    <div class="home_layout1_heading">
      <span class="text_style_5">ChemiTracker - A Supplier Guide</span>
    </div>
    <div class="home_layout1_desc">
      <span class="text_style_9"
        >A Platform Dedicated To Agrochemical, Pharmaceutical And Fine Chemical
        Industry</span
      >
    </div>
    <div class="home_layout1_img">
      <img
        class="image_width2"
        src="../../../assets/img/tech_suppliers_small.webp"
      />
    </div>
    <div class="home_layout1_content bg_blue">
      <div class="home_layout1_content_list">
        <div class="home_layout1_content_list_row text_white_4_res">
          <div class="home_layout1_content_list_row_item">
            <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
            <div>
              More than 15000 active ingredients with their intermediates
              supplier information
            </div>
          </div>
          <div class="home_layout1_content_list_row_item">
            <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
            <div>
              Information is fully searchable by means of the name of the active
              ingredient, CAS RN. And IUPAC name etc
            </div>
          </div>
          <div class="home_layout1_content_list_row_item">
            <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
            <div>
              Provides continuously updates Supplier with all relevant
              information
            </div>
          </div>
          <div class="home_layout1_content_list_row_item">
            <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
            <div>
              It coverage includes Indian, Chinese, and other countries Supplier
              information
            </div>
          </div>
          <div class="home_layout1_content_list_row_item">
            <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
            <div>
              The platform also discloses the literature reference, e.g. patent
              or non-patent reference
            </div>
          </div>
        </div>
      </div>
      <div class="home_layout1_content_button">
        <button type="button" class="rounded-pill text_blue_4 button_white_1">
          <span>View More </span>
          <img
            class="home_ipd_content_box_button_icon"
            src="../../../assets/icons/arrow_right_blue.png"
          />
        </button>
      </div>
    </div>
  </div>
  <div class="home_quikpatent">
    <div class="home_quikpatent_heading">
      <span class="text_style_5">QuikPatent - Constraining Patent Guide</span>
    </div>
    <div class="home_quikpatent_desc">
      <span class="text_black_1"
        >A patent intelligence database offers insights into patents within the
        agrochemical segment, focusing on raw materials such as active
        ingredients (technical), formulation, combinations (mixtures), and their
        intermediates. This enables companies to better understand their
        competitors</span
      >
    </div>
    <div class="home_quikpatent_content">
      <div class="home_quikpatent_content_background"></div>
      <div class="home_quikpatent_content_box">
        <div class="home_quikpatent_content_box_top">
          <div class="home_quikpatent_content_box_top_bg1">
            <img
              class="home_quikpatent_content_box_top_bg1_img"
              src="../../../assets/img/flex1.png"
            />
          </div>
          <div class="home_quikpatent_content_box_top_desc1">
            <img
              class="home_quikpatent_content_box_top_desc1_icon"
              src="../../../assets/icons/tick.png"
            />
            <span class="text_style_9 text-wrap"
              >Identification Gray area in Agrochem space
            </span>
          </div>
        </div>
        <div class="home_quikpatent_content_box_top">
          <div class="home_quikpatent_content_box_top_bg2">
            <img
              class="home_quikpatent_content_box_top_bg1_img"
              src="../../../assets/img/flex2.png"
            />
          </div>
          <div class="home_quikpatent_content_box_top_desc2">
            <img
              class="home_quikpatent_content_box_top_desc1_icon"
              src="../../../assets/icons/tick.png"
            />
            <span class="text_style_9"
              >Identification of Constraining Agrochemical Combinations patents
            </span>
          </div>
        </div>
        <div class="home_quikpatent_content_box_center1">
          <div class="home_quikpatent_content_box_center1_box">
            <div class="home_quikpatent_content_box_center1_box_bg1">
              <img
                class="home_quikpatent_content_box_center1_box_bg1_img"
                src="../../../assets/img/flex3.png"
              />
            </div>
            <div class="home_quikpatent_content_box_center1_box_desc1">
              <img
                class="home_quikpatent_content_box_center1_box_desc1_icon"
                src="../../../assets/icons/tick.png"
              />
              <span class="text_style_9"
                >Product launching dates (Generic Constraining Date) for various
                market with SPCs Expiries.</span
              >
            </div>
          </div>
        </div>
        <div class="home_quikpatent_content_box_center2">
          <div class="home_quikpatent_content_box_center2_box">
            <div class="home_quikpatent_content_box_center2_box_bg1">
              <img
                class="home_quikpatent_content_box_center2_box_bg1_img"
                src="../../../assets/img/flex3.png"
              />
            </div>
            <div class="home_quikpatent_content_box_center2_box_desc1">
              <img
                class="home_quikpatent_content_box_center2_box_desc1_icon"
                src="../../../assets/icons/tick.png"
              />
              <span class="text_style_9"
                >Competitor Watch for tracking innovation in Industry
              </span>
            </div>
          </div>
        </div>
        <div></div>
        <div></div>
      </div>
      <div class="home_quikpatent_content_box1">
        <div class="home_quikpatent_content_box1_item">
          <div class="home_quikpatent_content_box1_item_bg1">
            <img
              class="home_quikpatent_content_box1_item_bg1_img"
              src="../../../assets/img/flex3.png"
            />
          </div>
          <div class="home_quikpatent_content_box1_item_desc1">
            <img
              class="home_quikpatent_content_box1_item_desc1_icon"
              src="../../../assets/icons/tick.png"
            />
            <span class="text_style_9"
              >Identification of critical patent including compound,
              Formulation, Combination and Process Patents for product
              launching.
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="home_quikpatent_bottom">
      <a
        type="button"
        class="rounded-pill text_white_1 button_blue_1 dis-flex-2 text_decoration_none"
        href="https://quikpatent.chemrobotics.com/ "
        ><span class="button_blue_1_text">View More </span>
        <img
          class="button_blue_1_text_icon"
          src="../../../assets/icons/arrow-right.png"
      /></a>
    </div>
  </div>
  <div class="home_layout2">
    <div class="home_layout2_heading">
      <span class="text_style_5">QuikPatent - Constraining Patent Guide</span>
    </div>
    <div class="home_layout2_desc">
      <span class="text_style_9"
        >A patent intelligence database offers insights into patents within the
        agrochemical segment, focusing on raw materials such as active
        ingredients (technical), formulation, combinations (mixtures), and their
        intermediates. This enables companies to better understand their
        competitors</span
      >
    </div>
    <div class="home_layout2_img">
      <img class="image_width3" src="../../../assets/img/quikpatent_bg.webp" />
    </div>
    <div class="home_layout2_content">
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"
            >Identification Gray area in Agrochem space
          </span>
        </div>
      </div>
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"
            >Identification of critical patent including compound, Formulation,
            Combination and Process Patents for product launching.</span
          >
        </div>
      </div>
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"
            >Product launching dates (Generic Constraining Date) for various
            market with SPCs Expiries.
          </span>
        </div>
      </div>
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"
            >Competitor Watch for tracking innovation in Industry
          </span>
        </div>
      </div>
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"
            >Identification of Constraining Agrochemical Combinations patents
          </span>
        </div>
      </div>
    </div>
    <div class="home_layout2_button">
      <button
        type="button"
        class="button_blue_1 rounded-pill text_blue_4 text_white_1"
      >
        <span>View More </span>
        <img
          class="button_blue_1_text_icon"
          src="../../../assets/icons/arrow-right.png"
        />
      </button>
    </div>
  </div>

  <div class="home_gapd">
    <div class="home_gapd_img">
      <img
        class="image_width1"
        src="../../../assets/img/global_agro_product.webp"
      />
    </div>
    <div class="home_gapd_content">
      <div class="home_gapd_content_box">
        <p class="text_style_5">Global Agro Product Directory</p>
        <span class="text_black_1_res">
          Global Agro Product Directory is an Agrochemical Product Directory,
          wherein all Approved Agrochemical Products can be Tracked, covering
          more than 60 Countries Globally.
        </span>
        <div class="home_gapd_content_box_list">
          <div class="home_gapd_content_box_list_row text_black_3_res">
            <div class="home_gapd_content_box_list_row_item">
              <div><img src="../../../assets/icons/tick_icon.png" /></div>
              <div>
                Approved Products with All Business as Well as Scientific
                Information
              </div>
            </div>
            <div class="home_gapd_content_box_list_row_item">
              <div><img src="../../../assets/icons/tick_icon.png" /></div>
              <div>
                Technical and Formulation Supplier with Their Contact
                Information
              </div>
            </div>
            <div class="home_gapd_content_box_list_row_item">
              <div><img src="../../../assets/icons/tick_icon.png" /></div>
              <div>
                Label (English Translated Wherever), Factsheet, Monograph
                Documents
              </div>
            </div>
            <div class="home_gapd_content_box_list_row_item">
              <div><img src="../../../assets/icons/tick_icon.png" /></div>
              <div>Product Image as Well as Product Trademark Images</div>
            </div>
            <div class="home_gapd_content_box_list_row_item">
              <div><img src="../../../assets/icons/tick_icon.png" /></div>
              <div>Registered Company with Their Registration Number</div>
            </div>
          </div>
        </div>
        <div class="home_gapd_content_box_button">
          <button
            type="button"
            class="header_background_transparent border-none"
          >
            <a
              class="rounded-pill text_white_1 button_blue_1 dis-flex-2 text_decoration_none"
              href="https://www.chemrobotics.com/agrochem/global-agro-product-directory"
            >
              <span>View More</span>
              <img
                class="home_gapd_content_box_button_icon"
                src="../../../assets/icons/arrow-right.png"
              />
            </a>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="home_layout1">
    <div class="home_layout1_heading">
      <span class="text_style_5">Global Agro Product Directory</span>
    </div>
    <div class="home_layout1_desc">
      <span class="text_style_9">
        Global Agro Product Directory is an Agrochemical Product Directory,
        wherein all Approved Agrochemical Products can be Tracked, covering more
        than 60 Countries Globally.
      </span>
    </div>
    <div class="home_layout1_img">
      <img
        class="image_width2"
        src="../../../assets/img/global_agro_product_small.webp"
      />
    </div>
    <div class="home_layout1_content bg_yellow">
      <div class="home_layout1_content_list">
        <div class="home_layout1_content_list_row text_black_3_res">
          <div class="home_layout1_content_list_row_item">
            <div><img src="../../../assets/icons/tick_icon.png" /></div>
            <div>
              Approved Products with All Business as Well as Scientific
              Information
            </div>
          </div>
          <div class="home_layout1_content_list_row_item">
            <div><img src="../../../assets/icons/tick_icon.png" /></div>
            <div>
              Technical and Formulation Supplier with Their Contact Information
            </div>
          </div>
          <div class="home_layout1_content_list_row_item">
            <div><img src="../../../assets/icons/tick_icon.png" /></div>
            <div>
              Label (English Translated Wherever), Factsheet, Monograph
              Documents
            </div>
          </div>
          <div class="home_layout1_content_list_row_item">
            <div><img src="../../../assets/icons/tick_icon.png" /></div>
            <div>Product Image as Well as Product Trademark Images</div>
          </div>
          <div class="home_layout1_content_list_row_item">
            <div><img src="../../../assets/icons/tick_icon.png" /></div>
            <div>Registered Company with Their Registration Number</div>
          </div>
        </div>
      </div>
      <div class="home_layout1_content_button">
        <button type="button" class="header_background_transparent border-none">
          <a
            class="rounded-pill text_blue_4 button_blue_1 dis-flex-2 text_decoration_none"
            href="https://www.chemrobotics.com/agrochem/global-agro-product-directory"
          >
            <span class="text_white_1">View More</span>
            <img
              class="home_ipd_content_box_button_icon"
              src="../../../assets/icons/arrow-right.png"
            />
          </a>
        </button>
      </div>
    </div>
  </div>

  <div class="home_vetpat">
    <div class="home_vetpat_heading">
      <span class="text_style_5">PharmVetPat®</span>
    </div>
    <div class="home_vetpat_desc">
      <span class="text_black_1"
        >(Pharmaceutical API & Specialty Chemical Database)</span
      >
    </div>
    <div class="home_vetpat_content">
      <div class="home_vetpat_content_box">
        <div class="home_vetpat_content_box_col">
          <div class="home_vetpat_content_box_col_topl">
            <div class="home_vetpat_content_box_col_topl_bg1">
              <img
                class="home_vetpat_content_box_col_topl_bg1_img"
                src="../../../assets/img/flex1.png"
              />
            </div>
            <div class="home_vetpat_content_box_col_topl_desc1">
              <img
                class="home_vetpat_content_box_col_topl_desc1_icon"
                src="../../../assets/icons/tick.png"
              />
              <span class="text_style_9"
                >New & Existing Active Pharmaceutical Ingredient
              </span>
            </div>
          </div>
          <div class="home_vetpat_content_box_col_center1">
            <div class="home_vetpat_content_box_col_center1_bg1">
              <img
                class="home_vetpat_content_box_col_center1_bg1_img"
                src="../../../assets/img/flex3.png"
              />
            </div>
            <div class="home_vetpat_content_box_col_center1_desc1">
              <div class="home_vetpat_content_box_col_center1_desc1_left">
                <img
                  class="home_vetpat_content_box_col_center1_desc1_left_icon"
                  src="../../../assets/icons/tick.png"
                />
              </div>
              <div class="home_vetpat_content_box_col_center1_desc1_right">
                <span class="text_style_9"
                  >Key Starting Material / Intermediate Information with CAS
                  No.</span
                >
              </div>
            </div>
          </div>
          <div class="home_vetpat_content_box_col_center2">
            <div class="home_vetpat_content_box_col_center2_bg1">
              <img
                class="home_vetpat_content_box_col_center2_bg1_img"
                src="../../../assets/img/flex3.png"
              />
            </div>
            <div class="home_vetpat_content_box_col_center2_desc1">
              <div class="home_vetpat_content_box_col_center2_desc1_left">
                <img
                  class="home_vetpat_content_box_col_center2_desc1_left_icon"
                  src="../../../assets/icons/tick.png"
                />
              </div>
              <div class="home_vetpat_content_box_col_center2_desc1_right">
                <span class="text_style_9"
                  >Constraining Patents, e.g. Compound Patent</span
                >
              </div>
            </div>
          </div>
          <div class="home_vetpat_content_box_col_bottoml">
            <div class="home_vetpat_content_box_col_bottoml_bg1">
              <img
                class="home_vetpat_content_box_col_bottoml_bg1_img"
                src="../../../assets/img/flex4.png"
              />
            </div>
            <div class="home_vetpat_content_box_col_bottoml_desc1">
              <div class="home_vetpat_content_box_col_bottoml_desc1_left">
                <img
                  class="home_vetpat_content_box_col_bottoml_desc1_left_icon"
                  src="../../../assets/icons/tick.png"
                />
              </div>
              <div class="home_vetpat_content_box_col_bottoml_desc1_right">
                <span class="text_style_9"
                  >Territory Coverage: USA, Europe, India, Japan, Brazil</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="home_vetpat_content_box_col">
          <div class="home_vetpat_content_box_col_topr">
            <div class="home_vetpat_content_box_col_topr">
              <div class="home_vetpat_content_box_col_topr_bg1">
                <img
                  class="home_vetpat_content_box_col_topr_bg1_img"
                  src="../../../assets/img/flex2.png"
                />
              </div>
              <div class="home_vetpat_content_box_col_topr_desc1">
                <img
                  class="home_vetpat_content_box_col_topr_desc1_icon"
                  src="../../../assets/icons/tick.png"
                />
                <span class="text_style_9"
                  >Computed And Experimental Physiochem</span
                >
              </div>
            </div>
          </div>
          <div class="home_vetpat_content_box_col_center">
            <div class="home_vetpat_content_box_col_center_bg1">
              <img
                class="home_vetpat_content_box_col_center_bg1_img"
                src="../../../assets/img/flex3.png"
              />
            </div>
            <div class="home_vetpat_content_box_col_center_desc1">
              <div class="home_vetpat_content_box_col_center_desc1_left">
                <img
                  class="home_vetpat_content_box_col_center_desc1_left_icon"
                  src="../../../assets/icons/tick.png"
                />
              </div>
              <div class="home_vetpat_content_box_col_center_desc1_right">
                <span class="text_style_9"
                  >Constraining Patents, e.g. Compound Patent
                </span>
              </div>
            </div>
          </div>
          <div class="home_vetpat_content_box_col_bottomr">
            <div class="home_vetpat_content_box_col_bottomr_bg1">
              <img
                class="home_vetpat_content_box_col_bottomr_bg1_img"
                src="../../../assets/img/flex5.png"
              />
            </div>
            <div class="home_vetpat_content_box_col_bottomr_desc1">
              <div class="home_vetpat_content_box_col_bottomr_desc1_left">
                <img
                  class="home_vetpat_content_box_col_bottomr_desc1_left_icon"
                  src="../../../assets/icons/tick.png"
                />
              </div>
              <div class="home_vetpat_content_box_col_bottomr_desc1_right">
                <span class="text_style_9">Synthetic Commercial Routes </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home_vetpat_bottom">
      <a
        type="button"
        class="rounded-pill text_white_1 button_blue_1 dis-flex-2 text_decoration_none"
        href="https://chemroboticspharma.com/pharmVetPat  "
        ><span class="button_blue_1_text">View More </span>
        <img
          class="button_blue_1_text_icon"
          src="../../../assets/icons/arrow-right.png"
      /></a>
    </div>
  </div>
  <div class="home_layout2">
    <div class="home_layout2_heading">
      <span class="text_style_5">PharmVetPat®</span>
    </div>
    <div class="home_layout2_desc">
      <span class="text_style_9"
        >(Pharmaceutical API & Specialty Chemical Database)</span
      >
    </div>
    <div class="home_layout2_img">
      <img class="image_width3" src="../../../assets/img/pharma_vetpat.webp" />
    </div>
    <div class="home_layout2_content">
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"
            >New & Existing Active Pharmaceutical Ingredient
          </span>
        </div>
      </div>
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9">Computed And Experimental Physiochem</span>
        </div>
      </div>
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"
            >Key Starting Material / Intermediate Information with CAS No.</span
          >
        </div>
      </div>
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"
            >Product Identification with CAS No. / Developmental code / EPA
            Codes</span
          >
        </div>
      </div>
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"
            >Constraining Patents, e.g. Compound Patent</span
          >
        </div>
      </div>
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"
            >Territory Coverage: USA, Europe, India, Japan, Brazil</span
          >
        </div>
      </div>
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9">Synthetic Commercial Routes </span>
        </div>
      </div>
    </div>
    <div class="home_layout2_button">
      <button class="header_background_transparent border-none">
        <a
          type="button"
          class="button_blue_1 rounded-pill text_blue_4 text_white_1 dis-flex-2 text_decoration_none"
          href="https://chemroboticspharma.com/pharmVetPat"
          ><span>View More </span>
          <img
            class="button_blue_1_text_icon"
            src="../../../assets/icons/arrow-right.png"
        /></a>
      </button>
    </div>
  </div>
  <!-- <div class="home_xim">
    <div class="home_xim_heading">
      <span class="text_style_5">AgroPharm-XIM Analytics Database</span>
    </div>
    <div class="home_xim_desc">
      <div class="home_xim_desc_box">
        <span class="text_black_1">
          Provides Export and Import Data for Pharmaceuticals and Agrochemicals
          with Their Intermediates.
        </span>
      </div>
    </div>
    <div class="home_xim_content">
      <div class="home_xim_content_box">
        <div class="home_xim_content_box_left">
          <div class="home_xim_content_box_left_bg">
            <img
              class="home_xim_content_box_left_bg_img"
              src="../../../assets/img/flex3.png"
            />
          </div>
          <div class="home_xim_content_box_left_desc">
            <img
              class="home_xim_content_box_left_desc_icon"
              src="../../../assets/icons/tick.png"
            />
            <span class="text_style_9"
              >Trade Data of Active Pharmaceutical Ingredients (API),
              Formulations (FDFs), and Intermediates.</span
            >
          </div>
        </div>
        <div class="home_xim_content_box_right">
          <div class="home_xim_content_box_right_bg">
            <img
              class="home_xim_content_box_right_bg_img"
              src="../../../assets/img/flex3.png"
            />
          </div>
          <div class="home_xim_content_box_right_desc">
            <img
              class="home_xim_content_box_right_desc_icon"
              src="../../../assets/icons/tick.png"
            />
            <span class="text_style_9"
              >Access Buyer, Supplier, Volume, and Pricing Information.</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="home_xim_bottom">
      <button type="button" class="header_background_transparent border-none">
        <a
          class="rounded-pill text_white_1 button_blue_1 dis-flex-2 text_decoration_none"
          href="https://agropharmexim.chemrobotics.com/#/agropharm-xim-beta"
        >
          <span class="button_blue_1_text">View More</span>
          <img
            class="button_blue_1_text_icon"
            src="../../../assets/icons/arrow-right.png"
          />
        </a>
      </button>
    </div>
  </div>
  <div class="home_layout2">
    <div class="home_layout2_heading">
      <span class="text_style_5">AgroPharm-XIM Analytics Database</span>
    </div>
    <div class="home_layout2_desc">
      <span class="text_style_9"
        >Provides Export and Import Data for Pharmaceuticals and Agrochemicals
        with Their Intermediates.</span
      >
    </div>
    <div class="home_layout2_img">
      <img class="image_width3" src="../../../assets/img/xim.webp" />
    </div>
    <div class="home_layout2_content">
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"
            >Trade Data of Active Pharmaceutical Ingredients (API), Formulations
            (FDFs), and Intermediates.</span
          >
        </div>
      </div>
      <div class="home_layout2_content_item">
        <div class="home_layout2_content_item_desc">
          <img
            class="home_layout2_content_item_desc_icon"
            src="../../../assets/icons/tick.png"
          />
          <span class="text_style_9"
            >Access Buyer, Supplier, Volume, and Pricing Information.</span
          >
        </div>
      </div>
    </div>
    <div class="home_layout2_button">
      <button class="header_background_transparent border-none" type="button">
        <a
          class="button_blue_1 rounded-pill text_blue_4 text_white_1 text_decoration_none dis-flex-2"
          href="https://agropharmexim.chemrobotics.com/#/agropharm-xim-beta"
        >
          <span>View More</span>
          <img
            class="button_blue_1_text_icon"
            src="../../../assets/icons/arrow-right.png"
          />
        </a>
      </button>
    </div>
  </div> -->
  <div class="home_ipd">
    <div class="home_ipd_content">
      <div class="home_ipd_content_box">
        <p class="text_white_6_res">Indian Pesticide Database</p>
        <span class="text_white_5_res"
          >IPD which offers pesticide product registration/approval
          information.</span
        >
        <div class="home_ipd_content_box_list">
          <div class="home_ipd_content_box_list_row text_white_4_res">
            <div class="home_ipd_content_box_list_row_item">
              <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
              <div>
                Product Registered under Section 9(3), Section 9(3B), Section
                9(4)
              </div>
            </div>
            <div class="home_ipd_content_box_list_row_item">
              <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
              <div>Registration information of bio-pesticides</div>
            </div>
            <div class="home_ipd_content_box_list_row_item">
              <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
              <div>
                Registration information for Export of existing/new Technical
                and formulations
              </div>
            </div>
            <div class="home_ipd_content_box_list_row_item">
              <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
              <div>
                Endorsement information for transfer of Certificate of
                Registration / address change / company name change
              </div>
            </div>
            <div class="home_ipd_content_box_list_row_item">
              <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
              <div>
                Inclusion information of new molecule/chemical in schedule of
                Insecticides Act, 1968
              </div>
            </div>
          </div>
        </div>
        <div class="home_ipd_content_box_button">
          <button
            type="button"
            class="header_background_transparent border-none"
          >
            <a
              class="rounded-pill text_blue_4 button_white_1 text_decoration_none dis-flex-2"
              href="https://ipd.chemrobotics.com/#/"
            >
              <span>View More</span>
              <img
                class="home_ipd_content_box_button_icon"
                src="../../../assets/icons/arrow_right_blue.png"
              />
            </a>
          </button>
        </div>
      </div>
    </div>
    <div class="home_ipd_img">
      <img class="image_width1" src="../../../assets/img/ipd.webp" />
    </div>
  </div>

  <div class="home_layout1">
    <div class="home_layout1_heading">
      <span class="text_style_5">Indian Pesticide Database</span>
    </div>
    <div class="home_layout1_desc">
      <span class="text_style_9"
        >IPD which offers pesticide product registration/approval
        information.</span
      >
    </div>
    <div class="home_layout1_img">
      <img class="image_width2" src="../../../assets/img/ipd_small.webp" />
    </div>
    <div class="home_layout1_content bg_blue">
      <div class="home_layout1_content_list">
        <div class="home_layout1_content_list_row text_white_4_res">
          <div class="home_layout1_content_list_row_item">
            <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
            <div>
              Product Registered under Section 9(3), Section 9(3B), Section 9(4)
            </div>
          </div>
          <div class="home_layout1_content_list_row_item">
            <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
            <div>Registration information of bio-pesticides</div>
          </div>
          <div class="home_layout1_content_list_row_item">
            <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
            <div>
              Registration information for Export of existing/new Technical and
              formulations
            </div>
          </div>
          <div class="home_layout1_content_list_row_item">
            <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
            <div>
              Endorsement information for transfer of Certificate of
              Registration / address change / company name change
            </div>
          </div>
          <div class="home_layout1_content_list_row_item">
            <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
            <div>
              Inclusion information of new molecule/chemical in schedule of
              Insecticides Act, 1968
            </div>
          </div>
        </div>
      </div>
      <div class="home_layout1_content_button">
        <button type="button" class="header_background_transparent border-none">
          <a
            class="rounded-pill text_blue_4 button_white_1 dis-flex-2 text_decoration_none"
            href="https://ipd.chemrobotics.com/#/"
          >
            <span>View More</span>
            <img
              class="home_ipd_content_box_button_icon"
              src="../../../assets/icons/arrow_right_blue.png"
            />
          </a>
        </button>
      </div>
    </div>
  </div>

  <div class="home_wedo">
    <div class="home_wedo_inner">
      <div class="home_wedo_inner_box">
        <div class="home_wedo_inner_box_left">
          <div class="home_wedo_inner_box_left_top">
            <span class="text_style_8">What We Do?</span>
          </div>
          <div class="home_wedo_inner_box_left_content">
            <p class="text_style_1">What We Do?</p>
            <p class="text_style_5">Chemistry and Innovation Come Together</p>
            <p class="text_style_9">
              Provides Information on New or Existing Active Ingredients,
              Formulations, Combinations, Developers, Innovators, Existing
              Intellectual Property, Regulatory Requirements, Biology Data
              (Including Spectrum, Mechanism of Action, Direction for Use,
              Toxicity, and Safety). This Data Plays a Crucial Role in
              Decision-Making for Research at Individual, Academic, or Industry
              Levels, Aiding in Both Generic and Innovator Product Development
              to Maintain Profitability.
            </p>
          </div>
        </div>
        <div class="home_wedo_inner_box_right">
          <div class="home_wedo_inner_box_right_sec">
            <div class="home_wedo_inner_box_right_sec_btn">
              <svg
                class="home_wedo_inner_box_right_sec_btn_play"
                width="64"
                height="64"
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                (click)="toggleintroVideo()"
              >
                <path
                  d="M32 0C14.3271 0 0 14.3269 0 32C0 49.6731 14.3271 64 32 64C49.6729 64 64 49.6731 64 32C64 14.3269 49.6729 0 32 0ZM40.9232 32.7877L29.4032 39.7874C29.1701 39.9289 28.9051 40 28.64 40C28.3999 40 28.1594 39.9419 27.9418 39.8243C27.484 39.5776 27.2 39.1093 27.2 38.6001V24.6006C27.2 24.0914 27.484 23.6231 27.9418 23.3763C28.3995 23.1282 28.9592 23.1432 29.4032 23.4133L40.9232 30.413C41.344 30.6694 41.6 31.1178 41.6 31.6003C41.6 32.0829 41.344 32.5314 40.9232 32.7877Z"
                  fill="#0032A0"
                />
              </svg>
            </div>
            <div class="home_wedo_inner_box_right_sec_video">
              <video
                class="home_wedo_inner_box_right_sec_video_link"
                width="100%"
                height="100%"
                controls
                #IntroVideo
                [poster]="wedoThumbnail"
              >
                <source [src]="introVideo" type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="home_demo">
    <div class="home_demo_left">
      <div class="home_demo_left_heading text_style_5">
        <span>Call for Demo</span>
      </div>
      <div class="home_demo_left_desc text_black_4_res">
        <span
          >Unlock the Power of Our Product - Schedule a Call for Demo Today!
          Discover How Our Solution Can Revolutionize Your Workflow. Request a
          Demo Now and Take the First Step Towards Streamlining Your
          Processes.</span
        >
      </div>
      <div class="home_demo_left_button">
        <button
          type="button"
          class="rounded-pill text_white_1 button_blue_1"
          (click)="demoRequest()"
        >
          <span class="button_blue_1_text">Submit Details</span>
        </button>
      </div>
    </div>
    <div class="home_demo_right">
      <div class="home_demo_right_box">
        <div class="home_demo_right_box_img1">
          <img src="../../../assets/img/demo1.png" />
        </div>
        <div class="home_demo_right_box_img2">
          <img src="../../../assets/img/demo2.png" />
        </div>
        <div class="home_demo_right_box_img3">
          <img src="../../../assets/img/demo3.png" />
        </div>
        <div class="home_demo_right_box_img4">
          <img src="../../../assets/img/demo4.png" />
        </div>
      </div>
    </div>
    <div class="home_demo_box">
      <div class="home_demo_box_heading text_style_5">
        <span>Call for Demo</span>
      </div>
      <div class="home_demo_box_desc text_style_9">
        <span
          >Unlock the Power of Our Product - Schedule a Call for Demo Today!
          Discover How Our Solution Can Revolutionize Your Workflow. Request a
          Demo Now and Take the First Step Towards Streamlining Your
          Processes.</span
        >
      </div>
      <div class="home_demo_box_button">
        <button type="button" class="rounded-pill text_white_1 button_blue_1">
          <span class="button_blue_1_text">Submit Details</span>
        </button>
      </div>
    </div>
  </div>

  <!-- <div class="home_testimonials">
        <div class="home_testimonials_box">
            <div class="home_testimonials_box_heading">
                <span class="text_style_1">Testimonials</span>
            </div>
            <div class="home_testimonials_box_desc">
                <span class="text_style_5">Let’s see what people say about</span><span class="text_yellow_1"> ChemRobotics</span>
            </div>
            <div class="home_testimonials_box_content">
                <div class="home_testimonials_box_content_layout">
                    <ng-container *ngFor="let testimonial of testimonials">
                        <div>
                            
                        </div>
                    </ng-container>                    
                </div>
            </div>
        </div>        
    </div> -->
  <div class="home_info">
    <div class="home_info_left">
      <img class="home_info_left_img" src="../../../assets/img/info_bg.webp" />
    </div>
    <div class="home_info_right">
      <div class="home_info_right_box">
        <div class="home_info_right_box_ele1">
          <div class="home_info_right_box_ele1_top">
            <div class="home_info_right_box_ele1_top_icon icon_box">
              <svg
                width="53"
                height="38"
                viewBox="0 0 53 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_2044_7357)">
                  <path
                    d="M17.1757 34.64C17.1475 34.922 17.1718 35.2166 17.2744 35.5086C17.5249 36.2125 18.1126 36.7858 18.8089 37.002C19.4559 37.207 20.0996 37.0705 20.2948 36.8577L21.6446 35.4058C22.0352 34.9873 22.1338 34.3183 21.9043 33.6692C21.3396 32.5844 20.5828 32.1929 19.6137 32.0176L17.1757 34.64Z"
                    fill="#0032A0"
                  />
                  <path
                    d="M15.3702 27.3803L13.0112 29.9163C12.5319 30.439 12.3945 31.2423 12.6621 32.0121C12.9461 32.8254 13.624 33.4871 14.4353 33.7342C15.2032 33.9649 15.9738 33.7856 16.4564 33.2709L18.6406 30.9227C19.1231 30.4014 19.2573 29.602 18.9897 28.8322C18.7056 28.015 18.0238 27.3559 17.2164 27.1101C16.5721 26.9038 15.816 26.8959 15.3702 27.3803Z"
                    fill="#0032A0"
                  />
                  <path
                    d="M10.6935 23.2059L8.5153 25.5501C8.03534 26.0688 7.90121 26.8748 8.16618 27.6472C8.45021 28.4579 9.12807 29.1195 9.93941 29.3667C10.706 29.6007 11.4845 29.4181 11.7271 29.1604L14.1453 26.5591C14.6279 26.0365 14.762 25.2331 14.4944 24.4647C14.2091 23.6487 13.5312 22.9897 12.7199 22.7452C11.9737 22.5013 11.1479 22.7182 10.6935 23.2059Z"
                    fill="#0032A0"
                  />
                  <path
                    d="M6.43244 18.585L4.01817 21.1876C3.53558 21.7089 3.40145 22.5084 3.66905 23.2742C3.95045 24.0941 4.63226 24.7531 5.44359 25.0003C6.21022 25.2296 6.98736 25.0517 7.22734 24.7907L9.64819 22.1894V22.1868C10.1308 21.672 10.2649 20.8713 9.99731 20.1028C9.71722 19.283 9.03541 18.6239 8.22408 18.3794C7.60408 18.1652 6.85389 18.1283 6.43244 18.585Z"
                    fill="#0032A0"
                  />
                  <path
                    d="M37.7759 3.06445C36.2144 3.93968 34.044 4.09653 31.9302 4.24877C30.3312 4.35817 28.6816 4.47417 27.4962 4.9131L20.9049 7.35094C20.8602 7.36873 20.8148 7.37928 20.7675 7.38587C20.4493 7.43595 20.1547 7.47879 19.8904 7.5157C18.2855 7.74241 18.1001 7.81161 17.9153 8.28811C17.747 8.72836 17.9318 9.36303 18.3881 9.90213C18.7602 10.345 20.2165 11.7277 23.2127 11.0166L26.9662 10.5197C29.0682 10.2481 30.7533 11.6216 32.0992 12.7301L42.1935 20.8246L42.2014 20.8207C44.1968 19.9837 46.2758 18.8949 48.0431 16.7609L37.7759 3.06445Z"
                    fill="#0032A0"
                  />
                  <path
                    d="M23.8866 2.57252C23.2883 2.62788 22.6025 2.70367 21.8833 2.7788C17.9048 3.20455 15.699 3.37195 14.5767 3.16369L4.24829 16.6394C4.62832 16.9999 4.94325 17.3742 5.19704 17.7795C6.06031 16.8937 7.36475 16.5774 8.63501 16.9623C9.88159 17.3393 10.9224 18.3522 11.3576 19.609C11.5424 20.1409 11.6002 20.6866 11.5529 21.2092C12.0625 21.1374 12.6009 21.167 13.1309 21.3292C14.3742 21.7035 15.4189 22.7191 15.8509 23.9759C16.0382 24.5052 16.0974 25.0495 16.0527 25.5722C16.5623 25.5003 17.1007 25.5306 17.6307 25.6961C18.8713 26.073 19.9115 27.086 20.3467 28.3362C20.6202 29.1291 20.6308 29.945 20.4085 30.6765C20.5354 30.7009 20.6656 30.7319 20.7951 30.7728C21.9082 31.1188 22.8537 32.0355 23.2607 33.1658C23.6486 34.2598 23.4803 35.4092 22.8432 36.2343L24.6756 37.7034C25.124 38.0599 25.7775 38.0988 26.3877 37.8022C27.0491 37.4806 27.5488 36.8275 27.6961 36.0966C27.7579 35.7914 27.7375 35.4955 27.6678 35.2214L25.3436 33.3576C25.0313 33.1065 24.9761 32.6431 25.22 32.3215C25.4665 32.0025 25.9189 31.9432 26.2332 32.1943L29.0275 34.4391C29.3049 34.6618 30.0998 34.7211 30.829 34.3771C31.5956 34.01 32.1748 33.2534 32.3352 32.4092C32.4891 31.6111 32.2425 30.8373 31.6942 30.3945L29.1668 28.3672C28.8519 28.1161 28.7967 27.6515 29.0432 27.3338C29.2872 27.0109 29.7421 26.9516 30.0538 27.2066L33.7278 30.1519C34.2801 30.5922 35.0737 30.6528 35.8067 30.3101C36.5668 29.9456 37.146 29.1904 37.3104 28.3369C37.4643 27.5388 37.2177 26.7677 36.6634 26.3208L32.9881 23.3795C32.6732 23.1258 32.618 22.6624 32.8645 22.3382C33.1111 22.0205 33.5634 21.9652 33.879 22.2156C33.879 22.2156 39.4597 26.6886 39.4637 26.6886C39.7411 26.9074 40.5321 26.9694 41.2579 26.6214C42.0259 26.2622 42.6012 25.5069 42.7682 24.6561C42.9194 23.8566 42.6728 23.0803 42.1212 22.6413L31.1985 13.8792C29.9453 12.8491 28.6507 11.7821 27.1471 11.9845L23.4691 12.4656C20.9897 13.0627 18.6511 12.4722 17.2986 10.8693C16.4834 9.90382 16.2059 8.70962 16.5721 7.74938C17.0856 6.41743 18.0692 6.27969 19.6925 6.05034C19.9351 6.01936 20.1962 5.98114 20.4835 5.93566L27.007 3.52353C27.4311 3.36536 27.9005 3.25595 28.3864 3.15907C26.7092 2.50859 25.4935 2.4697 23.8866 2.57252Z"
                    fill="#FFCD04"
                  />
                  <path
                    d="M9.70998 0.0178932C8.52192 -0.0723971 7.43707 0.825234 5.87555 2.86369L1.88201 8.07812C0.437522 9.95905 -0.103585 11.1289 0.0160768 12.1201C0.112069 12.9347 0.677503 13.7341 1.23834 14.1849L3.13254 15.7014L13.4188 2.28108L12.0874 1.21276C11.1722 0.481208 10.4227 0.0732537 9.70998 0.0178932Z"
                    fill="#FFCD04"
                  />
                  <path
                    d="M42.6945 0.0044164C41.9818 0.049232 41.2257 0.448618 40.3033 1.16962L38.9574 2.2162L49.101 15.7459L50.412 14.7237C51.5462 13.8419 52.1248 13.053 52.2306 12.2391C52.3615 11.2505 51.8375 10.0715 50.416 8.16613L46.4875 2.90162C44.9569 0.842073 43.8859 -0.0720338 42.6945 0.0044164Z"
                    fill="#0032A0"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2044_7357">
                    <rect width="52.25" height="38" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <p class="home_info_right_box_ele1_heading text_blue_1">
            What We Offer
          </p>
          <p class="home_info_right_box_ele1_desc text_style_9">
            We keep pace with industry trends and think as business people. We
            will be counselors, advisors and confidants to Agrochem,
            Pharmaceutical API & Specialty Chemical Industry including Battery
            Chemicals, Dyes, and LED Chemical etc. With our relationships, we
            can liaise with companies for identifying new business
            opportunities, and further R&D product development with regulatory
            and patent support.
          </p>
        </div>
        <div class="home_info_right_box_ele2">
          <div class="home_info_right_box_ele2_content">
            <div class="home_info_right_box_ele2_content_top">
              <div class="home_info_right_box_ele2_content_top_icon icon_box">
                <svg
                  width="38"
                  height="38"
                  viewBox="0 0 38 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_2044_7398)">
                    <path
                      d="M17.7338 2.5332C7.93969 2.5332 0 10.4726 0 20.2664C0 30.0602 7.93969 37.9997 17.7338 37.9997C27.5279 37.9997 35.4677 30.0602 35.4677 20.2664C35.4677 17.8853 34.9973 15.6143 34.1461 13.5401L33.9879 13.6983C33.5744 14.1118 33.0305 14.3701 32.4484 14.428L30.5181 14.6204C31.2817 16.3468 31.7067 18.2567 31.7067 20.2659C31.7067 27.9826 25.4508 34.2383 17.7339 34.2383C10.0169 34.2383 3.7611 27.9826 3.7611 20.2659C3.7611 12.5493 10.0169 6.2938 17.7338 6.2938C19.7424 6.2938 21.6515 6.71841 23.3776 7.48145L23.5699 5.55287C23.628 4.97077 23.8872 4.42623 24.3007 4.01276L24.4592 3.85423C22.385 3.00345 20.1145 2.5332 17.7338 2.5332ZM17.7338 15.1998C18.1872 15.1998 18.6265 15.2597 19.0446 15.3714L15.9417 18.4748C14.9539 19.4626 14.9543 21.0671 15.9404 22.0561C16.4161 22.5332 17.0603 22.7997 17.7338 22.7997C18.4067 22.7997 19.0501 22.5333 19.526 22.0573L22.6286 18.9541C22.7405 19.3727 22.8005 19.8125 22.8005 20.2664C22.8005 23.0646 20.532 25.333 17.7337 25.333C14.9354 25.333 12.6669 23.0646 12.6669 20.2664C12.6671 17.4683 14.9355 15.1998 17.7338 15.1998ZM17.7338 8.82704C19.6771 8.82704 21.5069 9.31228 23.1097 10.1671L22.9836 11.432L21.0091 13.4067C20.0172 12.9323 18.9066 12.6665 17.7338 12.6665C13.5364 12.6665 10.1337 16.069 10.1337 20.2663C10.1337 24.4636 13.5364 27.8662 17.7338 27.8662C21.9313 27.8662 25.3339 24.4636 25.3339 20.2663C25.3339 19.0928 25.0678 17.9816 24.5928 16.9894L26.5678 15.0141L27.8319 14.8881C28.6877 16.4912 29.1732 18.3219 29.1732 20.2659C29.1732 26.5835 24.0516 31.705 17.7338 31.705C11.416 31.705 6.29435 26.5836 6.29435 20.2659C6.29435 13.9483 11.416 8.82704 17.7338 8.82704Z"
                      fill="#0032A0"
                    />
                    <path
                      d="M24.199 12.0082L24.8302 5.67893C24.8601 5.38755 24.9908 5.11606 25.1963 4.90876L29.7343 0.370724C30.0854 0.0218948 30.6046 -0.0931444 31.0677 0.0786723C31.5309 0.249747 31.8558 0.675095 31.8931 1.16739L32.2517 5.74714L36.8345 6.10732C37.3238 6.14614 37.7496 6.46758 37.9214 6.93153C38.0932 7.39532 37.9774 7.91634 37.6301 8.26546L33.092 12.8032C32.8866 13.0106 32.614 13.1389 32.3227 13.1682L25.9918 13.7992L18.6301 21.1623C18.3836 21.4093 18.0586 21.5336 17.7337 21.5336C17.4088 21.5336 17.0838 21.4093 16.8373 21.1623C16.3443 20.6676 16.3443 19.8657 16.8373 19.3709L24.199 12.0082Z"
                      fill="#FFCD04"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2044_7398">
                      <rect width="38" height="38" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
            <p class="home_info_right_box_ele2_content_heading text_blue_1">
              Our Mission
            </p>
            <p class="home_info_right_box_ele2_content_desc text_style_9">
              Achieve global excellence in IP services through consistent
              endeavor and attention to managing knowledge and information, and
              delivering consistently high standards of customer service.
            </p>
          </div>
        </div>
        <div class="home_info_right_box_ele3">
          <div class="home_info_right_box_ele3_content">
            <div class="home_info_right_box_ele3_content_top">
              <div class="home_info_right_box_ele3_content_top_icon icon_box">
                <svg
                  width="38"
                  height="38"
                  viewBox="0 0 38 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_2044_7376)">
                    <path
                      d="M27.7601 17.9423C27.265 13.9026 24.0767 10.7223 20.0357 10.2374C19.6878 10.1977 19.3379 10.1777 18.9877 10.1777C15.4164 10.1832 12.2008 12.3415 10.8428 15.6445C9.48471 18.9474 10.2522 22.7434 12.7868 25.2594C14.1346 26.5501 14.9065 28.3288 14.9285 30.1949V31.2141H23.0713V30.1896C23.0775 28.3589 23.8223 26.6081 25.1369 25.3339C27.1226 23.4181 28.0939 20.6812 27.7601 17.9423Z"
                      fill="#FFCD04"
                    />
                    <path
                      d="M19.0001 37.9997C19.8625 37.9988 20.631 37.4553 20.9195 36.6426H17.0807C17.3691 37.4553 18.1376 37.9988 19.0001 37.9997Z"
                      fill="#FFCD04"
                    />
                    <path
                      d="M15.6072 34.608C15.6077 34.9826 15.9112 35.2861 16.2858 35.2866H21.7143C22.0889 35.2861 22.3924 34.9826 22.3929 34.608V32.5723H15.6072V34.608Z"
                      fill="#FFCD04"
                    />
                    <path
                      d="M19 6.10716C19.7495 6.10716 20.3572 5.49954 20.3572 4.75V1.35716C20.3572 0.607629 19.7495 0 19 0C18.2505 0 17.6428 0.607629 17.6428 1.35716V4.75C17.6428 5.49954 18.2505 6.10716 19 6.10716Z"
                      fill="#0032A0"
                    />
                    <path
                      d="M7.54649 9.46586C8.08354 9.97879 8.92889 9.97879 9.46593 9.46586C9.7205 9.21136 9.86352 8.8661 9.86352 8.50614C9.86352 8.14618 9.7205 7.80091 9.46593 7.54641L7.06666 5.14759C6.81224 4.89302 6.46705 4.75 6.10716 4.75C5.74728 4.75 5.40209 4.89302 5.14759 5.14759C4.89302 5.40201 4.75 5.7472 4.75 6.10716C4.75 6.46713 4.89302 6.81224 5.14759 7.06674L7.54649 9.46586Z"
                      fill="#0032A0"
                    />
                    <path
                      d="M6.10716 18.9997C6.10716 18.2502 5.49954 17.6426 4.75 17.6426H1.35716C0.607926 17.6433 0.000742187 18.2505 0 18.9997C0.000742187 19.749 0.607926 20.3562 1.35716 20.3569H4.75C5.49954 20.3569 6.10716 19.7493 6.10716 18.9997Z"
                      fill="#0032A0"
                    />
                    <path
                      d="M8.8585 28.1808C8.38944 28.0555 7.8892 28.1902 7.54654 28.5342L5.14771 30.9334C4.89314 31.1878 4.75012 31.533 4.75012 31.8929C4.75012 32.2529 4.89314 32.598 5.14771 32.8525C5.68461 33.3654 6.52989 33.3654 7.06679 32.8525L9.46598 30.4537C9.80991 30.111 9.94469 29.6108 9.81934 29.1417C9.69398 28.6727 9.32756 28.3062 8.8585 28.1808Z"
                      fill="#0032A0"
                    />
                    <path
                      d="M30.4535 28.5342C30.1109 28.1902 29.6106 28.0555 29.1416 28.1808C28.6725 28.3062 28.3062 28.6725 28.1808 29.1416C28.0555 29.6106 28.1902 30.1109 28.5342 30.4535L30.9334 32.8524C31.4703 33.3653 32.3155 33.3653 32.8524 32.8524C33.107 32.5979 33.25 32.2527 33.25 31.8928C33.25 31.5328 33.107 31.1877 32.8524 30.9332L30.4535 28.5342Z"
                      fill="#0032A0"
                    />
                    <path
                      d="M36.6428 17.6426H33.25C32.5005 17.6426 31.8928 18.2502 31.8928 18.9997C31.8928 19.7493 32.5005 20.3569 33.25 20.3569H36.6428C37.3924 20.3569 38 19.7493 38 18.9997C38 18.2502 37.3924 17.6426 36.6428 17.6426Z"
                      fill="#0032A0"
                    />
                    <path
                      d="M30.4535 9.46583L32.8523 7.06663C33.1951 6.72382 33.329 6.22418 33.2035 5.75586C33.078 5.28754 32.7122 4.92179 32.2439 4.79628C31.7756 4.67078 31.276 4.80467 30.9331 5.14749L28.5339 7.54631C28.2794 7.80081 28.1364 8.14607 28.1364 8.50603C28.1364 8.86599 28.2794 9.21126 28.5339 9.46576C29.0711 9.97876 29.9165 9.97876 30.4535 9.46583Z"
                      fill="#0032A0"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2044_7376">
                      <rect width="38" height="38" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
            <p class="home_info_right_box_ele3_content_heading text_blue_1">
              Our Vision
            </p>
            <p class="home_info_right_box_ele3_content_desc text_style_9">
              Ambition, dedication and willingness to be outstanding to achieve
              the highest professional standards that will help us in being
              pioneer in the field. These values are percolated throughout the
              organization and is infused across the firm.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer />
<button class="back_to_top" (click)="scrollToTop()" *ngIf="isVisible">
  <img class="back_to_top_img" src="../../../assets/icons/back-to-top.png" />
</button>

<!-- video -->
<div
  class="modal fade modal-lg Video"
  id="VideoModel"
  tabindex="-1"
  role="dialog"
  aria-labelledby="VideoModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog Video_model" role="document">
    <div class="modal-content Video_model_content position-relevant">
      <div class="modal-body Video_model_content_body">
        <button
          type="button"
          class="btn-close position-absolute "
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="closeIntroVideoHome()"
        ></button>
        <video width="100%" height="100%" #introVideoHome controls>
          <source [src]="introVideo" type="video/mp4" />
        </video>
      </div>
    </div>
  </div>
</div>
